import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  printStackTrace18lnx7a39cni as printStackTrace,
  Unit_instance104q5opgivhr8 as Unit_instance,
  CancellationException3b36o9qz53rgr as CancellationException,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  toSet2orjxp16sotqu as toSet,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  addAll21mdhg523wnoa as addAll_0,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz62r1u73vv4y0lk as Duration__hashCode_impl_u4exz6,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toHexString5bhtjxqec7ow as toHexString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  sorted354mfsiv4s7x5 as sorted,
  toString30pk9tzaqopn as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  RuntimeException1r3t0zl97011n as RuntimeException,
  captureStack1fzi4aczwc4hg as captureStack,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  Enum3alwj03lh1n41 as Enum,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  DurationUnit_MICROSECONDS_getInstance2dy62s6vvg5md as DurationUnit_MICROSECONDS_getInstance,
  numberToLong1a4cndvg6c52s as numberToLong,
  toDurationba1nlt78o6vu as toDuration_0,
  mapOf1xd03cq9cnmy8 as mapOf,
  toInt2q8uldh7sc951 as toInt,
  getOrNullef5jbxih7r4f as getOrNull,
  _UByteArray___init__impl__ip4y9nsjfjryamagcs as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv1rti50fc3n28n as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qr9d98aajdmpjx as _UByte___get_data__impl__jof9qr,
  Monotonic_instance19wu6xfdyzm85 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs2ntz2k8jdtq63 as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3idov4hy0gkwd as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  copyOf39s58md6y6rn6 as copyOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  _Char___init__impl__6a9atx35f3p1971c8nj as _Char___init__impl__6a9atx,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  Char__toInt_impl_vasixd1g1ubcha2b2yr as Char__toInt_impl_vasixd,
  toShort36kaw0zjdq3ex as toShort,
  _UByte___init__impl__g9hnc41eipfvebfo5lc as _UByte___init__impl__g9hnc4,
  UBytep4j7r1t64gz1 as UByte,
  UByte__hashCode_impl_mmczcbsrqy0mgq6hwd as UByte__hashCode_impl_mmczcb,
  createThis2j2avj17cvnv2 as createThis,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  fill3lmv1pckd4inv as fill,
  fill34ox8qmmmh3u3 as fill_0,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  _UInt___init__impl__l7qpdl2soskspn8hzmt as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw1vaw6fgw4kwl0 as _UInt___get_data__impl__f0vqqw,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  coerceIn10f36k81le1mm as coerceIn,
  KProperty1ca4yb4wlo496 as KProperty1,
  contentDeepHashCodei0atlwkd11sc as contentDeepHashCode,
  contentDeepEquals38knrynwk1e6k as contentDeepEquals,
  arrayCopytctsywo3h7gj as arrayCopy,
  getOrNull1d60i0672n7ns as getOrNull_0,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
  compareTo3ankvs086tmwq as compareTo,
  boxApply1qmzdb3dh90hg as boxApply,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  println2shhhgwwt4c61 as println,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  Duration__toString_impl_8d916b1f2vqqjkgwgjr as Duration__toString_impl_8d916b,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  filll361lpxnd2bw as fill_1,
  EmptyCoroutineContext_getInstance2bxophqwsfm9n as EmptyCoroutineContext_getInstance,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  SafeContinuation1x0fxyaxo6cwq as SafeContinuation,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspended1qp7gd6asibpv as returnIfSuspended,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz831xktsyjq1qrq as _Result___init__impl__xyqfz8,
  Exceptiondt2hlxn7j7vw as Exception,
  createFailure8paxfkfa5dc7 as createFailure,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  _Result___get_value__impl__bjfvqg1uwg4i093qaqh as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv1ffgeoyqwuzmr as _Result___get_isFailure__impl__jpiriv,
  isNaNymqb93xtq8w8 as isNaN_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _PathInfo___init__impl__vpw96a3g5f537ih73ch as _PathInfo___init__impl__vpw96a,
  get_extensionLCr5nk7cwvpg7s as get_extensionLC,
} from './korlibs-korlibs-io-vfs.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-korlibs-datastructure-core.mjs';
import {
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  get_secondsjblpw5qd4dzj as get_seconds,
  Companion_getInstance3moaeo8p2fvjj as Companion_getInstance_0,
} from './korlibs-korlibs-time-core.mjs';
import {
  get_niceStr3crhxydmlnaoj as get_niceStr,
  extract2vhru1ihy4ogl as extract,
  hasFlagsibfubl68mj8u as hasFlags,
  clamp012a0sd8pj80ati as clamp01,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  convertRangeClamped3njqr0qabe371 as convertRangeClamped,
} from './korlibs-korlibs-math-core.mjs';
import {
  withContext2i47m7ae4v1sd as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  delay1a7xkalnslpld as delay,
  Dispatchers_getInstance1nk2l7rcqz5wi as Dispatchers_getInstance,
  CloseableCoroutineDispatcher1gpuztfef1ucn as CloseableCoroutineDispatcher,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
  Deferred6wjx2us769ee as Deferred,
} from './kotlinx-coroutines-core.mjs';
import {
  readBytesUpTo9uslmwqcrcrn as readBytesUpTo,
  MemorySyncStream1uv927me2xl9s as MemorySyncStream,
  toAsyncc87ncfb6nti7 as toAsync,
  readStream3jngpd9vaczbo as readStream,
  toSyncOrNull2d7etdx5kh7ns as toSyncOrNull,
  readBytesUpTo11h5prrhsqebh as readBytesUpTo_0,
  openSync2m3qn99fqytu0 as openSync,
  readString20u8kjncp0xlx as readString,
  readString2uttbyypy7i6f as readString_0,
  readBytesExactclsk6o5m4pur as readBytesExact,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  readS16LE1wixw67ayq6fo as readS16LE,
  readS32LE1tavmaszt87za as readS32LE,
  readU32LE110qshhyjnggz as readU32LE,
  MemorySyncStreamw5bwb9yy0cam as MemorySyncStream_0,
  writeString1nn4mnpki4ubn as writeString,
  write32LE1grgxk8hx1y6x as write32LE,
  write16LEsn3jmb3i02ek as write16LE,
  writeShortArrayLE6etom8wsvr15 as writeShortArrayLE,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-korlibs-io-stream.mjs';
import {
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  unsupported198cz39rr1ztw as unsupported,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  invalidOp1stebxh2m3n07 as invalidOp,
  Companion_getInstance4j5fpzk5rb8p as Companion_getInstance_1,
  cancel1n0qjc93h2v6w as cancel,
} from './korlibs-korlibs-platform.mjs';
import {
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  binarySearch1lxbagta5e4q4 as binarySearch,
  _BSearchResult___get_nearIndex__impl__s8nq4312kfva7q1s86i as _BSearchResult___get_nearIndex__impl__s8nq43,
  ByteArrayDeque2dezgzzyyl6zm as ByteArrayDeque,
  ShortArrayDeque13dn2tr6asm80 as ShortArrayDeque,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-korlibs-datastructure.mjs';
import {
  _UByteArrayInt___init__impl__xif7bu3pdjaoxauimyc as _UByteArrayInt___init__impl__xif7bu,
  _UByteArrayInt___get_bytes__impl__pj0ilc35thhu7ilpebp as _UByteArrayInt___get_bytes__impl__pj0ilc,
  UByteArrayInt__get_impl_px6q8a12ofefwxigfcv as UByteArrayInt__get_impl_px6q8a,
  getU83agrw8yj0shar as getU8,
  indexOf1wbggs5i7ilsw as indexOf,
  _UByteArrayInt___init__impl__xif7bu25jm4ej5ne9qt as _UByteArrayInt___init__impl__xif7bu_0,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  _UByteArrayInt___init__impl__xif7bu2cberlddfaqn1 as _UByteArrayInt___init__impl__xif7bu_1,
  UByteArrayInt__set_impl_gn45322e8gdcoopwt46 as UByteArrayInt__set_impl_gn4532,
  arraycopy52dxe7vhzf14 as arraycopy,
  arraycopy3n78tfzvkl4kg as arraycopy_0,
  UByteArrayInt__set_impl_gn45321uqwn40obuupa as UByteArrayInt__set_impl_gn4532_0,
  UByteArrayInt__fill$default_impl_mdydxi110rk9jgqoolh as UByteArrayInt__fill$default_impl_mdydxi,
  getS16LE39jsuv9u9gi4y as getS16LE,
  getS24LE1b229asvs5i3l as getS24LE,
  getSampled29kg0naf1rerj as getSampled,
} from './korlibs-korlibs-memory.mjs';
import {
  Charsets_instancenv17fp98ne59 as Charsets_instance,
  readStringzinkjpjt71hyo as readStringz,
} from './korlibs-korlibs-string.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
import { Companion_getInstance2175iaprojxbf as Companion_getInstance_2 } from './korlibs-korlibs-math-vector.mjs';
import {
  onCancelfhzfwe2m4dn1 as onCancel,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  createSingleThreadedDispatcher1tpb6ticji881 as createSingleThreadedDispatcher,
} from './korlibs-korlibs-concurrent.mjs';
import {
  Level_WARN_getInstancejrnwzyc079xb as Level_WARN_getInstance,
  Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance,
  Companion_getInstance1lqql7kjbk545 as Companion_getInstance_3,
  Level_ERROR_getInstance3sgixyayx9gy9 as Level_ERROR_getInstance,
} from './korlibs-korlibs-logger.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  x7i(formats) {
    return (new AudioFormats()).b7j(formats.slice());
  }
}
class AudioFormat {
  constructor(exts) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.AudioFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.f(tmp$ret$3);
    }
    tmp.c7j_1 = toSet(destination);
  }
  h7j() {
    return this.c7j_1;
  }
  d7j(data, props, $completion) {
    return null;
  }
  i7j(data, props, $completion) {
    return null;
  }
  g7j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStream__ydjika(this, data, props, $completion), $completion);
  }
  j7j(data, out, filename, props, $completion) {
    unsupported();
  }
  k7j(data, out, filename, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_6().c7k_1 : props;
    return $super === VOID ? this.j7j(data, out, filename, props, $completion) : $super.j7j.call(this, data, out, filename, props, $completion);
  }
  l7j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamOrError__s0emn1(this, data, props, $completion), $completion);
  }
  m7j(data, filename, format, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_encodeToByteArray__x1kcl0(this, data, filename, format, props, $completion), $completion);
  }
  n7j(data, filename, format, props, $completion, $super) {
    filename = filename === VOID ? 'out.wav' : filename;
    format = format === VOID ? this : format;
    props = props === VOID ? Companion_getInstance_6().c7k_1 : props;
    return $super === VOID ? this.m7j(data, filename, format, props, $completion) : $super.m7j.call(this, data, filename, format, props, $completion);
  }
  w3() {
    return 'AudioFormat';
  }
  toString() {
    return this.w3() + '(' + toString(sorted(this.h7j())) + ')';
  }
}
class AudioFormats extends AudioFormat {
  constructor() {
    super([]);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.z7i_1 = ArrayList.m1();
    this.a7j_1 = null;
  }
  h7j() {
    if (this.a7j_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.z7i_1;
      var destination = ArrayList.m1();
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.audio.format.AudioFormats.<get-extensions>.<anonymous>' call
        var list = element.h7j();
        addAll(destination, list);
      }
      tmp.a7j_1 = toSet(destination);
    }
    return ensureNotNull(this.a7j_1);
  }
  b7j(formats) {
    // Inline function 'kotlin.apply' call
    var this_0 = invalidate(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.AudioFormats.register.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this_0.z7i_1;
    addAll_0(this_1, formats);
    return this_0;
  }
  d7j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh(this, data, props, $completion), $completion);
  }
  i7j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamInternal__hls877(this, data, props, $completion), $completion);
  }
  j7j(data, out, filename, props, $completion) {
    var ext = get_extensionLC(_PathInfo___init__impl__vpw96a(filename));
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.z7i_1.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.audio.format.AudioFormats.encode.<anonymous>' call
        if (element.h7j().f3(ext)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw UnsupportedOperationException.ua("Don't know how to generate file for extension '" + ext + "'");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var format = tmp;
    return format.k7j(data, out, filename, VOID, $completion);
  }
}
class Info {
  constructor(duration, channels, decodingTime) {
    var tmp;
    if (duration === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = duration;
    }
    duration = tmp;
    channels = channels === VOID ? 2 : channels;
    decodingTime = decodingTime === VOID ? null : decodingTime;
    this.o7j_1 = new Mixin();
    this.p7j_1 = duration;
    this.q7j_1 = channels;
    this.r7j_1 = decodingTime;
  }
  n13(_set____db54di) {
    this.o7j_1.n13(_set____db54di);
  }
  o13() {
    return this.o7j_1.o13();
  }
  s7j() {
    var tmp0_elvis_lhs = this.p7j_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'Info(duration=' + get_niceStr(get_milliseconds(this.s7j())) + 'ms, channels=' + this.q7j_1 + ')';
  }
  hashCode() {
    var tmp;
    var tmp_0 = this.p7j_1;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      tmp = 0;
    } else {
      tmp = Duration__hashCode_impl_u4exz6(this.p7j_1);
    }
    var result = tmp;
    result = imul(result, 31) + this.q7j_1 | 0;
    var tmp_1 = imul(result, 31);
    var tmp_2;
    var tmp_3 = this.r7j_1;
    if ((tmp_3 == null ? null : new Duration(tmp_3)) == null) {
      tmp_2 = 0;
    } else {
      tmp_2 = Duration__hashCode_impl_u4exz6(this.r7j_1);
    }
    result = tmp_1 + tmp_2 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    var tmp = this.p7j_1;
    var tmp_0 = tmp == null ? null : new Duration(tmp);
    var tmp_1 = tmp0_other_with_cast.p7j_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Duration(tmp_1)))
      return false;
    if (!(this.q7j_1 === tmp0_other_with_cast.q7j_1))
      return false;
    var tmp_2 = this.r7j_1;
    var tmp_3 = tmp_2 == null ? null : new Duration(tmp_2);
    var tmp_4 = tmp0_other_with_cast.r7j_1;
    if (!equals(tmp_3, tmp_4 == null ? null : new Duration(tmp_4)))
      return false;
    return true;
  }
}
class AudioFormat$decodeStream$slambda {
  constructor(this$0, $data, $props) {
    this.z7j_1 = this$0;
    this.a7k_1 = $data;
    this.b7k_1 = $props;
  }
  o1s($this$withContext, $completion) {
    return this.z7j_1.i7j(this.a7k_1, this.b7k_1, $completion);
  }
  qe(p1, $completion) {
    return this.o1s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.e7j_1 = new AudioDecodingProps();
    this.f7j_1 = new AudioDecodingProps(false, false);
  }
}
class AudioDecodingProps {
  constructor(exactTimings, readInMemory, formats, maxSamples, dispatcher) {
    Companion_getInstance_5();
    exactTimings = exactTimings === VOID ? null : exactTimings;
    readInMemory = readInMemory === VOID ? true : readInMemory;
    formats = formats === VOID ? null : formats;
    maxSamples = maxSamples === VOID ? 39690000 : maxSamples;
    dispatcher = dispatcher === VOID ? null : dispatcher;
    this.t7j_1 = new Mixin();
    this.u7j_1 = exactTimings;
    this.v7j_1 = readInMemory;
    this.w7j_1 = formats;
    this.x7j_1 = maxSamples;
    this.y7j_1 = dispatcher;
  }
  n13(_set____db54di) {
    this.t7j_1.n13(_set____db54di);
  }
  o13() {
    return this.t7j_1.o13();
  }
  toString() {
    return 'AudioDecodingProps(exactTimings=' + this.u7j_1 + ', readInMemory=' + this.v7j_1 + ', formats=' + toString_0(this.w7j_1) + ', maxSamples=' + this.x7j_1 + ', dispatcher=' + toString_0(this.y7j_1) + ')';
  }
  hashCode() {
    var result = this.u7j_1 == null ? 0 : getBooleanHashCode(this.u7j_1);
    result = imul(result, 31) + getBooleanHashCode(this.v7j_1) | 0;
    result = imul(result, 31) + (this.w7j_1 == null ? 0 : hashCode(this.w7j_1)) | 0;
    result = imul(result, 31) + this.x7j_1 | 0;
    result = imul(result, 31) + (this.y7j_1 == null ? 0 : hashCode(this.y7j_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AudioDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof AudioDecodingProps ? other : THROW_CCE();
    if (!(this.u7j_1 == tmp0_other_with_cast.u7j_1))
      return false;
    if (!(this.v7j_1 === tmp0_other_with_cast.v7j_1))
      return false;
    if (!equals(this.w7j_1, tmp0_other_with_cast.w7j_1))
      return false;
    if (!(this.x7j_1 === tmp0_other_with_cast.x7j_1))
      return false;
    if (!equals(this.y7j_1, tmp0_other_with_cast.y7j_1))
      return false;
    return true;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_2 = this;
    this.c7k_1 = new AudioEncodingProps();
  }
}
class AudioEncodingProps {
  constructor(quality, filename) {
    Companion_getInstance_6();
    quality = quality === VOID ? 0.84 : quality;
    filename = filename === VOID ? null : filename;
    this.d7k_1 = new Mixin();
    this.e7k_1 = quality;
    this.f7k_1 = filename;
  }
  n13(_set____db54di) {
    this.d7k_1.n13(_set____db54di);
  }
  o13() {
    return this.d7k_1.o13();
  }
  toString() {
    return 'AudioEncodingProps(quality=' + this.e7k_1 + ', filename=' + this.f7k_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.e7k_1);
    result = imul(result, 31) + (this.f7k_1 == null ? 0 : getStringHashCode(this.f7k_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AudioEncodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof AudioEncodingProps ? other : THROW_CCE();
    if (!equals(this.e7k_1, tmp0_other_with_cast.e7k_1))
      return false;
    if (!(this.f7k_1 == tmp0_other_with_cast.f7k_1))
      return false;
    return true;
  }
}
class InvalidAudioFormatException extends RuntimeException {
  static j7k(message) {
    var $this = this.db(message);
    captureStack($this, $this.i7k_1);
    return $this;
  }
}
class MP3Base extends AudioFormat {
  constructor() {
    super(['mp3']);
  }
  d7j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh_0(this, data, props, $completion), $completion);
  }
}
class MP3 extends MP3Base {
  constructor() {
    Companion_getInstance_7();
    super();
  }
}
class Companion_2 extends MP3 {
  constructor() {
    Companion_instance_3 = null;
    super();
    Companion_instance_3 = this;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.n7k_1, item);
      destination.f(tmp$ret$0);
    }
    tmp.p7k_1 = toMap(destination);
  }
}
class ChannelMode extends Enum {
  constructor(name, ordinal, id, channels) {
    super(name, ordinal);
    this.n7k_1 = id;
    this.o7k_1 = channels;
  }
}
class Mp3Info {
  constructor(version, layer, bitrate, samplingRate, channelMode, frameSize, samples) {
    this.q7k_1 = version;
    this.r7k_1 = layer;
    this.s7k_1 = bitrate;
    this.t7k_1 = samplingRate;
    this.u7k_1 = channelMode;
    this.v7k_1 = frameSize;
    this.w7k_1 = samples;
  }
  toString() {
    return 'Mp3Info(version=' + this.q7k_1 + ', layer=' + this.r7k_1 + ', bitrate=' + this.s7k_1 + ', samplingRate=' + this.t7k_1 + ', channelMode=' + this.u7k_1.toString() + ', frameSize=' + this.v7k_1 + ', samples=' + this.w7k_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.q7k_1);
    result = imul(result, 31) + this.r7k_1 | 0;
    result = imul(result, 31) + this.s7k_1 | 0;
    result = imul(result, 31) + this.t7k_1 | 0;
    result = imul(result, 31) + this.u7k_1.hashCode() | 0;
    result = imul(result, 31) + this.v7k_1 | 0;
    result = imul(result, 31) + this.w7k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Mp3Info))
      return false;
    var tmp0_other_with_cast = other instanceof Mp3Info ? other : THROW_CCE();
    if (!(this.q7k_1 === tmp0_other_with_cast.q7k_1))
      return false;
    if (!(this.r7k_1 === tmp0_other_with_cast.r7k_1))
      return false;
    if (!(this.s7k_1 === tmp0_other_with_cast.s7k_1))
      return false;
    if (!(this.t7k_1 === tmp0_other_with_cast.t7k_1))
      return false;
    if (!this.u7k_1.equals(tmp0_other_with_cast.u7k_1))
      return false;
    if (!(this.v7k_1 === tmp0_other_with_cast.v7k_1))
      return false;
    if (!(this.w7k_1 === tmp0_other_with_cast.w7k_1))
      return false;
    return true;
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a7l_1 = ['2.5', 'x', '2', '1'];
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.b7l_1 = new Int32Array([-1, 3, 2, 1]);
    var tmp_1 = this;
    var tmp_2 = this.g7l(1, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$4 = new Int32Array([0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448]);
    var tmp_3 = to(tmp_2, tmp$ret$4);
    var tmp_4 = this.g7l(1, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$5 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384]);
    var tmp_5 = to(tmp_4, tmp$ret$5);
    var tmp_6 = this.g7l(1, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$6 = new Int32Array([0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]);
    var tmp_7 = to(tmp_6, tmp$ret$6);
    var tmp_8 = this.g7l(2, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$7 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256]);
    var tmp_9 = to(tmp_8, tmp$ret$7);
    var tmp_10 = this.g7l(2, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$8 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    var tmp_11 = to(tmp_10, tmp$ret$8);
    var tmp_12 = this.g7l(2, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$9 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    tmp_1.c7l_1 = mapOf([tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, to(tmp_12, tmp$ret$9)]);
    var tmp_13 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$10 = new Int32Array([44100, 48000, 32000]);
    var tmp_14 = to('1', tmp$ret$10);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$11 = new Int32Array([22050, 24000, 16000]);
    var tmp_15 = to('2', tmp$ret$11);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$12 = new Int32Array([11025, 12000, 8000]);
    tmp_13.d7l_1 = mapOf([tmp_14, tmp_15, to('2.5', tmp$ret$12)]);
    this.e7l_1 = mapOf([to(1, mapOf([to(1, 384), to(2, 1152), to(3, 1152)])), to(2, mapOf([to(1, 384), to(2, 1152), to(3, 576)]))]);
  }
  g7l(version, layer) {
    return imul(version, 10) + layer | 0;
  }
  f7l(f4) {
    var b0 = UByteArrayInt__get_impl_px6q8a(f4, 0);
    var b1 = UByteArrayInt__get_impl_px6q8a(f4, 1);
    var b2 = UByteArrayInt__get_impl_px6q8a(f4, 2);
    var b3 = UByteArrayInt__get_impl_px6q8a(f4, 3);
    if (!(b0 === 255)) {
      get_invalidOp();
    }
    var version = this.a7l_1[extract(b1, 3, 2)];
    var simple_version = version === '2.5' ? 2 : toInt(version);
    var layer = this.b7l_1[extract(b1, 1, 2)];
    var protection_bit = extract(b1, 0, 1);
    var bitrate_key = this.g7l(simple_version, layer);
    var bitrate_idx = extract(b2, 4, 4);
    var tmp6_safe_receiver = this.c7l_1.k3(bitrate_key);
    var tmp0_elvis_lhs = tmp6_safe_receiver == null ? null : getOrNull(tmp6_safe_receiver, bitrate_idx);
    var bitrate = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp7_safe_receiver = this.d7l_1.k3(version);
    var tmp1_elvis_lhs = tmp7_safe_receiver == null ? null : getOrNull(tmp7_safe_receiver, extract(b2, 2, 2));
    var sample_rate = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var padding_bit = extract(b2, 1, 1);
    var private_bit = extract(b2, 0, 1);
    var channelMode = ensureNotNull(Companion_getInstance_8().p7k_1.k3(extract(b3, 6, 2)));
    var mode_extension_bits = extract(b3, 4, 2);
    var copyright_bit = extract(b3, 3, 1);
    var original_bit = extract(b3, 2, 1);
    var emphasis = extract(b3, 0, 2);
    var tmp = framesize(this, layer, bitrate, sample_rate, padding_bit);
    var tmp8_safe_receiver = this.e7l_1.k3(simple_version);
    var tmp2_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.k3(layer);
    return new Mp3Info(version, layer, bitrate, sample_rate, channelMode, tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
  }
}
class SeekingTable {
  constructor(microseconds, filePositions, rate) {
    rate = rate === VOID ? 44100 : rate;
    this.j7l_1 = microseconds;
    this.k7l_1 = filePositions;
    this.l7l_1 = rate;
  }
  m7l() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = this.j7l_1.i1(this.j7l_1.j1() - 1 | 0);
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  n7l() {
    return numberToLong(get_seconds(this.m7l()) * this.l7l_1);
  }
  o7l(time) {
    // Inline function 'korlibs.time.microseconds' call
    var searchMicro = _Duration___get_inWholeNanoseconds__impl__r5x4mr(time).t4() / 1000.0;
    var result = binarySearch(this.j7l_1, searchMicro);
    return numberToLong(this.k7l_1.i1(_BSearchResult___get_nearIndex__impl__s8nq43(result)));
  }
  p7l(sample) {
    // Inline function 'korlibs.time.seconds' call
    var this_0 = sample.t4() / this.l7l_1;
    var tmp$ret$0 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
    return this.o7l(tmp$ret$0);
  }
}
class Parser {
  constructor(data, dataLength) {
    Companion_getInstance_9();
    this.x7k_1 = data;
    this.y7k_1 = dataLength;
    this.z7k_1 = null;
  }
  i7l($completion) {
    return _getDuration$default(this, true, VOID, $completion);
  }
  h7l($completion) {
    return _getDuration$default(this, false, VOID, $completion);
  }
  q7l(rate, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getSeekingTable__ywx4sa(this, rate, $completion), $completion);
  }
}
class MP3Decoder extends AudioFormat {
  constructor() {
    Companion_getInstance_10();
    super(['mp3']);
    this.s7l_1 = Minimp3AudioFormat_getInstance();
  }
  d7j(data, props, $completion) {
    return this.s7l_1.d7j(data, props, $completion);
  }
  i7j(data, props, $completion) {
    return this.s7l_1.g7j(data, props, $completion);
  }
  toString() {
    return 'NativeMp3DecoderFormat';
  }
}
class Companion_5 extends MP3Decoder {
  constructor() {
    Companion_instance_6 = null;
    super();
    Companion_instance_6 = this;
  }
}
class MiniMp3Program {
  constructor() {
    Companion_getInstance_12();
    this.m7m_1 = new Int32Array(3);
    this.n7m_1 = new Float32Array(9);
    this.o7m_1 = new Float32Array(9);
    this.p7m_1 = new Float32Array(4);
    this.q7m_1 = new Float32Array(4);
    this.r7m_1 = Mp3Scratch.p7s();
    this.s7m_1 = new Bs();
  }
  s7n(dst, src, size) {
    arraycopy(src.x7s_1, src.y7s_1, dst.x7s_1, dst.y7s_1, size);
  }
  t7n(dst, src, size) {
    arraycopy_0(src.t7s_1, src.u7s_1, dst.t7s_1, dst.u7s_1, size);
  }
  u7n(bs, data, bytes) {
    bs.e7s_1 = data;
    bs.f7s_1 = 0;
    bs.g7s_1 = imul(bytes, 8);
  }
  v7n(bs, n) {
    var cache = 0;
    var s = bs.f7s_1 & 7;
    var shl = n + s | 0;
    var p = bs.e7s_1.s7s(bs.f7s_1 >>> 3 | 0);
    bs.f7s_1 = bs.f7s_1 + n | 0;
    if (bs.f7s_1 > bs.g7s_1)
      return 0;
    var next = p.b2() & (255 >>> s | 0);
    p = p.g4();
    $l$loop: while (true) {
      shl = shl - 8 | 0;
      if (shl <= 0)
        break $l$loop;
      cache = cache | next << shl;
      next = p.b2();
      p = p.g4();
    }
    return cache | (next >>> (-shl | 0) | 0);
  }
  w7n(h) {
    var h0 = h.i1(0);
    var h1 = h.i1(1);
    var h2 = h.i1(2);
    return h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226) && !((h1 >> 1 & 3) === 0) && !(h2 >> 4 === 15) && !((h2 >> 2 & 3) === 3);
  }
  x7n(h1, h2) {
    return toInt_0(this.w7n(h2) && ((h1.i1(1) ^ h2.i1(1)) & 254) === 0 && ((h1.i1(2) ^ h2.i1(2)) & 12) === 0 && (toInt_0((h1.i1(2) & 240) === 0, this) ^ toInt_0((h2.i1(2) & 240) === 0, this)) === 0, this);
  }
  y7n(h) {
    return imul(2, UByteArrayInt__get_impl_px6q8a(Companion_getInstance_12().h7r_1[toInt_0(!((h.i1(1) & 8) === 0), this)][(h.i1(1) >> 1 & 3) - 1 | 0].n10_1, h.i1(2) >> 4));
  }
  z7n(h) {
    var g_hz = Companion_getInstance_12().g7r_1;
    return g_hz[h.i1(2) >> 2 & 3] >> toInt_0((h.i1(1) & 8) === 0, this) >> toInt_0((h.i1(1) & 16) === 0, this);
  }
  a7o(h) {
    return (h.i1(1) & 6) === 6 ? 384 : 1152 >> toInt_0((h.i1(1) & 14) === 2, this);
  }
  b7o(h, free_format_size) {
    var frame_bytes = imul(imul(this.a7o(h), this.y7n(h)), 125) / this.z7n(h) | 0;
    if ((h.i1(1) & 6) === 6) {
      frame_bytes = frame_bytes & -4;
    }
    return !(frame_bytes === 0) ? frame_bytes : free_format_size;
  }
  c7o(h) {
    return !((h.i1(2) & 2) === 0) ? (h.i1(1) & 6) === 6 ? 4 : 1 : 0;
  }
  d7o(hdr, sci) {
    var alloc = Companion_getInstance_12().v7r_1;
    var mode = hdr.i1(3) >> 6 & 3;
    var nbands;
    var stereo_bands;
    switch (mode) {
      case 3:
        stereo_bands = 0;
        break;
      case 1:
        stereo_bands = ((hdr.i1(3) >> 4 & 3) << 2) + 4 | 0;
        break;
      default:
        stereo_bands = 32;
        break;
    }
    if ((hdr.i1(1) & 6) === 6) {
      alloc = Companion_getInstance_12().v7r_1;
      nbands = 32;
    } else if ((hdr.i1(1) & 8) === 0) {
      alloc = Companion_getInstance_12().w7r_1;
      nbands = 30;
    } else {
      var sample_rate_idx = hdr.i1(2) >> 2 & 3;
      var kbps = this.y7n(hdr) >> toInt_0(!(mode === 3), this);
      if (kbps === 0)
        kbps = 192;
      alloc = Companion_getInstance_12().x7r_1;
      nbands = 27;
      if (kbps < 56) {
        alloc = Companion_getInstance_12().y7r_1;
        nbands = sample_rate_idx === 2 ? 12 : 8;
      } else if (kbps >= 96 && !(sample_rate_idx === 1)) {
        nbands = 30;
      }
    }
    sci.x7t_1 = nbands;
    sci.y7t_1 = stereo_bands > nbands ? nbands : stereo_bands;
    return alloc;
  }
  e7o(bs, pba, scfcod, bands, scf) {
    var scfOffset = 0;
    var g_deq_L12 = Companion_getInstance_12().f7r_1;
    var inductionVariable = 0;
    if (inductionVariable < bands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var s = 0.0;
        var ba = UByteArrayInt__get_impl_px6q8a(pba, i);
        var mask = !(ba === 0) ? 4 + (19 >> UByteArrayInt__get_impl_px6q8a(scfcod, i) & 3) | 0 : 0;
        var m = 4;
        while (!(m === 0)) {
          if (!((mask & m) === 0)) {
            var b = this.v7n(bs, 6);
            s = g_deq_L12[(imul(ba, 3) - 6 | 0) + (b % 3 | 0) | 0] * (2097152 >> (b / 3 | 0));
          }
          scf.a7t(scfOffset, s);
          m = m >> 1;
          scfOffset = scfOffset + 1 | 0;
        }
      }
       while (inductionVariable < bands);
  }
  f7o(hdr, bs, sci) {
    var g_bitalloc_code_tab = new UByteArrayIntPtr(Companion_getInstance_12().q7r_1);
    var subband_alloc = this.d7o(hdr, sci);
    var subband_alloc_n = 0;
    var k = 0;
    var ba_bits = 0;
    var ba_code_tab = g_bitalloc_code_tab;
    var inductionVariable = 0;
    var last = sci.x7t_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ba = 0;
        if (i === k) {
          var tmp = k;
          // Inline function 'kotlin.UByte.toInt' call
          var this_0 = subband_alloc[subband_alloc_n].c7s_1;
          k = tmp + (_UByte___get_data__impl__jof9qr(this_0) & 255) | 0;
          // Inline function 'kotlin.UByte.toInt' call
          var this_1 = subband_alloc[subband_alloc_n].b7s_1;
          ba_bits = _UByte___get_data__impl__jof9qr(this_1) & 255;
          // Inline function 'kotlin.UByte.toInt' call
          var this_2 = subband_alloc[subband_alloc_n].a7s_1;
          var tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
          ba_code_tab = g_bitalloc_code_tab.s7s(tmp$ret$2);
          subband_alloc_n = subband_alloc_n + 1 | 0;
        }
        ba = ba_code_tab.i1(this.v7n(bs, ba_bits));
        UByteArrayInt__set_impl_gn4532(sci.z7t_1, imul(2, i), ba);
        if (i < sci.y7t_1) {
          ba = ba_code_tab.i1(this.v7n(bs, ba_bits));
        }
        UByteArrayInt__set_impl_gn4532(sci.z7t_1, imul(2, i) + 1 | 0, !(sci.y7t_1 === 0) ? ba : 0);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = imul(2, sci.x7t_1);
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.a7u_1, i_0, !(UByteArrayInt__get_impl_px6q8a(sci.z7t_1, i_0) === 0) ? (hdr.i1(1) & 6) === 6 ? 2 : this.v7n(bs, 2) : 6);
      }
       while (inductionVariable_0 < last_0);
    this.e7o(bs, sci.z7t_1, sci.a7u_1, imul(sci.x7t_1, 2), new FloatArrayPtr(sci.w7t_1));
    var inductionVariable_1 = sci.y7t_1;
    var last_1 = sci.x7t_1;
    if (inductionVariable_1 < last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.z7t_1, imul(2, i_1) + 1 | 0, 0);
      }
       while (inductionVariable_1 < last_1);
  }
  g7o(grbuf, bs, sci, group_size) {
    var choff = 576;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dst = grbuf.s7s(imul(group_size, j));
        var inductionVariable_0 = 0;
        var last = imul(2, sci.x7t_1);
        if (inductionVariable_0 < last)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ba = UByteArrayInt__get_impl_px6q8a(sci.z7t_1, i);
            if (!(ba === 0)) {
              if (ba < 17) {
                var half = (1 << (ba - 1 | 0)) - 1 | 0;
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < group_size)
                  do {
                    var k = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    dst.a7t(k, this.v7n(bs, ba) - half | 0);
                  }
                   while (inductionVariable_1 < group_size);
              } else {
                var mod = (2 << (ba - 17 | 0)) + 1 | 0;
                var code = this.v7n(bs, (mod + 2 | 0) - (mod >> 3) | 0);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < group_size)
                  do {
                    var k_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    dst.a7t(k_0, (code % mod | 0) - (mod / 2 | 0) | 0);
                    code = code / mod | 0;
                  }
                   while (inductionVariable_2 < group_size);
              }
            }
            dst = dst.s7s(choff);
            choff = 18 - choff | 0;
          }
           while (inductionVariable_0 < last);
      }
       while (inductionVariable < 4);
    return imul(group_size, 4);
  }
  h7o(sci, scf, dst) {
    var scf_0 = scf;
    var dst_0 = dst;
    this.s7n(dst_0.s7s(576).s7s(imul(sci.y7t_1, 18)), dst_0.s7s(imul(sci.y7t_1, 18)), imul(sci.x7t_1 - sci.y7t_1 | 0, 18));
    var inductionVariable = 0;
    var last = sci.x7t_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 12)
          do {
            var k = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            dst_0.a7t(k + 0 | 0, dst_0.i1(k + 0 | 0) * scf_0.i1(0));
            dst_0.a7t(k + 576 | 0, dst_0.i1(k + 576 | 0) * scf_0.i1(3));
          }
           while (inductionVariable_0 < 12);
        dst_0 = dst_0.s7s(18);
        scf_0 = scf_0.s7s(6);
      }
       while (inductionVariable < last);
  }
  i7o(bs, gr, hdr) {
    var gr_0 = gr;
    var g_scf_long = Companion_getInstance_12().r7r_1;
    var g_scf_short = Companion_getInstance_12().s7r_1;
    var g_scf_mixed = Companion_getInstance_12().t7r_1;
    var tables;
    var scfsi = 0;
    var main_data_begin;
    var part_23_sum = 0;
    var sr_idx = (hdr.i1(2) >> 2 & 3) + imul((hdr.i1(1) >> 3 & 1) + (hdr.i1(1) >> 4 & 1) | 0, 3) | 0;
    sr_idx = sr_idx - toInt_0(!(sr_idx === 0), this) | 0;
    var gr_count = (hdr.i1(3) & 192) === 192 ? 1 : 2;
    if (!((hdr.i1(1) & 8) === 0)) {
      gr_count = imul(gr_count, 2);
      main_data_begin = this.v7n(bs, 9);
      scfsi = this.v7n(bs, 7 + gr_count | 0);
    } else {
      main_data_begin = this.v7n(bs, 8 + gr_count | 0) >> gr_count;
    }
    $l$1: do {
      $l$0: do {
        if ((hdr.i1(3) & 192) === 192) {
          scfsi = scfsi << 4;
        }
        gr_0.b2().h7t_1 = this.v7n(bs, 12);
        part_23_sum = part_23_sum + gr_0.b2().h7t_1 | 0;
        gr_0.b2().i7t_1 = this.v7n(bs, 9);
        if (gr_0.b2().i7t_1 > 288)
          return -1;
        gr_0.b2().k7t_1 = this.v7n(bs, 8);
        gr_0.b2().j7t_1 = this.v7n(bs, !((hdr.i1(1) & 8) === 0) ? 4 : 9);
        gr_0.b2().g7t_1 = new UByteArrayIntPtr(g_scf_long[sr_idx].n10_1);
        gr_0.b2().n7t_1 = 22;
        gr_0.b2().o7t_1 = 0;
        if (!(this.v7n(bs, 1) === 0)) {
          gr_0.b2().l7t_1 = this.v7n(bs, 2);
          if (gr_0.b2().l7t_1 === 0)
            return -1;
          gr_0.b2().m7t_1 = this.v7n(bs, 1);
          UByteArrayInt__set_impl_gn4532_0(gr_0.b2().q7t_1, 0, _UByte___init__impl__g9hnc4(7));
          UByteArrayInt__set_impl_gn4532(gr_0.b2().q7t_1, 1, 255);
          if (gr_0.b2().l7t_1 === 2) {
            scfsi = scfsi & 3855;
            if (gr_0.b2().m7t_1 === 0) {
              UByteArrayInt__set_impl_gn4532(gr_0.b2().q7t_1, 0, 8);
              gr_0.b2().g7t_1 = new UByteArrayIntPtr(g_scf_short[sr_idx].n10_1);
              gr_0.b2().n7t_1 = 0;
              gr_0.b2().o7t_1 = 39;
            } else {
              gr_0.b2().g7t_1 = new UByteArrayIntPtr(g_scf_mixed[sr_idx].n10_1);
              gr_0.b2().n7t_1 = !((hdr.i1(1) & 8) === 0) ? 8 : 6;
              gr_0.b2().o7t_1 = 30;
            }
          }
          tables = this.v7n(bs, 10);
          tables = tables << 5;
          UByteArrayInt__set_impl_gn4532(gr_0.b2().r7t_1, 0, this.v7n(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.b2().r7t_1, 1, this.v7n(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.b2().r7t_1, 2, this.v7n(bs, 3));
        } else {
          gr_0.b2().l7t_1 = 0;
          gr_0.b2().m7t_1 = 0;
          tables = this.v7n(bs, 15);
          UByteArrayInt__set_impl_gn4532(gr_0.b2().q7t_1, 0, this.v7n(bs, 4));
          UByteArrayInt__set_impl_gn4532(gr_0.b2().q7t_1, 1, this.v7n(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.b2().q7t_1, 2, 255);
        }
        UByteArrayInt__set_impl_gn4532(gr_0.b2().p7t_1, 0, tables >> 10);
        UByteArrayInt__set_impl_gn4532(gr_0.b2().p7t_1, 1, tables >> 5 & 31);
        UByteArrayInt__set_impl_gn4532(gr_0.b2().p7t_1, 2, tables & 31);
        gr_0.b2().s7t_1 = !((hdr.i1(1) & 8) === 0) ? this.v7n(bs, 1) : toInt_0(gr_0.b2().j7t_1 >= 500, this);
        gr_0.b2().t7t_1 = this.v7n(bs, 1);
        gr_0.b2().u7t_1 = this.v7n(bs, 1);
        gr_0.b2().v7t_1 = scfsi >> 12 & 15;
        scfsi = scfsi << 4;
        gr_0 = gr_0.g4();
      }
       while (false);
      gr_count = gr_count - 1 | 0;
    }
     while (!(gr_count === 0));
    if ((part_23_sum + bs.f7s_1 | 0) > (bs.g7s_1 + imul(main_data_begin, 8) | 0))
      return -1;
    return main_data_begin;
  }
  j7o(scf, ist_pos, scf_size, scf_count, bitbuf, scfsi) {
    var scf_0 = scf;
    var ist_pos_0 = new UByteArrayIntPtr(ist_pos);
    var scfsi_0 = scfsi;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (scf_count.i1(i) === 0)
          break $l$loop;
        var cnt = scf_count.i1(i);
        if (!((scfsi_0 & 8) === 0)) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < cnt)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              scf_0.t31(n, ist_pos_0.i1(n));
            }
             while (inductionVariable_0 < cnt);
        } else {
          var bits = UByteArrayInt__get_impl_px6q8a(scf_size, i);
          if (bits === 0) {
            scf_0.w7s(_UByte___init__impl__g9hnc4(0), 0, cnt);
            ist_pos_0.w7s(_UByte___init__impl__g9hnc4(0), 0, cnt);
          } else {
            var max_scf = (scfsi_0 < 0 ? toLong((1 << bits) - 1 | 0) : new Long(-1, -1)).q2();
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < cnt)
              do {
                var k = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var s = this.v7n(bitbuf, bits);
                ist_pos_0.t31(k, (s === max_scf ? new Long(-1, -1) : toLong(s)).q2());
                scf_0.t31(k, s);
              }
               while (inductionVariable_1 < cnt);
          }
        }
        ist_pos_0 = ist_pos_0.s7s(cnt);
        scf_0 = scf_0.s7s(cnt);
        scfsi_0 = imul(scfsi_0, 2);
      }
       while (inductionVariable < 4);
    scf_0.t31(0, 0);
    scf_0.t31(1, 0);
    scf_0.t31(2, 0);
  }
  k7o(y, exp_q2) {
    var y_0 = y;
    var exp_q2_0 = exp_q2;
    var g_expfrac = Companion_getInstance_12().e7r_1;
    do {
      var e = 120 > exp_q2_0 ? exp_q2_0 : 120;
      y_0 = y_0 * (g_expfrac[e & 3] * (1073741824 >> (e >> 2)));
      exp_q2_0 = exp_q2_0 - e | 0;
    }
     while (exp_q2_0 > 0);
    return y_0;
  }
  l7o(hdr, ist_pos, bs, gr, scf, ch) {
    var g_scf_partitions = Companion_getInstance_12().u7r_1;
    var scf_partition = new UByteArrayIntPtr(g_scf_partitions[toInt_0(!(gr.b2().o7t_1 === 0), this) + toInt_0(gr.b2().n7t_1 === 0, this) | 0].n10_1);
    var scf_size = _UByteArrayInt___init__impl__xif7bu_1(4);
    var iscf = _UByteArrayInt___init__impl__xif7bu_1(40);
    var scf_shift = gr.b2().t7t_1 + 1 | 0;
    var scfsi = gr.b2().v7t_1;
    if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
      var g_scfc_decode = Companion_getInstance_12().i7r_1;
      var part = UByteArrayInt__get_impl_px6q8a(g_scfc_decode, gr.b2().j7t_1);
      UByteArrayInt__set_impl_gn4532(scf_size, 0, part >> 2);
      UByteArrayInt__set_impl_gn4532(scf_size, 1, UByteArrayInt__get_impl_px6q8a(scf_size, 0));
      UByteArrayInt__set_impl_gn4532(scf_size, 2, part & 3);
      UByteArrayInt__set_impl_gn4532(scf_size, 3, UByteArrayInt__get_impl_px6q8a(scf_size, 2));
    } else {
      var g_mod = Companion_getInstance_12().j7r_1;
      var ist = toInt_0(!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 16) === 0) && !(ch === 0), this);
      var sfc = gr.b2().j7t_1 >> ist;
      var k = imul(imul(ist, 3), 4);
      while (sfc >= 0) {
        var modprod = 1;
        var inductionVariable = 3;
        if (0 <= inductionVariable)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            UByteArrayInt__set_impl_gn4532(scf_size, i, (sfc / modprod | 0) % UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0) | 0);
            modprod = imul(modprod, UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0));
          }
           while (0 <= inductionVariable);
        sfc = sfc - modprod | 0;
        k = k + 4 | 0;
      }
      scf_partition = scf_partition.s7s(k);
      scfsi = -16;
    }
    this.j7o(new UByteArrayIntPtr(iscf), ist_pos, scf_size, scf_partition, bs, scfsi);
    if (!(gr.b2().o7t_1 === 0)) {
      var sh = 3 - scf_shift | 0;
      var progression = step(until(0, gr.b2().o7t_1), 3);
      var inductionVariable_0 = progression.k2_1;
      var last = progression.l2_1;
      var step_0 = progression.m2_1;
      if (step_0 > 0 && inductionVariable_0 <= last || (step_0 < 0 && last <= inductionVariable_0))
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          UByteArrayInt__set_impl_gn4532(iscf, (gr.b2().n7t_1 + i_0 | 0) + 0 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.b2().n7t_1 + i_0 | 0) + 0 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.b2().r7t_1, 0) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.b2().n7t_1 + i_0 | 0) + 1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.b2().n7t_1 + i_0 | 0) + 1 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.b2().r7t_1, 1) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.b2().n7t_1 + i_0 | 0) + 2 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.b2().n7t_1 + i_0 | 0) + 2 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.b2().r7t_1, 2) << sh) | 0);
        }
         while (!(i_0 === last));
    } else {
      if (!(gr.b2().s7t_1 === 0)) {
        var g_preamp = Companion_getInstance_12().k7r_1;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 10)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(iscf, 11 + i_1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, 11 + i_1 | 0) + UByteArrayInt__get_impl_px6q8a(g_preamp, i_1) | 0);
          }
           while (inductionVariable_1 < 10);
      }
    }
    var gain_exp = (numberToLong(gr.b2().k7t_1).c4(new Long(-4, -1)).q2() - 210 | 0) - ((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 224) === 96 ? 2 : 0) | 0;
    var gain = this.k7o(2048, (new Long(44, 0)).h2(toLong(gain_exp)).q2());
    var inductionVariable_2 = 0;
    var last_0 = gr.b2().n7t_1 + gr.b2().o7t_1 | 0;
    if (inductionVariable_2 < last_0)
      do {
        var i_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        scf.a7t(i_2, this.k7o(gain, UByteArrayInt__get_impl_px6q8a(iscf, i_2) << scf_shift));
      }
       while (inductionVariable_2 < last_0);
  }
  m7o(x) {
    var x_0 = x;
    var mult = 256;
    if (x_0 < 129)
      return Companion_getInstance_12().z7r_1[16 + x_0 | 0];
    if (x_0 < 1024) {
      mult = 16;
      x_0 = x_0 << 3;
    }
    var sign = imul(2, x_0) & 64;
    var frac = ((x_0 & 63) - sign | 0) / ((x_0 & -64) + sign | 0);
    return Companion_getInstance_12().z7r_1[16 + ((x_0 + sign | 0) >> 6) | 0] * (1.0 + frac * (4.0 / 3.0 + frac * (2.0 / 9.0))) * mult;
  }
  n7o(dst, bs, gr_info, scf, layer3gr_limit) {
    var dst_0 = dst;
    var scf_0 = scf;
    var tabs = Companion_getInstance_12().l7r_1;
    var tab32 = Companion_getInstance_12().m7r_1;
    var tab33 = Companion_getInstance_12().n7r_1;
    var tabindex = Companion_getInstance_12().o7r_1;
    var g_linbits = Companion_getInstance_12().p7r_1;
    var one = 0.0;
    var ireg = 0;
    var big_val_cnt = gr_info.b2().i7t_1;
    var sfb = gr_info.b2().g7t_1;
    var bs_next_ptr = bs.e7s_1.s7s(bs.f7s_1 / 8 | 0);
    // Inline function 'kotlin.toUInt' call
    var this_0 = (imul(imul(imul(bs_next_ptr.i1(0), 256) + bs_next_ptr.i1(1) | 0, 256) + bs_next_ptr.i1(2) | 0, 256) + bs_next_ptr.i1(3) | 0) << (bs.f7s_1 & 7);
    var bs_cache = _UInt___init__impl__l7qpdl(this_0);
    var pairs_to_decode = 0;
    var np = 0;
    var bs_sh = (bs.f7s_1 & 7) - 8 | 0;
    bs_next_ptr = bs_next_ptr.s7s(4);
    while (big_val_cnt > 0) {
      var tab_num = UByteArrayInt__get_impl_px6q8a(gr_info.b2().p7t_1, ireg);
      var tmp = gr_info.b2().q7t_1;
      var _unary__edvuaz = ireg;
      ireg = _unary__edvuaz + 1 | 0;
      var sfb_cnt = UByteArrayInt__get_impl_px6q8a(tmp, _unary__edvuaz);
      var codebook = tabindex[tab_num];
      var linbits = UByteArrayInt__get_impl_px6q8a(g_linbits, tab_num);
      if (!(linbits === 0)) {
        $l$3: do {
          $l$2: do {
            np = sfb.b2() / 2 | 0;
            sfb = sfb.g4();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_0 = scf_0;
            scf_0 = _unary__edvuaz_0.g4();
            one = _unary__edvuaz_0.b2();
            $l$1: do {
              $l$0: do {
                var w = 5;
                // Inline function 'kotlin.UInt.toInt' call
                // Inline function 'kotlin.UInt.shr' call
                var this_1 = bs_cache;
                var bitCount = 32 - w | 0;
                var this_2 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) >>> bitCount | 0);
                var leaf = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_2) | 0];
                while (leaf < 0) {
                  // Inline function 'kotlin.UInt.shl' call
                  var this_3 = bs_cache;
                  var bitCount_0 = w;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_3) << bitCount_0);
                  bs_sh = bs_sh + w | 0;
                  w = leaf & 7;
                  // Inline function 'kotlin.UInt.toInt' call
                  // Inline function 'kotlin.UInt.shr' call
                  var this_4 = bs_cache;
                  var bitCount_1 = 32 - w | 0;
                  var this_5 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_4) >>> bitCount_1 | 0);
                  leaf = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_5) | 0) - (leaf >> 3) | 0];
                }
                // Inline function 'kotlin.UInt.shl' call
                var this_6 = bs_cache;
                var bitCount_2 = leaf >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_6) << bitCount_2);
                bs_sh = bs_sh + (leaf >> 8) | 0;
                var inductionVariable = 0;
                if (inductionVariable < 2)
                  do {
                    var j = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var lsb = leaf & 15;
                    if (lsb === 15) {
                      var tmp_0 = lsb;
                      // Inline function 'kotlin.UInt.toInt' call
                      // Inline function 'kotlin.UInt.shr' call
                      var this_7 = bs_cache;
                      var bitCount_3 = 32 - linbits | 0;
                      var this_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_7) >>> bitCount_3 | 0);
                      lsb = tmp_0 + _UInt___get_data__impl__f0vqqw(this_8) | 0;
                      // Inline function 'kotlin.UInt.shl' call
                      var this_9 = bs_cache;
                      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_9) << linbits);
                      bs_sh = bs_sh + linbits | 0;
                      while (bs_sh >= 0) {
                        // Inline function 'kotlin.UInt.or' call
                        var this_10 = bs_cache;
                        // Inline function 'kotlin.toUInt' call
                        var this_11 = bs_next_ptr.b2() << bs_sh;
                        var other = _UInt___init__impl__l7qpdl(this_11);
                        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_10) | _UInt___get_data__impl__f0vqqw(other));
                        bs_next_ptr = bs_next_ptr.g4();
                        bs_sh = bs_sh - 8 | 0;
                      }
                      var tmp_1 = dst_0;
                      var tmp_2 = one * this.m7o(lsb);
                      var tmp_3;
                      // Inline function 'kotlin.UInt.toInt' call
                      var this_12 = bs_cache;
                      if (_UInt___get_data__impl__f0vqqw(this_12) < 0) {
                        tmp_3 = new Long(-1, -1);
                      } else {
                        tmp_3 = new Long(1, 0);
                      }
                      tmp_1.z7s(tmp_2 * tmp_3.s4());
                    } else {
                      var tmp_4 = dst_0;
                      var tmp_5 = Companion_getInstance_12().z7r_1;
                      var tmp_6 = 16 + lsb | 0;
                      // Inline function 'kotlin.UInt.toInt' call
                      // Inline function 'kotlin.UInt.shr' call
                      var this_13 = bs_cache;
                      var this_14 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_13) >>> 31 | 0);
                      var tmp$ret$14 = _UInt___get_data__impl__f0vqqw(this_14);
                      tmp_4.z7s(tmp_5[tmp_6 - imul(16, tmp$ret$14) | 0] * one);
                    }
                    // Inline function 'kotlin.UInt.shl' call
                    var this_15 = bs_cache;
                    var bitCount_4 = !(lsb === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_15) << bitCount_4);
                    bs_sh = bs_sh + (!(lsb === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.g4();
                    leaf = leaf >> 4;
                  }
                   while (inductionVariable < 2);
                while (bs_sh >= 0) {
                  // Inline function 'kotlin.UInt.or' call
                  var this_16 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_17 = bs_next_ptr.b2() << bs_sh;
                  var other_0 = _UInt___init__impl__l7qpdl(this_17);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_16) | _UInt___get_data__impl__f0vqqw(other_0));
                  bs_next_ptr = bs_next_ptr.g4();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_7;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_7 = sfb_cnt >= 0;
          } else {
            tmp_7 = false;
          }
        }
         while (tmp_7);
      } else {
        $l$7: do {
          $l$6: do {
            np = sfb.b2() / 2 | 0;
            sfb = sfb.g4();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_1 = scf_0;
            scf_0 = _unary__edvuaz_1.g4();
            one = _unary__edvuaz_1.b2();
            $l$5: do {
              $l$4: do {
                var w_0 = 5;
                // Inline function 'kotlin.UInt.toInt' call
                // Inline function 'kotlin.UInt.shr' call
                var this_18 = bs_cache;
                var bitCount_5 = 32 - w_0 | 0;
                var this_19 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_18) >>> bitCount_5 | 0);
                var leaf_0 = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_19) | 0];
                while (leaf_0 < 0) {
                  // Inline function 'kotlin.UInt.shl' call
                  var this_20 = bs_cache;
                  var bitCount_6 = w_0;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_20) << bitCount_6);
                  bs_sh = bs_sh + w_0 | 0;
                  w_0 = leaf_0 & 7;
                  // Inline function 'kotlin.UInt.toInt' call
                  // Inline function 'kotlin.UInt.shr' call
                  var this_21 = bs_cache;
                  var bitCount_7 = 32 - w_0 | 0;
                  var this_22 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_21) >>> bitCount_7 | 0);
                  leaf_0 = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_22) | 0) - (leaf_0 >> 3) | 0];
                }
                // Inline function 'kotlin.UInt.shl' call
                var this_23 = bs_cache;
                var bitCount_8 = leaf_0 >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_23) << bitCount_8);
                bs_sh = bs_sh + (leaf_0 >> 8) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < 2)
                  do {
                    var j_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var lsb_0 = leaf_0 & 15;
                    var tmp_8 = dst_0;
                    var tmp_9 = Companion_getInstance_12().z7r_1;
                    var tmp_10 = 16 + lsb_0 | 0;
                    // Inline function 'kotlin.UInt.toInt' call
                    // Inline function 'kotlin.UInt.shr' call
                    var this_24 = bs_cache;
                    var this_25 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_24) >>> 31 | 0);
                    var tmp$ret$25 = _UInt___get_data__impl__f0vqqw(this_25);
                    tmp_8.z7s(tmp_9[tmp_10 - imul(16, tmp$ret$25) | 0] * one);
                    // Inline function 'kotlin.UInt.shl' call
                    var this_26 = bs_cache;
                    var bitCount_9 = !(lsb_0 === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_26) << bitCount_9);
                    bs_sh = bs_sh + (!(lsb_0 === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.g4();
                    leaf_0 = leaf_0 >> 4;
                  }
                   while (inductionVariable_0 < 2);
                while (bs_sh >= 0) {
                  // Inline function 'kotlin.UInt.or' call
                  var this_27 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_28 = bs_next_ptr.b2() << bs_sh;
                  var other_1 = _UInt___init__impl__l7qpdl(this_28);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_27) | _UInt___get_data__impl__f0vqqw(other_1));
                  bs_next_ptr = bs_next_ptr.g4();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_11;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_11 = sfb_cnt >= 0;
          } else {
            tmp_11 = false;
          }
        }
         while (tmp_11);
      }
    }
    np = 1 - big_val_cnt | 0;
    $l$loop_1: while (true) {
      var codebook_count1 = !(gr_info.b2().u7t_1 === 0) ? tab33 : tab32;
      // Inline function 'kotlin.UInt.toInt' call
      // Inline function 'kotlin.UInt.shr' call
      var this_29 = bs_cache;
      var this_30 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_29) >>> 28 | 0);
      var tmp$ret$30 = _UInt___get_data__impl__f0vqqw(this_30);
      var leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp$ret$30);
      if ((leaf_1 & 8) === 0) {
        var tmp_12 = leaf_1 >> 3;
        // Inline function 'kotlin.UInt.toInt' call
        // Inline function 'kotlin.UInt.shr' call
        // Inline function 'kotlin.UInt.shl' call
        var this_31 = bs_cache;
        var this_32 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_31) << 4);
        var bitCount_10 = 32 - (leaf_1 & 3) | 0;
        var this_33 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_32) >>> bitCount_10 | 0);
        var tmp$ret$33 = _UInt___get_data__impl__f0vqqw(this_33);
        leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp_12 + tmp$ret$33 | 0);
      }
      // Inline function 'kotlin.UInt.shl' call
      var this_34 = bs_cache;
      var bitCount_11 = leaf_1 & 7;
      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_34) << bitCount_11);
      bs_sh = bs_sh + (leaf_1 & 7) | 0;
      if (((imul(bs_next_ptr.v7s(bs.e7s_1), 8) - 24 | 0) + bs_sh | 0) > layer3gr_limit) {
        break $l$loop_1;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.b2() / 2 | 0;
        sfb = sfb.g4();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_2 = scf_0;
        scf_0 = _unary__edvuaz_2.g4();
        one = _unary__edvuaz_2.b2();
      }
      if (!((leaf_1 & 128) === 0)) {
        var tmp_13 = dst_0;
        var tmp_14;
        // Inline function 'kotlin.UInt.toInt' call
        var this_35 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_35) < 0) {
          tmp_14 = -one;
        } else {
          tmp_14 = one;
        }
        tmp_13.a7t(0, tmp_14);
        // Inline function 'kotlin.UInt.shl' call
        var this_36 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_36) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 64) === 0)) {
        var tmp_15 = dst_0;
        var tmp_16;
        // Inline function 'kotlin.UInt.toInt' call
        var this_37 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_37) < 0) {
          tmp_16 = -one;
        } else {
          tmp_16 = one;
        }
        tmp_15.a7t(1, tmp_16);
        // Inline function 'kotlin.UInt.shl' call
        var this_38 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_38) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.b2() / 2 | 0;
        sfb = sfb.g4();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_3 = scf_0;
        scf_0 = _unary__edvuaz_3.g4();
        one = _unary__edvuaz_3.b2();
      }
      if (!((leaf_1 & 32) === 0)) {
        var tmp_17 = dst_0;
        var tmp_18;
        // Inline function 'kotlin.UInt.toInt' call
        var this_39 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_39) < 0) {
          tmp_18 = -one;
        } else {
          tmp_18 = one;
        }
        tmp_17.a7t(2, tmp_18);
        // Inline function 'kotlin.UInt.shl' call
        var this_40 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_40) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 16) === 0)) {
        var tmp_19 = dst_0;
        var tmp_20;
        // Inline function 'kotlin.UInt.toInt' call
        var this_41 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_41) < 0) {
          tmp_20 = -one;
        } else {
          tmp_20 = one;
        }
        tmp_19.a7t(3, tmp_20);
        // Inline function 'kotlin.UInt.shl' call
        var this_42 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_42) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      while (bs_sh >= 0) {
        // Inline function 'kotlin.UInt.or' call
        var this_43 = bs_cache;
        // Inline function 'kotlin.toUInt' call
        var this_44 = bs_next_ptr.b2() << bs_sh;
        var other_2 = _UInt___init__impl__l7qpdl(this_44);
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_43) | _UInt___get_data__impl__f0vqqw(other_2));
        bs_next_ptr = bs_next_ptr.g4();
        bs_sh = bs_sh - 8 | 0;
      }
      dst_0 = dst_0.s7s(4);
    }
    bs.f7s_1 = layer3gr_limit;
  }
  o7o(left, n) {
    var right = left.s7s(576);
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = left.i1(i);
        var b = right.i1(i);
        left.a7t(i, a + b);
        right.a7t(i, a - b);
      }
       while (inductionVariable < n);
  }
  p7o(left, n, kl, kr) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        left.a7t(i + 576 | 0, left.i1(i) * kr);
        left.a7t(i, left.i1(i) * kl);
      }
       while (inductionVariable < n);
  }
  q7o(right, sfb, nbands, max_band) {
    var right_0 = right;
    max_band[0] = -1;
    max_band[1] = -1;
    max_band[2] = -1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = 0;
        $l$loop: while (k < sfb.i1(i)) {
          if (!(right_0.i1(k) === 0.0) || !(right_0.i1(k + 1 | 0) === 0.0)) {
            max_band[i % 3 | 0] = i;
            break $l$loop;
          }
          k = k + 2 | 0;
        }
        right_0 = right_0.s7s(sfb.i1(i));
      }
       while (inductionVariable < nbands);
  }
  r7o(left, ist_pos, sfb, hdr, max_band, mpeg2_sh) {
    var left_0 = left;
    var g_pan = Companion_getInstance_12().a7r_1;
    var max_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 7 : 64;
    var i = 0;
    while (!(sfb.i1(i) === 0)) {
      var ipos = UByteArrayInt__get_impl_px6q8a(ist_pos, i);
      if (i > max_band[i % 3 | 0] && ipos < max_pos) {
        var kl;
        var kr;
        var s = !((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0) ? 1.4142135 : 1.0;
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
          kl = g_pan[imul(2, ipos) + 0 | 0];
          kr = g_pan[imul(2, ipos) + 1 | 0];
        } else {
          kl = 1.0;
          kr = this.k7o(1.0, (ipos + 1 | 0) >> 1 << mpeg2_sh);
          if (!((ipos & 1) === 0)) {
            kl = kr;
            kr = 1.0;
          }
        }
        this.p7o(left_0, sfb.i1(i), kl * s, kr * s);
      } else {
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0)) {
          this.o7o(left_0, sfb.i1(i));
        }
      }
      left_0 = left_0.s7s(sfb.i1(i));
      i = i + 1 | 0;
    }
  }
  s7o(left, ist_pos, gr, hdr) {
    var max_band = this.m7m_1;
    var n_sfb = gr.b2().n7t_1 + gr.b2().o7t_1 | 0;
    var max_blocks = !(gr.b2().o7t_1 === 0) ? 3 : 1;
    this.q7o(left.s7s(576), gr.b2().g7t_1, n_sfb, max_band);
    if (!(gr.b2().n7t_1 === 0)) {
      // Inline function 'kotlin.math.max' call
      // Inline function 'kotlin.math.max' call
      var a = max_band[0];
      var b = max_band[1];
      var a_0 = Math.max(a, b);
      var b_0 = max_band[2];
      var v = Math.max(a_0, b_0);
      max_band[0] = v;
      max_band[1] = v;
      max_band[2] = v;
    }
    var inductionVariable = 0;
    if (inductionVariable < max_blocks)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var default_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 3 : 0;
        var itop = (n_sfb - max_blocks | 0) + i | 0;
        var prev = itop - max_blocks | 0;
        UByteArrayInt__set_impl_gn4532(ist_pos, itop, max_band[i] >= prev ? default_pos : UByteArrayInt__get_impl_px6q8a(ist_pos, prev));
      }
       while (inductionVariable < max_blocks);
    this.r7o(left, ist_pos, gr.b2().g7t_1, hdr, max_band, gr.i1(1).j7t_1 & 1);
  }
  t7o(grbuf, scratch, sfb) {
    var sfb_0 = sfb;
    var i = 0;
    var len = 0;
    var src = grbuf;
    var dst = scratch;
    $l$loop: while (true) {
      len = sfb_0.b2();
      if (len === 0)
        break $l$loop;
      i = 0;
      while (i < len) {
        var _unary__edvuaz = dst;
        dst = _unary__edvuaz.g4();
        _unary__edvuaz.z7s(src.i1(imul(0, len)));
        var _unary__edvuaz_0 = dst;
        dst = _unary__edvuaz_0.g4();
        _unary__edvuaz_0.z7s(src.i1(imul(1, len)));
        var _unary__edvuaz_1 = dst;
        dst = _unary__edvuaz_1.g4();
        _unary__edvuaz_1.z7s(src.i1(imul(2, len)));
        i = i + 1 | 0;
        src = src.g4();
      }
      sfb_0 = sfb_0.s7s(3);
      src = src.s7s(imul(2, len));
    }
    this.s7n(grbuf, scratch, dst.b7t(scratch));
  }
  u7o(grbuf, nbands) {
    var grbuf_0 = grbuf;
    var nbands_0 = nbands;
    var g_aa = Companion_getInstance_12().c7r_1;
    while (nbands_0 > 0) {
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var u = grbuf_0.i1(18 + i | 0);
          var d = grbuf_0.i1(17 - i | 0);
          grbuf_0.a7t(18 + i | 0, u * g_aa[0][i] - d * g_aa[1][i]);
          grbuf_0.a7t(17 - i | 0, u * g_aa[1][i] + d * g_aa[0][i]);
        }
         while (inductionVariable < 8);
      nbands_0 = nbands_0 - 1 | 0;
      grbuf_0 = grbuf_0.s7s(18);
    }
  }
  v7o(y) {
    var s0 = y[0];
    var s2 = y[2];
    var s4 = y[4];
    var s6 = y[6];
    var s8 = y[8];
    var t0 = s0 + s6 * 0.5;
    s0 = s0 - s6;
    var t4 = (s4 + s2) * 0.9396926;
    var t2 = (s8 + s2) * 0.76604444;
    s6 = (s4 - s8) * 0.17364818;
    s4 = s4 + (s8 - s2);
    s2 = s0 - s4 * 0.5;
    y[4] = s4 + s0;
    s8 = t0 - t2 + s6;
    s0 = t0 - t4 + t2;
    s4 = t0 + t4 - s6;
    var s1 = y[1];
    var s3 = y[3];
    var s5 = y[5];
    var s7 = y[7];
    s3 = s3 * 0.8660254;
    t0 = (s5 + s1) * 0.9848077;
    t4 = (s5 - s7) * 0.34202015;
    t2 = (s1 + s7) * 0.64278764;
    s1 = (s1 - s5 - s7) * 0.8660254;
    s5 = t0 - s3 - t2;
    s7 = t4 - s3 - t0;
    s3 = t4 + s3 - t2;
    y[0] = s4 - s7;
    y[1] = s2 + s1;
    y[2] = s0 - s3;
    y[3] = s8 + s5;
    y[5] = s8 - s5;
    y[6] = s0 + s3;
    y[7] = s2 - s1;
    y[8] = s4 + s7;
  }
  w7o(grbuf, overlap, window_0, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_twid9 = Companion_getInstance_12().x7q_1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var co = this.n7m_1;
        var si = this.o7m_1;
        co[0] = -grbuf_0.i1(0);
        si[0] = grbuf_0.i1(17);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            si[8 - imul(2, i) | 0] = grbuf_0.i1(imul(4, i) + 1 | 0) - grbuf_0.i1(imul(4, i) + 2 | 0);
            co[1 + imul(2, i) | 0] = grbuf_0.i1(imul(4, i) + 1 | 0) + grbuf_0.i1(imul(4, i) + 2 | 0);
            si[7 - imul(2, i) | 0] = grbuf_0.i1(imul(4, i) + 4 | 0) - grbuf_0.i1(imul(4, i) + 3 | 0);
            co[2 + imul(2, i) | 0] = -(grbuf_0.i1(imul(4, i) + 3 | 0) + grbuf_0.i1(imul(4, i) + 4 | 0));
          }
           while (inductionVariable_0 < 4);
        this.v7o(co);
        this.v7o(si);
        si[1] = -si[1];
        si[3] = -si[3];
        si[5] = -si[5];
        si[7] = -si[7];
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 9)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var ovl = overlap_0.i1(i_0);
            var sum = co[i_0] * g_twid9[9 + i_0 | 0] + si[i_0] * g_twid9[0 + i_0 | 0];
            overlap_0.a7t(i_0, co[i_0] * g_twid9[0 + i_0 | 0] - si[i_0] * g_twid9[9 + i_0 | 0]);
            grbuf_0.a7t(i_0, ovl * window_0[0 + i_0 | 0] - sum * window_0[9 + i_0 | 0]);
            grbuf_0.a7t(17 - i_0 | 0, ovl * window_0[9 + i_0 | 0] + sum * window_0[0 + i_0 | 0]);
          }
           while (inductionVariable_1 < 9);
        grbuf_0 = grbuf_0.s7s(18);
        overlap_0 = overlap_0.s7s(9);
      }
       while (inductionVariable < nbands);
  }
  x7o(x0, x1, x2, dst) {
    var m1 = x1 * 0.8660254;
    var a1 = x0 - x2 * 0.5;
    dst[1] = x0 + x2;
    dst[0] = a1 + m1;
    dst[2] = a1 - m1;
  }
  y7o(x, dst, overlap) {
    var g_twid3 = Companion_getInstance_12().y7q_1;
    var co = this.p7m_1;
    var si = this.q7m_1;
    this.x7o(-x.i1(0), x.i1(6) + x.i1(3), x.i1(12) + x.i1(9), co);
    this.x7o(x.i1(15), x.i1(12) - x.i1(9), x.i1(6) - x.i1(3), si);
    si[1] = -si[1];
    var inductionVariable = 0;
    if (inductionVariable < 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ovl = overlap.i1(i);
        var sum = co[i] * g_twid3[3 + i | 0] + si[i] * g_twid3[0 + i | 0];
        overlap.a7t(i, co[i] * g_twid3[0 + i | 0] - si[i] * g_twid3[3 + i | 0]);
        dst.a7t(i, ovl * g_twid3[2 - i | 0] - sum * g_twid3[5 - i | 0]);
        dst.a7t(5 - i | 0, ovl * g_twid3[5 - i | 0] + sum * g_twid3[2 - i | 0]);
      }
       while (inductionVariable < 3);
  }
  z7o(grbuf, overlap, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var nbands_0 = nbands;
    while (nbands_0 > 0) {
      var tmp = new FloatArrayPtr(new Float32Array(18));
      this.s7n(tmp, grbuf_0, 18);
      this.s7n(grbuf_0, overlap_0, 6);
      this.y7o(tmp, grbuf_0.s7s(6), overlap_0.s7s(6));
      this.y7o(tmp.s7s(1), grbuf_0.s7s(12), overlap_0.s7s(6));
      this.y7o(tmp.s7s(2), overlap_0, overlap_0.s7s(6));
      nbands_0 = nbands_0 - 1 | 0;
      overlap_0 = overlap_0.s7s(9);
      grbuf_0 = grbuf_0.s7s(18);
    }
  }
  a7p(grbuf) {
    var p = 18;
    var progression = step(until(0, 32), 2);
    var inductionVariable = progression.k2_1;
    var last = progression.l2_1;
    var step_0 = progression.m2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var b = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var progression_0 = step(until(1, 18), 2);
        var inductionVariable_0 = progression_0.k2_1;
        var last_0 = progression_0.l2_1;
        var step_1 = progression_0.m2_1;
        if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            var index = p + i | 0;
            grbuf.a7t(index, -grbuf.i1(index));
          }
           while (!(i === last_0));
        p = p + 36 | 0;
      }
       while (!(b === last));
  }
  b7p(grbuf, overlap, block_type, n_long_bands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_mdct_window = Companion_getInstance_12().d7r_1;
    if (!(n_long_bands === 0)) {
      this.w7o(grbuf_0, overlap_0, g_mdct_window[0], n_long_bands);
      grbuf_0 = grbuf_0.s7s(imul(18, n_long_bands));
      overlap_0 = overlap_0.s7s(imul(9, n_long_bands));
    }
    if (block_type === 2) {
      this.z7o(grbuf_0, overlap_0, 32 - n_long_bands | 0);
    } else {
      this.w7o(grbuf_0, overlap_0, g_mdct_window[toInt_0(block_type === 3, this)], 32 - n_long_bands | 0);
    }
  }
  c7p(h, s) {
    var pos = (s.h7s_1.f7s_1 + 7 | 0) / 8 | 0;
    var remains = (s.h7s_1.g7s_1 / 8 | 0) - pos | 0;
    if (remains > 511) {
      pos = pos + (remains - 511 | 0) | 0;
      remains = 511;
    }
    if (remains > 0) {
      this.t7n(new UByteArrayIntPtr(h.k7m_1), s.i7s_1.s7s(pos), remains);
    }
    h.h7m_1 = remains;
  }
  d7p(h, bs, s, main_data_begin) {
    var frame_bytes = (bs.g7s_1 - bs.f7s_1 | 0) / 8 | 0;
    var bytes_have = h.h7m_1 > main_data_begin ? main_data_begin : h.h7m_1;
    this.t7n(s.i7s_1, (new UByteArrayIntPtr(h.k7m_1)).s7s(0 < (h.h7m_1 - main_data_begin | 0) ? h.h7m_1 - main_data_begin | 0 : 0), h.h7m_1 > main_data_begin ? main_data_begin : h.h7m_1);
    this.t7n(s.i7s_1.s7s(bytes_have), bs.e7s_1.s7s(bs.f7s_1 / 8 | 0), frame_bytes);
    this.u7n(s.h7s_1, s.i7s_1, bytes_have + frame_bytes | 0);
    return toInt_0(h.h7m_1 >= main_data_begin, this);
  }
  e7p(h, s, gr_info, nch) {
    var gr_info_0 = gr_info;
    var inductionVariable = 0;
    if (inductionVariable < nch)
      do {
        var ch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var layer3gr_limit = s.h7s_1.f7s_1 + gr_info_0.i1(ch).h7t_1 | 0;
        this.l7o(h.j7m_1, s.n7s_1[ch].n10_1, s.h7s_1, gr_info_0.s7s(ch), s.l7s_1, ch);
        this.n7o(s.k7s_1[ch], s.h7s_1, gr_info_0.s7s(ch), s.l7s_1, layer3gr_limit);
      }
       while (inductionVariable < nch);
    if (!((UByteArrayInt__get_impl_px6q8a(h.j7m_1, 3) & 16) === 0)) {
      this.s7o(s.k7s_1[0], s.n7s_1[1].n10_1, gr_info_0, h.j7m_1);
    } else if ((UByteArrayInt__get_impl_px6q8a(h.j7m_1, 3) & 224) === 96) {
      this.o7o(s.k7s_1[0], 576);
    }
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < nch)
      do {
        var ch_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var aa_bands = 31;
        var n_long_bands = (!(gr_info_0.b2().m7t_1 === 0) ? 2 : 0) << toInt_0(((UByteArrayInt__get_impl_px6q8a(h.j7m_1, 2) >> 2 & 3) + imul((UByteArrayInt__get_impl_px6q8a(h.j7m_1, 1) >> 3 & 1) + (UByteArrayInt__get_impl_px6q8a(h.j7m_1, 1) >> 4 & 1) | 0, 3) | 0) === 2, this);
        if (!(gr_info_0.b2().o7t_1 === 0)) {
          aa_bands = n_long_bands - 1 | 0;
          this.t7o(s.k7s_1[ch_0].s7s(imul(n_long_bands, 18)), s.m7s_1[0], gr_info_0.b2().g7t_1.s7s(gr_info_0.b2().n7t_1));
        }
        this.u7o(s.k7s_1[ch_0], aa_bands);
        this.b7p(s.k7s_1[ch_0], new FloatArrayPtr(h.f7m_1[ch_0]), gr_info_0.b2().l7t_1, n_long_bands);
        this.a7p(s.k7s_1[ch_0]);
        gr_info_0 = gr_info_0.s7s(1);
      }
       while (inductionVariable_0 < nch);
  }
  f7p(grbuf, n) {
    var g_sec = Companion_getInstance_12().z7q_1;
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(4), null);
    while (tmp < 4) {
      tmp_0[tmp] = new Float32Array(8);
      tmp = tmp + 1 | 0;
    }
    var t = tmp_0;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = grbuf.s7s(k);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 8)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var x0 = y.i1(imul(i, 18));
            var x1 = y.i1(imul(15 - i | 0, 18));
            var x2 = y.i1(imul(16 + i | 0, 18));
            var x3 = y.i1(imul(31 - i | 0, 18));
            var t0 = x0 + x3;
            var t1 = x1 + x2;
            var t2 = (x1 - x2) * g_sec[imul(3, i) + 0 | 0];
            var t3 = (x0 - x3) * g_sec[imul(3, i) + 1 | 0];
            t[0][i] = t0 + t1;
            t[1][i] = (t0 - t1) * g_sec[imul(3, i) + 2 | 0];
            t[2][i] = t3 + t2;
            t[3][i] = (t3 - t2) * g_sec[imul(3, i) + 2 | 0];
          }
           while (inductionVariable_0 < 8);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 4)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var x = t[i_0];
            var x0_0 = x[0];
            var x1_0 = x[1];
            var x2_0 = x[2];
            var x3_0 = x[3];
            var x4 = x[4];
            var x5 = x[5];
            var x6 = x[6];
            var x7 = x[7];
            var xt = x0_0 - x7;
            x0_0 = x0_0 + x7;
            x7 = x1_0 - x6;
            x1_0 = x1_0 + x6;
            x6 = x2_0 - x5;
            x2_0 = x2_0 + x5;
            x5 = x3_0 - x4;
            x3_0 = x3_0 + x4;
            x4 = x0_0 - x3_0;
            x0_0 = x0_0 + x3_0;
            x3_0 = x1_0 - x2_0;
            x1_0 = x1_0 + x2_0;
            x[0] = x0_0 + x1_0;
            x[4] = (x0_0 - x1_0) * 0.70710677;
            x5 = x5 + x6;
            x6 = (x6 + x7) * 0.70710677;
            x7 = x7 + xt;
            x3_0 = (x3_0 + x4) * 0.70710677;
            x5 = x5 - x7 * 0.19891237;
            x7 = x7 + x5 * 0.38268343;
            x5 = x5 - x7 * 0.19891237;
            x0_0 = xt - x6;
            xt = xt + x6;
            x[1] = (xt + x7) * 0.5097956;
            x[2] = (x4 + x3_0) * 0.5411961;
            x[3] = (x0_0 - x5) * 0.6013449;
            x[5] = (x0_0 + x5) * 0.8999762;
            x[6] = (x4 - x3_0) * 1.306563;
            x[7] = (xt - x7) * 2.5629156;
          }
           while (inductionVariable_1 < 4);
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < 7)
          do {
            var i_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            y.a7t(0, t[0][i_1]);
            y.a7t(18, t[2][i_1] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y.a7t(36, t[1][i_1] + t[1][i_1 + 1 | 0]);
            y.a7t(54, t[2][i_1 + 1 | 0] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y = y.s7s(72);
          }
           while (inductionVariable_2 < 7);
        y.a7t(0, t[0][7]);
        y.a7t(18, t[2][7] + t[3][7]);
        y.a7t(36, t[1][7]);
        y.a7t(54, t[3][7]);
      }
       while (inductionVariable < n);
  }
  g7p(sample) {
    if (sample >= 32766.5)
      return 32767;
    if (sample <= -32767.5)
      return -32768;
    var s = toShort(numberToInt(sample + 0.5));
    return toShort(s - toInt_0(s < 0, this) | 0);
  }
  h7p(pcm, nch, z) {
    var z_0 = z;
    var a = 0.0;
    a = a + (z_0.i1(896) - z_0.i1(0)) * 29.0;
    a = a + (z_0.i1(64) + z_0.i1(832)) * 213.0;
    a = a + (z_0.i1(768) - z_0.i1(128)) * 459.0;
    a = a + (z_0.i1(192) + z_0.i1(704)) * 2037.0;
    a = a + (z_0.i1(640) - z_0.i1(256)) * 5153.0;
    a = a + (z_0.i1(320) + z_0.i1(576)) * 6574.0;
    a = a + (z_0.i1(512) - z_0.i1(384)) * 37489.0;
    a = a + z_0.i1(448) * 75038.0;
    pcm.f7t(0, this.g7p(a));
    z_0 = z_0.s7s(2);
    a = z_0.i1(896) * 104.0;
    a = a + z_0.i1(768) * 1567.0;
    a = a + z_0.i1(640) * 9727.0;
    a = a + z_0.i1(512) * 64019.0;
    a = a + z_0.i1(384) * -9975.0;
    a = a + z_0.i1(256) * -45.0;
    a = a + z_0.i1(128) * 146.0;
    a = a + z_0.i1(0) * -5.0;
    pcm.f7t(imul(16, nch), this.g7p(a));
  }
  i7p(xl, dstl, nch, lins) {
    var xr = xl.s7s(imul(576, nch - 1 | 0));
    var dstr = dstl.s7s(nch - 1 | 0);
    var g_win = Companion_getInstance_12().b7r_1;
    var zlin = lins.s7s(960);
    var w = 0;
    zlin.a7t(60, xl.i1(288));
    zlin.a7t(61, xr.i1(288));
    zlin.a7t(62, xl.i1(0));
    zlin.a7t(63, xr.i1(0));
    zlin.a7t(124, xl.i1(289));
    zlin.a7t(125, xr.i1(289));
    zlin.a7t(126, xl.i1(1));
    zlin.a7t(127, xr.i1(1));
    this.h7p(dstr, nch, lins.s7s(60).s7s(1));
    this.h7p(dstr.s7s(imul(32, nch)), nch, lins.s7s(60).s7s(64).s7s(1));
    this.h7p(dstl, nch, lins.s7s(60));
    this.h7p(dstl.s7s(imul(32, nch)), nch, lins.s7s(60).s7s(64));
    var inductionVariable = 14;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var a = this.p7m_1;
        var b = this.q7m_1;
        zlin.a7t(imul(4, i), xl.i1(imul(18, 31 - i | 0)));
        zlin.a7t(imul(4, i) + 1 | 0, xr.i1(imul(18, 31 - i | 0)));
        zlin.a7t(imul(4, i) + 2 | 0, xl.i1(1 + imul(18, 31 - i | 0) | 0));
        zlin.a7t(imul(4, i) + 3 | 0, xr.i1(1 + imul(18, 31 - i | 0) | 0));
        zlin.a7t(imul(4, i + 16 | 0), xl.i1(1 + imul(18, 1 + i | 0) | 0));
        zlin.a7t(imul(4, i + 16 | 0) + 1 | 0, xr.i1(1 + imul(18, 1 + i | 0) | 0));
        zlin.a7t(imul(4, i - 16 | 0) + 2 | 0, xl.i1(imul(18, 1 + i | 0)));
        zlin.a7t(imul(4, i - 16 | 0) + 3 | 0, xr.i1(imul(18, 1 + i | 0)));
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            b[j] = 0.0;
            a[j] = 0.0;
          }
           while (inductionVariable_0 < 4);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 8)
          do {
            var n = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var _unary__edvuaz = w;
            w = _unary__edvuaz + 1 | 0;
            var w0 = g_win[_unary__edvuaz];
            var _unary__edvuaz_0 = w;
            w = _unary__edvuaz_0 + 1 | 0;
            var w1 = g_win[_unary__edvuaz_0];
            var vz = zlin.s7s(imul(4, i) - imul(n, 64) | 0);
            var vy = zlin.s7s(imul(4, i) - imul(15 - n | 0, 64) | 0);
            if ((n % 2 | 0) === 0) {
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < 4)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  b[j_0] = b[j_0] + vz.i1(j_0) * w1 + vy.i1(j_0) * w0;
                  a[j_0] = a[j_0] + vz.i1(j_0) * w0 - vy.i1(j_0) * w1;
                }
                 while (inductionVariable_2 < 4);
            } else {
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < 4)
                do {
                  var j_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  b[j_1] = b[j_1] + (vz.i1(j_1) * w1 + vy.i1(j_1) * w0);
                  a[j_1] = a[j_1] + (vy.i1(j_1) * w1 - vz.i1(j_1) * w0);
                }
                 while (inductionVariable_3 < 4);
            }
          }
           while (inductionVariable_1 < 8);
        dstr.f7t(imul(15 - i | 0, nch), this.g7p(a[1]));
        dstr.f7t(imul(17 + i | 0, nch), this.g7p(b[1]));
        dstl.f7t(imul(15 - i | 0, nch), this.g7p(a[0]));
        dstl.f7t(imul(17 + i | 0, nch), this.g7p(b[0]));
        dstr.f7t(imul(47 - i | 0, nch), this.g7p(a[3]));
        dstr.f7t(imul(49 + i | 0, nch), this.g7p(b[3]));
        dstl.f7t(imul(47 - i | 0, nch), this.g7p(a[2]));
        dstl.f7t(imul(49 + i | 0, nch), this.g7p(b[2]));
      }
       while (0 <= inductionVariable);
  }
  j7p(qmf_state, grbuf, nbands, nch, pcm, lins) {
    var i = 0;
    i = 0;
    while (i < nch) {
      this.f7p(grbuf.s7s(imul(576, i)), nbands);
      i = i + 1 | 0;
    }
    this.s7n(lins, qmf_state, 960);
    i = 0;
    while (i < nbands) {
      this.i7p(grbuf.s7s(i), pcm.s7s(imul(32, imul(nch, i))), nch, lins.s7s(imul(i, 64)));
      i = i + 2 | 0;
    }
    if (nch === 1) {
      i = 0;
      while (i < 960) {
        qmf_state.a7t(i, lins.i1(imul(nbands, 64) + i | 0));
        i = i + 2 | 0;
      }
    } else {
      this.s7n(qmf_state, lins.s7s(imul(nbands, 64)), 960);
    }
  }
  k7p(hdr, mp3_bytes, frame_bytes) {
    var i = 0;
    var inductionVariable = 0;
    if (inductionVariable < 10)
      do {
        var nmatch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        i = i + (this.b7o(hdr.s7s(i), frame_bytes) + this.c7o(hdr.s7s(i)) | 0) | 0;
        if ((i + 4 | 0) > mp3_bytes)
          return toInt_0(nmatch > 0, this);
        if (this.x7n(hdr, hdr.s7s(i)) === 0)
          return 0;
      }
       while (inductionVariable < 10);
    return 1;
  }
  l7p(mp3, mp3_bytes, free_format_bytes, ptr_frame_bytes) {
    var mp3_0 = mp3;
    var i = 0;
    var k = 0;
    i = 0;
    while (i < (mp3_bytes - 4 | 0)) {
      if (this.w7n(mp3_0)) {
        var frame_bytes = this.b7o(mp3_0, free_format_bytes[0]);
        var frame_and_padding = frame_bytes + this.c7o(mp3_0) | 0;
        k = 4;
        $l$loop: while (frame_bytes === 0 && k < 2304 && !((i + imul(2, toInt_0(k < (mp3_bytes - 4 | 0), this)) | 0) === 0)) {
          if (!(this.x7n(mp3_0, mp3_0.s7s(k)) === 0)) {
            var fb = k - this.c7o(mp3_0) | 0;
            var nextfb = fb + this.c7o(mp3_0.s7s(k)) | 0;
            if ((((i + k | 0) + nextfb | 0) + 4 | 0) > mp3_bytes || this.x7n(mp3_0, mp3_0.s7s(k).s7s(nextfb)) === 0) {
              k = k + 1 | 0;
              continue $l$loop;
            }
            frame_and_padding = k;
            frame_bytes = fb;
            free_format_bytes[0] = fb;
          }
          k = k + 1 | 0;
        }
        if (!(frame_bytes === 0) && !((i + toInt_0(frame_and_padding <= mp3_bytes, this) | 0) === 0) && !(this.k7p(mp3_0, mp3_bytes - i | 0, frame_bytes) === 0) || (i === 0 && frame_and_padding === mp3_bytes)) {
          ptr_frame_bytes[0] = frame_and_padding;
          return i;
        }
        free_format_bytes[0] = 0;
      }
      i = i + 1 | 0;
      mp3_0 = mp3_0.s7s(1);
    }
    ptr_frame_bytes[0] = 0;
    return mp3_bytes;
  }
  t7m(dec) {
    UByteArrayInt__set_impl_gn4532(dec.j7m_1, 0, 0);
  }
  l7n(dec, mp3, mp3_bytes, pcm, info) {
    var pcm_0 = pcm;
    var i = 0;
    var frame_size = new Int32Array(1);
    var success = 1;
    var bs_frame = this.s7m_1;
    var scratch = this.r7m_1;
    if (mp3_bytes > 4 && UByteArrayInt__get_impl_px6q8a(dec.j7m_1, 0) === 255 && !(this.x7n(new UByteArrayIntPtr(dec.j7m_1), mp3) === 0)) {
      frame_size[0] = this.b7o(mp3, dec.i7m_1[0]) + this.c7o(mp3) | 0;
      if (!(frame_size[0] === mp3_bytes) && ((frame_size[0] + 4 | 0) > mp3_bytes || this.x7n(mp3, mp3.s7s(frame_size[0])) === 0)) {
        frame_size[0] = 0;
      }
    }
    if (frame_size[0] === 0) {
      dec.h7m_1 = 0;
      dec.i7m_1[0] = 0;
      UByteArrayInt__fill$default_impl_mdydxi(dec.k7m_1, 0);
      UByteArrayInt__fill$default_impl_mdydxi(dec.j7m_1, 0);
      fill_0(dec.g7m_1, 0.0);
      fill_0(dec.f7m_1[0], 0.0);
      fill_0(dec.f7m_1[1], 0.0);
      i = this.l7p(mp3, mp3_bytes, dec.i7m_1, frame_size);
      if (frame_size[0] === 0 || !((i + toInt_0(frame_size[0] > mp3_bytes, this) | 0) === 0)) {
        info.b2().m7n_1 = i;
        return 0;
      }
    }
    var hdr = mp3.s7s(i);
    this.t7n(new UByteArrayIntPtr(dec.j7m_1), hdr, 4);
    info.b2().m7n_1 = i + frame_size[0] | 0;
    info.b2().n7n_1 = i;
    info.b2().o7n_1 = (hdr.i1(3) & 192) === 192 ? 1 : 2;
    info.b2().p7n_1 = this.z7n(hdr);
    info.b2().q7n_1 = 4 - (hdr.i1(1) >> 1 & 3) | 0;
    info.b2().r7n_1 = this.y7n(hdr);
    // Inline function 'kotlin.collections.isEmpty' call
    if (pcm_0.d7t_1.length === 0) {
      return this.a7o(hdr);
    }
    this.u7n(bs_frame, hdr.s7s(4), frame_size[0] - 4 | 0);
    if ((hdr.i1(1) & 1) === 0) {
      this.v7n(bs_frame, 16);
    }
    if (info.b2().q7n_1 === 3) {
      var main_data_begin = this.i7o(bs_frame, scratch.j7s_1, hdr);
      if (main_data_begin < 0 || bs_frame.f7s_1 > bs_frame.g7s_1) {
        this.t7m(dec);
        return 0;
      }
      success = this.d7p(dec, bs_frame, scratch, main_data_begin);
      if (!(success === 0)) {
        var igr = 0;
        while (igr < (!((hdr.i1(1) & 8) === 0) ? 2 : 1)) {
          scratch.k7s_1[0].c7t(0.0, 0, 1152);
          this.e7p(dec, scratch, scratch.j7s_1.s7s(imul(igr, info.b2().o7n_1)), info.b2().o7n_1);
          this.j7p(new FloatArrayPtr(dec.g7m_1), scratch.k7s_1[0], 18, info.b2().o7n_1, pcm_0, scratch.m7s_1[0]);
          igr = igr + 1 | 0;
          pcm_0 = pcm_0.s7s(imul(576, info.b2().o7n_1));
        }
      }
      this.c7p(dec, scratch);
    } else {
      var sci = new ScaleInfo();
      this.f7o(hdr, bs_frame, sci);
      scratch.k7s_1[0].c7t(0.0, 0, 1152);
      i = 0;
      var igr_0 = 0;
      while (igr_0 < 3) {
        i = i + this.g7o(scratch.k7s_1[0].s7s(i), bs_frame, sci, info.b2().q7n_1 | 1) | 0;
        if (12 === i) {
          i = 0;
          this.h7o(sci, (new FloatArrayPtr(sci.w7t_1)).s7s(igr_0), scratch.k7s_1[0]);
          this.j7p(new FloatArrayPtr(dec.g7m_1), scratch.k7s_1[0], 12, info.b2().o7n_1, pcm_0, scratch.m7s_1[0]);
          scratch.k7s_1[0].c7t(0.0, 0, 1152);
          pcm_0 = pcm_0.s7s(imul(384, info.b2().o7n_1));
        }
        if (bs_frame.f7s_1 > bs_frame.g7s_1) {
          this.t7m(dec);
          return 0;
        }
        igr_0 = igr_0 + 1 | 0;
      }
    }
    return imul(success, this.a7o(new UByteArrayIntPtr(dec.j7m_1)));
  }
}
class Minimp3Decoder extends MiniMp3Program {
  constructor() {
    super();
    this.b7m_1 = new Int16Array(9216);
    this.c7m_1 = Mp3Dec.l7m();
    this.d7m_1 = new Mp3FrameInfo();
    this.t7m(this.c7m_1);
    this.e7m_1 = new BaseMp3DecoderInfo();
  }
  u7m() {
    return this.e7m_1;
  }
  v7m(availablePeek) {
    var samples = this.l7n(this.c7m_1, new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu(this.e7m_1.w7m_1)), availablePeek, new ShortArrayPtr(this.b7m_1), this.d7m_1);
    var struct = this.d7m_1;
    this.e7m_1.b7n_1 = struct.o7n_1;
    this.e7m_1.z7m_1 = struct.p7n_1;
    this.e7m_1.a7n_1 = struct.r7n_1;
    this.e7m_1.d7n_1 = struct.m7n_1;
    this.e7m_1.c7n_1 = samples;
    if (this.e7m_1.b7n_1 === 0 || samples <= 0)
      return null;
    return copyOf(this.b7m_1, imul(samples, this.e7m_1.b7n_1));
  }
  u6() {
  }
}
class BaseMinimp3AudioFormat extends AudioFormat {
  constructor() {
    Companion_getInstance_11();
    super(['mp3']);
  }
  d7j(data, props, $completion) {
    return Companion_getInstance_7().d7j(data, props, $completion);
  }
  i7j(data, props, $completion) {
    return createDecoderStream(this, data, props, null, $completion);
  }
}
class Minimp3AudioFormat extends BaseMinimp3AudioFormat {
  constructor() {
    Minimp3AudioFormat_instance = null;
    super();
    Minimp3AudioFormat_instance = this;
  }
  n7p() {
    return new Minimp3Decoder();
  }
}
class BaseMp3DecoderInfo {
  constructor() {
    this.w7m_1 = new Int8Array(4608);
    this.x7m_1 = new ByteArrayDeque();
    this.y7m_1 = null;
    this.z7m_1 = 0;
    this.a7n_1 = 0;
    this.b7n_1 = 0;
    this.c7n_1 = 0;
    this.d7n_1 = 0;
    this.e7n_1 = 0;
    this.f7n_1 = 0;
    this.g7n_1 = 0;
    this.h7n_1 = 0;
    this.i7n_1 = 0;
    this.j7n_1 = 0;
    this.k7n_1 = 0;
  }
  z33() {
    var tmp11_safe_receiver = this.y7m_1;
    if (tmp11_safe_receiver == null)
      null;
    else {
      tmp11_safe_receiver.o3();
    }
    this.x7m_1.o3();
    this.e7n_1 = 0;
    this.f7n_1 = -1;
    this.h7n_1 = 0;
  }
  g7q(decoder) {
    var availablePeek = this.x7m_1.x12(this.w7m_1, 0, this.w7m_1.length);
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOf(this.w7m_1, Companion_getInstance_11().h7q_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.audio.format.BaseMp3DecoderInfo.step.<anonymous>' call
    if (this_0 >= 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var xingIndex = tmp0_elvis_lhs == null ? this.w7m_1.length : tmp0_elvis_lhs;
    // Inline function 'kotlin.takeIf' call
    var this_1 = indexOf(this.w7m_1, Companion_getInstance_11().i7q_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.audio.format.BaseMp3DecoderInfo.step.<anonymous>' call
    if (this_1 >= 0) {
      tmp_0 = this_1;
    } else {
      tmp_0 = null;
    }
    var tmp1_elvis_lhs = tmp_0;
    var infoIndex = tmp1_elvis_lhs == null ? this.w7m_1.length : tmp1_elvis_lhs;
    if (xingIndex < this.w7m_1.length || infoIndex < this.w7m_1.length) {
      try {
        // Inline function 'kotlin.math.min' call
        var index = Math.min(xingIndex, infoIndex);
        var data = new FastByteArrayInputStream(this.w7m_1, index);
        data.zy(7);
        if (data.oy() >= 1) {
          var flags = data.z1q();
          var FRAMES_FLAG = 1;
          var BYTES_FLAG = 2;
          var TOC_FLAG = 4;
          var VBR_SCALE_FLAG = 8;
          if (hasFlags(flags, FRAMES_FLAG) && data.oy() >= 4) {
            this.i7n_1 = data.f1r();
            if (hasFlags(flags, BYTES_FLAG)) {
              data.zy(4);
            }
            if (hasFlags(flags, TOC_FLAG)) {
              data.zy(100);
            }
            if (hasFlags(flags, VBR_SCALE_FLAG)) {
              data.zy(4);
            }
            if (data.oy() >= 1) {
              var info = data.z1q();
              if (!(info === 0)) {
                data.zy(20);
                if (data.oy() >= 3) {
                  var t0 = data.z1q();
                  var t1 = data.z1q();
                  var t2 = data.z1q();
                  this.j7n_1 = (t0 << 4 | (t1 >>> 4 | 0)) + 529 | 0;
                  this.k7n_1 = ((t1 & 15) << 8 | t2) - 529 | 0;
                }
              }
            }
          }
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
    }
    var buf = decoder.v7m(availablePeek);
    if (!(this.b7n_1 === 0) && (!(this.i7n_1 === 0) || !(this.j7n_1 === 0) || !(this.k7n_1 === 0))) {
      var rpadding = imul(this.k7n_1, this.b7n_1);
      var to_skip = imul(this.j7n_1, this.b7n_1);
      var detected_samples = imul(imul(this.c7n_1, this.i7n_1), this.b7n_1);
      if (detected_samples >= to_skip)
        detected_samples = detected_samples - to_skip | 0;
      if (1 <= rpadding ? rpadding <= detected_samples : false)
        detected_samples = detected_samples - rpadding | 0;
      this.e7n_1 = to_skip + imul(this.c7n_1, this.b7n_1) | 0;
      this.f7n_1 = detected_samples;
      this.g7n_1 = detected_samples / this.b7n_1 | 0;
      this.i7n_1 = 0;
      this.j7n_1 = 0;
      this.k7n_1 = 0;
    }
    if (!(this.b7n_1 === 0) && this.y7m_1 == null) {
      this.y7m_1 = new AudioSamplesDeque(this.b7n_1);
    }
    if (this.c7n_1 > 0) {
      var offset = 0;
      var toRead = imul(this.c7n_1, this.b7n_1);
      if (this.e7n_1 > 0) {
        // Inline function 'kotlin.math.min' call
        var a = this.e7n_1;
        var b = toRead;
        var skipNow = Math.min(a, b);
        offset = offset + skipNow | 0;
        toRead = toRead - skipNow | 0;
        this.e7n_1 = this.e7n_1 - skipNow | 0;
      }
      if (this.f7n_1 >= 0) {
        // Inline function 'kotlin.math.min' call
        var a_0 = toRead;
        var b_0 = this.f7n_1;
        toRead = Math.min(a_0, b_0);
        this.f7n_1 = this.f7n_1 - toRead | 0;
      }
      ensureNotNull(this.y7m_1).j7q(ensureNotNull(buf), offset, toRead);
    }
    this.x7m_1.oz(this.d7n_1);
    if (this.d7n_1 === 0 && this.c7n_1 === 0) {
      return false;
    }
    if (!(this.y7m_1 == null) && ensureNotNull(this.y7m_1).i12() > 0) {
      return true;
    }
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_7 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.h7q_1 = new Int8Array([88, 105, 110, 103]);
    var tmp_0 = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0.i7q_1 = new Int8Array([73, 110, 102, 111]);
  }
}
class AudioStream {
  constructor(rate, channels, $box) {
    boxApply(this, $box);
    this.o7q_1 = rate;
    this.p7q_1 = channels;
    this.q7q_1 = false;
    this.r7q_1 = null;
    this.s7q_1 = new Long(0, 0);
  }
  k7q() {
    return this.q7q_1;
  }
  l7q(_set____db54di) {
    this.s7q_1 = _set____db54di;
  }
  t7q(value) {
    this.l7q(this.u7q(value));
  }
  u7q(time) {
    return numberToLong(get_seconds(time) * this.o7q_1);
  }
  m7q(out, offset, length, $completion) {
    return 0;
  }
  u6() {
    return Unit_instance;
  }
}
class BaseMinimp3AudioFormat$createDecoderStream$2 extends AudioStream {
  constructor($decoder, $mp3SeekingTable, $data, this$0, $dataStartPosition, $props, $table, $box) {
    if ($box === VOID)
      $box = {};
    $box.w7p_1 = $decoder;
    $box.x7p_1 = $mp3SeekingTable;
    $box.y7p_1 = $data;
    $box.z7p_1 = this$0;
    $box.a7q_1 = $dataStartPosition;
    $box.b7q_1 = $props;
    $box.c7q_1 = $table;
    super($decoder.u7m().z7m_1, $decoder.u7m().b7n_1, $box);
    this.t7p_1 = false;
    var tmp = this;
    // Inline function 'kotlin.takeIf' call
    var this_0 = toLong($decoder.u7m().g7n_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.audio.format.<no name provided>.totalLengthInSamples.<anonymous>' call
    if (!this_0.equals(new Long(0, 0))) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      tmp_1 = $mp3SeekingTable == null ? null : $mp3SeekingTable.n7l();
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    tmp.u7p_1 = tmp_1;
    this.v7p_1 = new Long(0, 0);
  }
  k7q() {
    return this.t7p_1;
  }
  l7q(value) {
    this.t7p_1 = false;
    if (!(this.x7p_1 == null)) {
      this.y7p_1.t1t_1 = this.x7p_1.p7l(value);
      this.v7p_1 = value;
    } else {
      this.y7p_1.t1t_1 = new Long(0, 0);
      this.v7p_1 = new Long(0, 0);
    }
    this.w7p_1.u7m().z33();
  }
  m7q(out, offset, length, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe(this, out, offset, length, $completion), $completion);
  }
  u6() {
    this.w7p_1.u6();
  }
  n7q($completion) {
    // Inline function 'kotlin.also' call
    var this_0 = this.y7p_1.r1u();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.<no name provided>.clone.<anonymous>' call
    this_0.t1t_1 = this.a7q_1;
    return createDecoderStream(this.z7p_1, this_0, this.b7q_1, this.c7q_1, $completion);
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_8 = this;
    this.v7q_1 = 2304;
    this.w7q_1 = 511;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.x7q_1 = new Float32Array([0.7372773, 0.7933533, 0.8433915, 0.8870108, 0.9238795, 0.95371693, 0.976296, 0.9914449, 0.99904823, 0.6755902, 0.6087614, 0.53729963, 0.4617486, 0.38268343, 0.3007058, 0.2164396, 0.13052619, 0.04361938]);
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.y7q_1 = new Float32Array([0.7933533, 0.9238795, 0.9914449, 0.6087614, 0.38268343, 0.13052619]);
    var tmp_1 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_1.z7q_1 = new Float32Array([10.190008, 0.500603, 0.5024193, 3.4076085, 0.50547093, 0.5224986, 2.057781, 0.5154473, 0.56694406, 1.4841646, 0.5310426, 0.6468218, 1.1694399, 0.5531039, 0.7881546, 0.9725682, 0.582935, 1.0606776, 0.8393496, 0.6225041, 1.7224472, 0.7445363, 0.6748083, 5.1011486]);
    var tmp_2 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_2.a7r_1 = new Float32Array([0.0, 1.0, 0.21132487, 0.7886751, 0.3660254, 0.6339746, 0.5, 0.5, 0.6339746, 0.3660254, 0.7886751, 0.21132487, 1.0, 0.0]);
    var tmp_3 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_3.b7r_1 = new Float32Array([-1.0, 26.0, -31.0, 208.0, 218.0, 401.0, -519.0, 2063.0, 2000.0, 4788.0, -5517.0, 7134.0, 5959.0, 35640.0, -39336.0, 74992.0, -1.0, 24.0, -35.0, 202.0, 222.0, 347.0, -581.0, 2080.0, 1952.0, 4425.0, -5879.0, 7640.0, 5288.0, 33791.0, -41176.0, 74856.0, -1.0, 21.0, -38.0, 196.0, 225.0, 294.0, -645.0, 2087.0, 1893.0, 4063.0, -6237.0, 8092.0, 4561.0, 31947.0, -43006.0, 74630.0, -1.0, 19.0, -41.0, 190.0, 227.0, 244.0, -711.0, 2085.0, 1822.0, 3705.0, -6589.0, 8492.0, 3776.0, 30112.0, -44821.0, 74313.0, -1.0, 17.0, -45.0, 183.0, 228.0, 197.0, -779.0, 2075.0, 1739.0, 3351.0, -6935.0, 8840.0, 2935.0, 28289.0, -46617.0, 73908.0, -1.0, 16.0, -49.0, 176.0, 228.0, 153.0, -848.0, 2057.0, 1644.0, 3004.0, -7271.0, 9139.0, 2037.0, 26482.0, -48390.0, 73415.0, -2.0, 14.0, -53.0, 169.0, 227.0, 111.0, -919.0, 2032.0, 1535.0, 2663.0, -7597.0, 9389.0, 1082.0, 24694.0, -50137.0, 72835.0, -2.0, 13.0, -58.0, 161.0, 224.0, 72.0, -991.0, 2001.0, 1414.0, 2330.0, -7910.0, 9592.0, 70.0, 22929.0, -51853.0, 72169.0, -2.0, 11.0, -63.0, 154.0, 221.0, 36.0, -1064.0, 1962.0, 1280.0, 2006.0, -8209.0, 9750.0, -998.0, 21189.0, -53534.0, 71420.0, -2.0, 10.0, -68.0, 147.0, 215.0, 2.0, -1137.0, 1919.0, 1131.0, 1692.0, -8491.0, 9863.0, -2122.0, 19478.0, -55178.0, 70590.0, -3.0, 9.0, -73.0, 139.0, 208.0, -29.0, -1210.0, 1870.0, 970.0, 1388.0, -8755.0, 9935.0, -3300.0, 17799.0, -56778.0, 69679.0, -3.0, 8.0, -79.0, 132.0, 200.0, -57.0, -1283.0, 1817.0, 794.0, 1095.0, -8998.0, 9966.0, -4533.0, 16155.0, -58333.0, 68692.0, -4.0, 7.0, -85.0, 125.0, 189.0, -83.0, -1356.0, 1759.0, 605.0, 814.0, -9219.0, 9959.0, -5818.0, 14548.0, -59838.0, 67629.0, -4.0, 7.0, -91.0, 117.0, 177.0, -106.0, -1428.0, 1698.0, 402.0, 545.0, -9416.0, 9916.0, -7154.0, 12980.0, -61289.0, 66494.0, -5.0, 6.0, -97.0, 111.0, 163.0, -127.0, -1498.0, 1634.0, 185.0, 288.0, -9585.0, 9838.0, -8540.0, 11455.0, -62684.0, 65290.0]);
    var tmp_4 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_5 = new Float32Array([0.8574929, 0.881742, 0.94962865, 0.9833146, 0.9955178, 0.9991606, 0.9998992, 0.99999315]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4.c7r_1 = [tmp_5, new Float32Array([0.51449573, 0.47173196, 0.31337744, 0.1819132, 0.09457419, 0.04096558, 0.01419856, 0.00369997])];
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_7 = new Float32Array([0.99904823, 0.9914449, 0.976296, 0.95371693, 0.9238795, 0.8870108, 0.8433915, 0.7933533, 0.7372773, 0.04361938, 0.13052619, 0.2164396, 0.3007058, 0.38268343, 0.4617486, 0.53729963, 0.6087614, 0.6755902]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_6.d7r_1 = [tmp_7, new Float32Array([1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.9914449, 0.9238795, 0.7933533, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.13052619, 0.38268343, 0.6087614])];
    var tmp_8 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_8.e7r_1 = new Float32Array([9.313226E-10, 7.831458E-10, 6.585445E-10, 5.537677E-10]);
    var tmp_9 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_9.f7r_1 = new Float32Array([9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 7.0, 7.569318E-7 / 7.0, 6.007772E-7 / 7.0, 9.536743E-7 / 15.0, 7.569318E-7 / 15.0, 6.007772E-7 / 15.0, 9.536743E-7 / 31.0, 7.569318E-7 / 31.0, 6.007772E-7 / 31.0, 9.536743E-7 / 63.0, 7.569318E-7 / 63.0, 6.007772E-7 / 63.0, 9.536743E-7 / 127.0, 7.569318E-7 / 127.0, 6.007772E-7 / 127.0, 9.536743E-7 / 255.0, 7.569318E-7 / 255.0, 6.007772E-7 / 255.0, 9.536743E-7 / 511.0, 7.569318E-7 / 511.0, 6.007772E-7 / 511.0, 9.536743E-7 / 1023.0, 7.569318E-7 / 1023.0, 6.007772E-7 / 1023.0, 9.536743E-7 / 2047.0, 7.569318E-7 / 2047.0, 6.007772E-7 / 2047.0, 9.536743E-7 / 4095.0, 7.569318E-7 / 4095.0, 6.007772E-7 / 4095.0, 9.536743E-7 / 8191.0, 7.569318E-7 / 8191.0, 6.007772E-7 / 8191.0, 9.536743E-7 / 16383.0, 7.569318E-7 / 16383.0, 6.007772E-7 / 16383.0, 9.536743E-7 / 32767.0, 7.569318E-7 / 32767.0, 6.007772E-7 / 32767.0, 9.536743E-7 / 65535.0, 7.569318E-7 / 65535.0, 6.007772E-7 / 65535.0, 9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 5.0, 7.569318E-7 / 5.0, 6.007772E-7 / 5.0, 9.536743E-7 / 9.0, 7.569318E-7 / 9.0, 6.007772E-7 / 9.0]);
    var tmp_10 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_10.g7r_1 = new Int32Array([44100, 48000, 32000]);
    var tmp_11 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_12 = [new UByteArrayInt(arrayOfUByte$default(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x18\x1C (08@HPX`p\x80'))];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_11.h7r_1 = [tmp_12, [new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x14\x18\x1C (08@P`p\x80\xA0')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x18\x1C (08@P`p\x80\xA0\xC0')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10 0@P`p\x80\x90\xA0\xB0\xC0\xD0\xE0'))]];
    this.i7r_1 = arrayOfUByte$default(this, '\x00\x01\x02\x03\f\x05\x06\x07\t\n\x0B\r\x0E\x0F\x12\x13');
    this.j7r_1 = arrayOfUByte$default(this, '\x05\x05\x04\x04\x05\x05\x04\x01\x04\x03\x01\x01\x05\x06\x06\x01\x04\x04\x04\x01\x04\x03\x01\x01');
    this.k7r_1 = arrayOfUByte$default(this, '\x01\x01\x01\x01\x02\x02\x03\x03\x03\x02');
    this.l7r_1 = arrayOfShort$default(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFF01\u0521\u0512\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0122\u0120\uFF01\u0521\u0512\u0502\u0301\u0301\u0301\u0301\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0122\u0120\uFF03\uFEC2\uFEA1\uFE91\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0333\u0332\u0223\u0223\u0113\u0113\u0113\u0113\u0231\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF02\uFEE1\u0531\u0513\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0310\u0310\u0310\u0310\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\u0233\u0230\u0132\u0132\u0123\u0103\uFF04\uFE63\uFE23\uFDE2\u0512\uFDC1\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE81\uFE71\u0453\u0444\u0452\u0425\u0351\u0351\u0315\u0315\u0450\u0443\u0305\u0305\u0434\u0433\u0155\u0154\u0145\u0135\u0342\u0324\u0241\u0241\u0214\u0214\u0204\u0204\u0340\u0332\u0323\u0330\u0231\u0231\u0213\u0213\u0203\u0222\u0121\u0121\u0120\u0102\uFF04\uFE53\uFE13\uFDD1\u0421\u0421\u0412\u0412\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\uFE82\u0435\uFE61\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0433\u0342\u0342\u0255\u0245\u0154\u0154\u0153\u0144\u0324\u0341\u0214\u0214\u0340\u0304\u0332\u0323\u0331\u0313\u0330\u0303\u0122\u0122\u0122\u0122\u0120\u0102\uFF03\uFEA3\uFE62\uFE41\uFE31\u0531\u0513\uFE21\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\uFEC1\u0353\u0335\uFEB1\u0344\u0352\u0325\u0351\u0155\u0154\u0145\u0150\u0215\u0215\u0243\u0243\u0234\u0234\u0305\u0340\u0242\u0224\u0233\u0204\u0141\u0114\u0132\u0123\u0130\u0103\uFF05\uFDC4\uFD23\uFCC2\uFCA1\uFC91\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\u0574\u0547\u0565\u0556\u0573\u0537\u0564\uFDD1\u0536\u0472\u0472\u0427\u0427\u0546\u0570\u0407\u0407\u0426\u0426\u0554\u0553\u0460\u0460\u0535\u0544\u0371\u0371\u0371\u0371\u0177\u0176\u0167\u0175\u0157\u0166\u0155\u0145\u0317\u0317\u0463\u0462\uFD41\u0451\u0415\uFD31\u0361\u0361\u0316\u0316\u0306\u0306\u0450\u0405\u0152\u0125\u0143\u0134\uFCE1\uFCD1\u0341\u0314\u0304\u0332\u0323\u0330\u0142\u0124\u0133\u0140\u0231\u0213\u0203\u0222\u0121\u0112\u0120\u0102\uFF05\uFDF3\uFDA3\uFD53\uFD03\uFCC1\uFCB2\u0512\u0421\u0421\u0520\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0577\u0576\u0567\u0557\u0566\u0574\u0547\uFE01\u0565\u0556\u0473\u0473\u0437\u0437\u0464\u0464\u0554\u0545\u0553\u0535\u0372\u0372\u0372\u0372\u0327\u0327\u0327\u0327\u0446\u0446\u0470\u0470\u0175\u0155\u0217\u0217\u0371\u0307\u0363\u0336\u0306\uFDB1\u0144\u0152\uFD61\u0351\u0226\u0226\u0362\u0360\u0261\u0261\u0125\u0150\u0216\u0216\u0315\u0343\u0305\uFD11\u0342\u0324\u0134\u0133\u0341\u0314\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\uFF04\uFE73\uFE23\uFDD3\uFD92\uFD73\uFD31\uFD21\uFD12\u0531\u0513\u0522\u0421\u0421\u0412\u0412\u0520\u0502\u0400\u0400\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\uFE81\u0467\u0475\u0457\u0466\u0474\u0447\u0456\u0365\u0365\u0373\u0373\u0437\u0455\u0372\u0372\u0177\u0176\u0327\u0364\u0346\u0371\u0317\uFE31\u0363\u0336\u0170\u0107\u0354\u0345\u0344\uFDE1\u0262\u0262\u0226\u0226\u0160\u0150\u0216\u0216\u0361\u0306\u0353\u0335\u0352\u0325\u0251\u0215\u0243\u0234\u0305\u0340\u0242\u0242\u0224\u0224\u0241\u0241\u0133\u0114\u0132\u0123\u0204\u0230\u0103\u0103\uFF06\uF7C5\uF635\uF534\uF4A3\uF462\uF441\uF431\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFD01\uFBE4\uFB43\uFB03\uFAB2\uFA83\uFA43\uFA01\uF9F2\uF9D2\uF9B2\uF991\uF982\uF962\uF942\uF921\uF912\uF8F1\uF8E2\uF8C2\uF8A2\u061D\uF881\uF871\uF861\uF851\u06C3\u06C2\u062C\u06B5\uF841\u06C1\u061C\uF831\u060C\uF821\uF811\u06B3\u063B\uF801\u06B2\uF7F1\u064A\uF7E1\u0649\uF7D1\u052B\u052B\u05B1\u05B1\u051B\u051B\u06B0\u060B\u0669\u06A4\u06A3\u063A\u0695\u0659\u05A2\u05A2\u052A\u052A\uFCF4\uFC33\uFC72\u04FF\u04FE\u04FD\u04EE\u04FC\u04ED\u04FB\u04BF\u04EC\u04CD\uFC41\u03CE\u03CE\u03DD\u03DD\uFC51\u02DF\u01DE\u01DE\u01EF\u01CF\u01FA\u019E\uFBF1\u03EB\u03BE\u03F9\u039F\u03AE\u03DB\u03BD\u01AF\u01DC\u04F8\u048F\u04CC\uFB61\u04E8\uFB51\u037F\u037F\u03AD\u03AD\u04DA\u04CB\u04BC\u046F\u03F6\u03F6\u01EA\u01E9\u01F7\u01E7\u038E\u03F5\u03D9\u039D\u035F\u037E\u03CA\u03BB\u03F4\u034F\uFAC1\u033F\u02F3\u02F3\u03D8\u038D\u01AC\u016E\u02F2\u022F\uFA91\u02F0\u01E6\u01C9\u039C\u03E5\u02BA\u02BA\u03D7\u037D\u02E4\u02E4\u038C\u036D\u02E3\u02E3\u029B\u029B\u03B9\u03AA\u01F1\u011F\u010F\u010F\u02AB\u025E\u024E\u02C8\u02D6\u023E\u012E\u012E\u02E2\u02E0\u01E1\u011E\u020E\u02D5\u025D\u02C7\u027C\u02D4\u02B8\u028B\u024D\u02A9\u029A\u02C6\u016C\u01D3\u023D\u02B7\u01D2\u01D2\u012D\u01D1\u017B\u017B\u02C5\u025C\u0299\u02A7\u013C\u013C\u027A\u0279\u01B4\u01B4\u01D0\u010D\u01A8\u018A\u01C4\u014C\u01B6\u016B\u015B\u0198\u0189\u01C0\u014B\u01A6\u016A\u0197\u0188\u01A5\u015A\u0196\u0187\u0178\u0177\u0167\u05A1\u051A\uF6C1\u050A\uF6B1\u0539\uF6A1\uF691\u0592\u0529\uF681\u0583\u0538\uF671\uF661\uF651\u0491\u0491\u0419\u0419\u0590\u0509\u0584\u0548\u0527\uF641\u0482\u0482\u0428\u0428\u0481\u0481\u01A0\u0186\u0168\u0194\u0193\u0185\u0158\u0176\u0175\u0157\u0166\u0174\u0147\u0165\u0156\u0137\u0164\u0146\u0573\u0572\u0471\u0471\u0417\u0417\u0555\u0570\u0507\u0563\u0536\u0554\u0545\u0562\u0526\u0553\u0318\u0318\u0318\u0318\u0480\u0480\u0408\u0408\u0461\u0461\u0416\u0416\u0460\u0460\u0406\u0406\uF4B1\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0135\u0144\u0214\u0214\u0340\u0304\u0332\u0323\u0231\u0231\u0213\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF06\uFB65\uF9D5\uF8D4\uF834\uF7B4\uF733\uF6E3\uF693\uF653\uF612\uF5F2\uF5D1\uF5C2\uF5A1\u0522\u0521\u0512\u0520\u0502\u0311\u0311\u0311\u0311\u0410\u0410\u0401\u0401\u0300\u0300\u0300\u0300\uFD02\uFCE2\uFCC2\uFCA2\uFC81\uFC71\uFC61\uFC51\uFC41\uFC31\uFC21\uFC11\uFC01\uFBF1\uFBE1\uFBD2\u06BC\u066F\uFBB1\uFBA1\u065F\u06E7\u067E\u06CA\u06AC\u06BB\uFB91\u06F4\u064F\u06F3\u063F\u068D\u066E\u06F2\u062F\uFB81\u06F1\u061F\u06C9\u069C\u06E5\u06BA\u06AB\u065E\u06D7\u067D\u06E4\u064E\u06C8\u068C\u06E3\u06D6\u066D\u063E\u06B9\u069B\u06E2\u06AA\u062E\u06E1\u061E\uFB71\u06D5\u065D\u02FF\u02FE\u02EF\u02FD\u01EE\u01EE\u02DF\u02FC\u02CF\u02ED\u02DE\u02FB\u01BF\u01BF\u02EC\u02CE\u01DD\u01FA\u01AF\u01EB\u01BE\u01DC\u01CD\u01F9\u019F\u01AE\u01DB\u01BD\u01F8\u018F\u01CC\u01E9\u019E\u01F7\u017F\u01DA\u01AD\u01CB\u01F6\u01F6\u02EA\u02F0\u01E8\u018E\u01F5\u01D9\u019D\u01D8\u01E6\u010F\u01E0\u010E\uFA61\uFA51\u054D\uFA41\uFA31\uFA21\u053D\u052D\uFA11\u05D1\u05B7\u057B\u051D\uFA01\u055C\u05A8\u058A\u05C4\u054C\u05B6\u056B\uF9F1\u05C3\u053C\u05A7\u057A\u056A\uF9E1\u042C\u042C\u05C2\u05B5\u01C7\u017C\u01D4\u01B8\u018B\u01A9\u019A\u01C6\u016C\u01D3\u01D2\u01D0\u01C5\u010D\u0199\u01C0\u010C\u01B0\u055B\u05C1\u0598\u0589\u051C\u05B4\u054B\u05A6\u05B3\u0597\u043B\u043B\u0579\u0588\u05B2\u05A5\u042B\u042B\u055A\u05B1\u041B\u041B\u050B\u0596\u0569\u05A4\u054A\u0587\u0578\u05A3\u043A\u043A\u0495\u0459\u04A2\u042A\u04A1\u041A\uF851\u0486\u0468\u0494\u0449\u0493\u0439\uF841\u0485\u0458\u01A0\u010A\u0177\u0190\u0492\u0476\u0467\u0429\u0319\u0319\u0491\u0409\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0474\u0382\u0382\u0328\u0328\u0381\u0381\u0318\u0318\u0447\u0480\u0408\u0465\u0456\u0473\u0437\u0464\u0372\u0327\u0346\u0371\u0355\u0317\uF6F1\u0363\u0170\u0107\u0336\u0354\u0345\u0362\u0326\u0361\uF6A1\u0353\u0160\u0106\u0216\u0216\u0335\u0344\u0252\u0252\u0225\u0225\u0251\u0251\u0215\u0215\u0350\u0305\u0243\u0243\u0234\u0242\u0224\u0233\u0114\u0114\u0241\u0240\u0132\u0123\u0204\u0230\u0131\u0131\u0113\u0103\uFF05\uFC84\uF7F6\uF5C4\uF4F4\uF473\uF431\uF421\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\uFDD1\u05FA\uFDC1\uFDB1\u05F8\u05F7\u057F\u05F6\u056F\u03FF\u03FF\u03FF\u03FF\u05F5\u055F\u04F4\u04F4\u044F\u044F\u043F\u043F\u040F\u040F\u05F3\uFDA4\u032F\u032F\u032F\u032F\u01FE\u01EF\u01FD\u01DF\u01FC\u01CF\u01FB\u01BF\u01AF\u01F9\u019F\u018F\uFD22\uFCF2\u04EE\uFCD1\u04EB\u04DC\uFCC1\u04EA\u04CC\uFCB1\uFCA1\u04AC\uFC91\u04E5\u03DB\u03DB\u02EC\uFD01\u01ED\u01ED\u01CE\u01DD\u019E\u019E\u02AE\u029D\u01DE\u01BE\u01CD\u01BD\u01DA\u01AD\u01E7\u01CA\u019C\u01D7\u04F2\u04F0\u03F1\u03F1\u031F\u031F\uFC05\uFB04\uFA54\uF9D3\uF973\uF923\uF8E3\uF8A2\uF873\uF833\u04E9\u04E9\u05CB\u05BC\u05E8\u058E\u05D9\u057E\u05BB\u05D8\u058D\u05E6\u046E\u046E\u04C9\u04C9\u05BA\u05AB\u055E\u057D\u04E4\u04E4\u054E\u05C8\u048C\u048C\u04E3\u04E3\u04D6\u04D6\u056D\u05B9\uFA81\u041E\u044D\uFA71\u04B7\uFA61\u033E\u033E\u04E0\u040E\u04D5\u045D\u04C7\u047C\u04D4\u04B8\u019B\u01AA\u018B\u019A\u017B\u010D\u04A9\u04C6\u046C\u04D3\u04C5\u045C\u03D0\u03D0\u04A8\u048A\u0499\u04C4\u046B\u04A7\u03C3\u03C3\uF991\u03C1\u030C\uF981\u022E\u022E\u03E2\u03E1\u01B5\u0198\u0189\u0197\u033D\u03D2\u032D\u031D\u03B3\uF931\u02D1\u02D1\u0179\u0188\u034C\u03B6\u033C\u037A\u02C2\u02C2\u032C\u035B\u031C\u03C0\u03B4\u034B\u03A6\u036A\u023B\u023B\uF881\u02B2\u022B\u02B1\u01A5\u015A\u021B\u021B\u03B0\u030B\u0396\u0369\u03A4\u034A\u0387\u0378\u023A\u023A\u03A3\u0395\u02A2\u02A2\uF5F1\u061A\uF5E1\u0649\uF5D1\u0676\u052A\u052A\u05A1\u05A1\u06A0\u060A\u0693\u0639\u0685\u0658\u0592\u0592\u0529\u0529\u0667\u0690\u0591\u0591\u0519\u0519\u0609\u0684\u0648\u0657\u0683\u0638\u0666\u0682\u0528\u0528\u0674\u0647\u0581\u0581\u0518\u0518\u0508\u0508\u0680\u0665\u0573\u0573\u0537\u0537\u0656\u0664\u0572\u0572\u0527\u0527\u0646\u0655\u0570\u0570\u0471\u0471\u0471\u0471\u0159\u0186\u0168\u0177\u0194\u0175\u0417\uF541\uF531\uF521\u0426\u0461\u0416\uF511\u0435\uF501\u0452\u0425\u0315\u0315\u0451\u0450\u0107\u0163\u0136\u0154\u0145\u0162\u0160\u0106\u0153\u0144\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0314\u0314\u0440\u0404\u0332\u0332\u0323\u0323\u0231\u0231\u0213\u0213\u0330\u0303\u0222\u0222\u0121\u0112\u0120\u0102\uFF03\uFEC3\uFE83\uFE42\uFE22\uFE03\u04FF\u04FF\uFCD5\uFB65\uFA55\uF924\uF894\uF814\uF773\uF733\uF6E3\uF692\uF673\uF631\uF622\u0521\u0512\uF601\u0411\u0411\u0410\u0410\u0401\u0401\u0400\u0400\u03FE\u03EF\u03FD\u03DF\u03FC\u03CF\u03FB\u03BF\u02AF\u02AF\u03FA\u03F9\u029F\u029F\u028F\u028F\u03F8\u03F7\u027F\u027F\u02F6\u02F6\u026F\u026F\u02F5\u025F\u02F4\u024F\u02F3\u023F\u02F2\u022F\u021F\u021F\u03F1\u030F\uFDC1\uFD93\uFD53\uFD13\u01F0\uFDB2\u02EE\u02ED\u02DE\u02EC\u03CE\u03DD\u03EB\u03BE\u03DC\u03CD\u03EA\u03AE\u03DB\u03BD\u03CC\u03E9\u039E\u03DA\u03AD\u03CB\u03BC\u03E8\u038E\u03D9\u039D\u03E7\u037E\u03CA\uFBD1\uFBC1\uFBB2\u056E\uFB91\u059C\u05E5\u05AB\u055E\uFB81\u057D\u054E\u05C8\u058C\uFB71\u05E3\u05D6\u056D\u053E\u05B9\u059B\u05AA\u052E\u05E1\u051E\u05D5\u055D\u05C7\u057C\u05D4\u05B8\u058B\u01AC\u01BB\u01D8\u018D\u02E0\u020E\u01D0\u01D0\u01E6\u01C9\u01BA\u01D7\u01E4\u01E2\u054D\u05A9\u059A\u05C6\u056C\u05D3\u053D\u05D2\u052D\u05D1\u05B7\u057B\u051D\u05C5\u055C\u05A8\u058A\u0599\u05C4\u054C\u05B6\u056B\uFA61\u05C3\u053C\u05A7\u057A\u05C2\u052C\u05B5\u055B\u05C1\u010D\u01C0\u0598\u0589\u051C\u05B4\uF951\u05B3\uF941\u05A1\u044B\u044B\u05A6\u056A\u0597\u0579\uF931\u0509\u043B\u043B\u0488\u0488\u05B2\u05A5\u042B\u042B\u055A\u05B1\u051B\u0596\u0469\u0469\u044A\u044A\u010C\u01B0\u010B\u01A0\u010A\u0190\uF8A1\u0478\u04A3\u043A\u0495\u0459\u04A2\u042A\u041A\u0486\u0468\u0477\u0494\u0449\u0493\u0439\u01A4\u0187\u0485\u0458\u0492\u0476\u0467\u0429\u0491\u0419\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0482\u0428\u0481\u0474\u0447\u0418\uF791\u0465\u0456\u0471\uF781\u0337\u0337\u0473\u0472\u0327\u0327\u0180\u0108\u0170\u0107\u0364\u0346\u0355\u0317\u0363\u0336\u0354\u0345\u0362\u0326\u0361\u0316\uF6F1\u0353\u0335\u0344\u0160\u0106\u0352\u0325\u0351\uF6A1\u0215\u0215\u0343\u0334\u0150\u0105\u0242\u0224\u0233\u0241\u0214\u0214\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\u0120\u0102');
    this.m7r_1 = arrayOfUByte$default(this, '\x82\xA2\xC1\xD1,\x1CL\x8C\t\t\t\t\t\t\t\t\xBE\xFE\xDE\xEE~^\x9D\x9Dm=\xAD\xCD');
    this.n7r_1 = arrayOfUByte$default(this, '\xFC\xEC\xDC\xCC\xBC\xAC\x9C\x8C|l\\L<,\x1C\f');
    this.o7r_1 = arrayOfShort$default(this, '\x00 @b\x00\x84\xB4\xDA\u0124\u016C\u01AA\u021A\u0288\u02EA\x00\u0466\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u0732\u0732\u0732\u0732\u0732\u0732\u0732\u0732');
    this.p7r_1 = arrayOfUByte$default(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x01\x02\x03\x04\x06\b\n\r\x04\x05\x06\x07\b\t\x0B\r');
    this.q7r_1 = arrayOfUByte$default(this, '\x00\x11\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x10\x00\x11\x12\x03\x13\x04\x05\x10\x00\x11\x12\x10\x00\x11\x12\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x00\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10');
    var tmp_13 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_13.r7r_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\f\f\f\f\f\f\x10\x14\x18\x1C (08@LZ\x02\x02\x02\x02\x02\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x12\x16\x1A &.6>FL$\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\b\n\f\x10\x14\x18\x1C"*26L\x9E\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\n\f\x10\x12\x16\x1C"(.66\xC0\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\n\f\x10\x14\x18\x1E&.8DTf\x1A\x00'))];
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.s7r_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\b\b\b\b\b\b\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00'))];
    var tmp_15 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_15.t7r_1 = [new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte$default(this, '\f\f\f\x04\x04\x04\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00', 40))];
    var tmp_16 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_16.u7r_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x06\x05\x05\x05\x06\x05\x05\x05\x06\x05\x07\x03\x0B\n\x00\x00\x07\x07\x07\x00\x06\x06\x06\x03\b\b\x05\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\b\t\x06\f\x06\t\t\t\x06\t\f\x06\x0F\x12\x00\x00\x06\x0F\f\x00\x06\f\t\x06\x06\x12\t\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\t\t\x06\f\t\t\t\t\t\t\f\x06\x12\x12\x00\x00\f\f\f\x00\f\t\t\x06\x0F\f\t\x00'))];
    var tmp_17 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_17.v7r_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(76), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(32))];
    var tmp_18 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_18.w7r_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(60), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(4)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(7)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(19))];
    var tmp_19 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_19.x7r_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(0), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(3)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(16), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(8)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(32), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(12)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(40), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(7))];
    var tmp_20 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_20.y7r_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(2)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(10))];
    var tmp_21 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_21.z7r_1 = new Float32Array([0.0, -1.0, -2.519842, -4.326749, -6.349604, -8.54988, -10.902724, -13.390518, -16.0, -18.720755, -21.544348, -24.463781, -27.473143, -30.56735, -33.741993, -36.99318, 0.0, 1.0, 2.519842, 4.326749, 6.349604, 8.54988, 10.902724, 13.390518, 16.0, 18.720755, 21.544348, 24.463781, 27.473143, 30.56735, 33.741993, 36.99318, 40.317474, 43.71179, 47.173344, 50.69963, 54.288353, 57.93741, 61.644863, 65.40894, 69.22798, 73.10044, 77.024895, 81.0, 85.02449, 89.09719, 93.21697, 97.3828, 101.593666, 105.84863, 110.146805, 114.48732, 118.869385, 123.292206, 127.755066, 132.25725, 136.79808, 141.3769, 145.99312, 150.64612, 155.33533, 160.0602, 164.8202, 169.61482, 174.44357, 179.30598, 184.20157, 189.12991, 194.09058, 199.08315, 204.10721, 209.16238, 214.24829, 219.36456, 224.51085, 229.68678, 234.89206, 240.12633, 245.38928, 250.6806, 256.0, 261.34717, 266.72183, 272.12372, 277.55255, 283.00806, 288.48996, 293.99805, 299.53207, 305.09177, 310.6769, 316.28726, 321.92258, 327.5827, 333.26736, 338.97638, 344.70956, 350.46664, 356.24747, 362.05188, 367.8796, 373.73053, 379.60443, 385.50113, 391.4205, 397.3623, 403.32642, 409.31268, 415.3209, 421.3509, 427.4026, 433.47574, 439.57028, 445.68597, 451.82275, 457.98044, 464.15887, 470.35797, 476.57755, 482.81744, 489.0776, 495.35788, 501.65808, 507.97815, 514.31793, 520.6773, 527.0562, 533.4544, 539.8719, 546.3085, 552.76404, 559.2386, 565.7319, 572.2439, 578.7744, 585.3235, 591.89087, 598.47656, 605.08044, 611.70233, 618.3422, 625.0, 631.67554, 638.3688, 645.0796]);
  }
}
class L12_subband_alloc_tStruct {
  constructor(tab_offset, code_tab_width, band_count) {
    this.a7s_1 = tab_offset;
    this.b7s_1 = code_tab_width;
    this.c7s_1 = band_count;
  }
  toString() {
    return 'L12_subband_alloc_tStruct(tab_offset=' + new UByte(this.a7s_1) + ', code_tab_width=' + new UByte(this.b7s_1) + ', band_count=' + new UByte(this.c7s_1) + ')';
  }
  hashCode() {
    var result = UByte__hashCode_impl_mmczcb(this.a7s_1);
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.b7s_1) | 0;
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.c7s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof L12_subband_alloc_tStruct))
      return false;
    var tmp0_other_with_cast = other instanceof L12_subband_alloc_tStruct ? other : THROW_CCE();
    if (!(this.a7s_1 === tmp0_other_with_cast.a7s_1))
      return false;
    if (!(this.b7s_1 === tmp0_other_with_cast.b7s_1))
      return false;
    if (!(this.c7s_1 === tmp0_other_with_cast.c7s_1))
      return false;
    return true;
  }
}
class Mp3Dec {
  static d7s(mdct_overlap, qmf_state, reserv, free_format_bytes_array, header, reserv_buf) {
    var $this = createThis(this);
    $this.f7m_1 = mdct_overlap;
    $this.g7m_1 = qmf_state;
    $this.h7m_1 = reserv;
    $this.i7m_1 = free_format_bytes_array;
    $this.j7m_1 = header;
    $this.k7m_1 = reserv_buf;
    return $this;
  }
  static l7m() {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(2), null);
    while (tmp < 2) {
      tmp_0[tmp] = new Float32Array(288);
      tmp = tmp + 1 | 0;
    }
    return this.d7s(tmp_0, new Float32Array(960), 0, new Int32Array(1), _UByteArrayInt___init__impl__xif7bu_1(4), _UByteArrayInt___init__impl__xif7bu_1(511));
  }
}
class Bs {
  constructor(buf, pos, limit) {
    buf = buf === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : buf;
    pos = pos === VOID ? 0 : pos;
    limit = limit === VOID ? 0 : limit;
    this.e7s_1 = buf;
    this.f7s_1 = pos;
    this.g7s_1 = limit;
  }
}
class Mp3Scratch {
  static o7s(bs, maindata, gr_info, grbuf, scf, syn, ist_pos) {
    var $this = createThis(this);
    $this.h7s_1 = bs;
    $this.i7s_1 = maindata;
    $this.j7s_1 = gr_info;
    $this.k7s_1 = grbuf;
    $this.l7s_1 = scf;
    $this.m7s_1 = syn;
    $this.n7s_1 = ist_pos;
    return $this;
  }
  static p7s() {
    var tmp = new Bs();
    var tmp_0 = new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(2815));
    var tmp_1 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(4), null);
    while (tmp_1 < 4) {
      tmp_2[tmp_1] = new GrInfo();
      tmp_1 = tmp_1 + 1 | 0;
    }
    var tmp_3 = new ArrayPtr(tmp_2, 0);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.Mp3Scratch.<init>.<anonymous>' call
    var CSIZE = 576;
    var data = new Float32Array(imul(2, CSIZE));
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(2), null);
    while (tmp_4 < 2) {
      var tmp_6 = tmp_4;
      tmp_5[tmp_6] = new FloatArrayPtr(data, imul(CSIZE, tmp_6));
      tmp_4 = tmp_4 + 1 | 0;
    }
    var tmp_7 = tmp_5;
    var tmp_8 = new FloatArrayPtr(new Float32Array(40));
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.Mp3Scratch.<init>.<anonymous>' call
    var CSIZE_0 = 64;
    var data_0 = new Float32Array(imul(33, CSIZE_0));
    var tmp_9 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_10 = fillArrayVal(Array(33), null);
    while (tmp_9 < 33) {
      var tmp_11 = tmp_9;
      tmp_10[tmp_11] = new FloatArrayPtr(data_0, imul(CSIZE_0, tmp_11));
      tmp_9 = tmp_9 + 1 | 0;
    }
    var tmp_12 = tmp_10;
    var tmp_13 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(2), null);
    while (tmp_13 < 2) {
      var tmp_15 = tmp_13;
      var tmp$ret$11 = _UByteArrayInt___init__impl__xif7bu_1(39);
      tmp_14[tmp_15] = new UByteArrayInt(tmp$ret$11);
      tmp_13 = tmp_13 + 1 | 0;
    }
    return this.o7s(tmp, tmp_0, tmp_3, tmp_7, tmp_8, tmp_12, tmp_14);
  }
}
class Mp3FrameInfo {
  constructor(frame_bytes, frame_offset, channels, hz, layer, bitrate_kbps) {
    frame_bytes = frame_bytes === VOID ? 0 : frame_bytes;
    frame_offset = frame_offset === VOID ? 0 : frame_offset;
    channels = channels === VOID ? 0 : channels;
    hz = hz === VOID ? 0 : hz;
    layer = layer === VOID ? 0 : layer;
    bitrate_kbps = bitrate_kbps === VOID ? 0 : bitrate_kbps;
    this.m7n_1 = frame_bytes;
    this.n7n_1 = frame_offset;
    this.o7n_1 = channels;
    this.p7n_1 = hz;
    this.q7n_1 = layer;
    this.r7n_1 = bitrate_kbps;
  }
  b2() {
    return this;
  }
}
class ArrayPtr {
  constructor(array, pos) {
    this.q7s_1 = array;
    this.r7s_1 = pos;
  }
  b2() {
    return this.q7s_1[this.r7s_1];
  }
  i1(index) {
    return this.q7s_1[this.r7s_1 + index | 0];
  }
  g4() {
    return new ArrayPtr(this.q7s_1, this.r7s_1 + 1 | 0);
  }
  s7s(other) {
    return new ArrayPtr(this.q7s_1, this.r7s_1 + other | 0);
  }
}
class UByteArrayIntPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.t7s_1 = array;
    this.u7s_1 = pos;
  }
  b2() {
    return UByteArrayInt__get_impl_px6q8a(this.t7s_1, this.u7s_1);
  }
  i1(index) {
    return UByteArrayInt__get_impl_px6q8a(this.t7s_1, this.u7s_1 + index | 0);
  }
  t31(index, value) {
    UByteArrayInt__set_impl_gn4532(this.t7s_1, this.u7s_1 + index | 0, value);
  }
  g4() {
    return new UByteArrayIntPtr(this.t7s_1, this.u7s_1 + 1 | 0);
  }
  s7s(other) {
    return new UByteArrayIntPtr(this.t7s_1, this.u7s_1 + other | 0);
  }
  v7s(other) {
    return this.u7s_1 - other.u7s_1 | 0;
  }
  w7s(value, from, to) {
    var tmp = _UByteArrayInt___get_bytes__impl__pj0ilc(this.t7s_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    fill(tmp, tmp$ret$0, this.u7s_1 + from | 0, this.u7s_1 + to | 0);
  }
}
class FloatArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.x7s_1 = array;
    this.y7s_1 = pos;
  }
  z7s(value) {
    this.x7s_1[this.y7s_1] = value;
  }
  b2() {
    return this.x7s_1[this.y7s_1];
  }
  i1(index) {
    return this.x7s_1[this.y7s_1 + index | 0];
  }
  a7t(index, value) {
    this.x7s_1[this.y7s_1 + index | 0] = value;
  }
  g4() {
    return new FloatArrayPtr(this.x7s_1, this.y7s_1 + 1 | 0);
  }
  s7s(other) {
    return new FloatArrayPtr(this.x7s_1, this.y7s_1 + other | 0);
  }
  b7t(other) {
    return this.y7s_1 - other.y7s_1 | 0;
  }
  c7t(value, from, to) {
    fill_0(this.x7s_1, value, this.y7s_1 + from | 0, this.y7s_1 + to | 0);
  }
}
class ShortArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.d7t_1 = array;
    this.e7t_1 = pos;
  }
  f7t(index, value) {
    this.d7t_1[this.e7t_1 + index | 0] = value;
  }
  s7s(other) {
    return new ShortArrayPtr(this.d7t_1, this.e7t_1 + other | 0);
  }
}
class GrInfo {
  constructor(sfbtab, part_23_length, big_values, scalefac_compress, global_gain, block_type, mixed_block_flag, n_long_sfb, n_short_sfb, table_select, region_count, subblock_gain, preflag, scalefac_scale, count1_table, scfsi) {
    sfbtab = sfbtab === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : sfbtab;
    part_23_length = part_23_length === VOID ? 0 : part_23_length;
    big_values = big_values === VOID ? 0 : big_values;
    scalefac_compress = scalefac_compress === VOID ? 0 : scalefac_compress;
    global_gain = global_gain === VOID ? 0 : global_gain;
    block_type = block_type === VOID ? 0 : block_type;
    mixed_block_flag = mixed_block_flag === VOID ? 0 : mixed_block_flag;
    n_long_sfb = n_long_sfb === VOID ? 0 : n_long_sfb;
    n_short_sfb = n_short_sfb === VOID ? 0 : n_short_sfb;
    table_select = table_select === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : table_select;
    region_count = region_count === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : region_count;
    subblock_gain = subblock_gain === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : subblock_gain;
    preflag = preflag === VOID ? 0 : preflag;
    scalefac_scale = scalefac_scale === VOID ? 0 : scalefac_scale;
    count1_table = count1_table === VOID ? 0 : count1_table;
    scfsi = scfsi === VOID ? 0 : scfsi;
    this.g7t_1 = sfbtab;
    this.h7t_1 = part_23_length;
    this.i7t_1 = big_values;
    this.j7t_1 = scalefac_compress;
    this.k7t_1 = global_gain;
    this.l7t_1 = block_type;
    this.m7t_1 = mixed_block_flag;
    this.n7t_1 = n_long_sfb;
    this.o7t_1 = n_short_sfb;
    this.p7t_1 = table_select;
    this.q7t_1 = region_count;
    this.r7t_1 = subblock_gain;
    this.s7t_1 = preflag;
    this.t7t_1 = scalefac_scale;
    this.u7t_1 = count1_table;
    this.v7t_1 = scfsi;
  }
}
class ScaleInfo {
  constructor(scf, total_bands, stereo_bands, bitalloc, scfcod) {
    scf = scf === VOID ? new Float32Array(192) : scf;
    total_bands = total_bands === VOID ? 0 : total_bands;
    stereo_bands = stereo_bands === VOID ? 0 : stereo_bands;
    bitalloc = bitalloc === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : bitalloc;
    scfcod = scfcod === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : scfcod;
    this.w7t_1 = scf;
    this.x7t_1 = total_bands;
    this.y7t_1 = stereo_bands;
    this.z7t_1 = bitalloc;
    this.a7u_1 = scfcod;
  }
}
class WAV extends AudioFormat {
  constructor() {
    Companion_getInstance_13();
    super(['wav']);
  }
  d7j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh_1(this, data, props, $completion), $completion);
  }
  i7j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamInternal__hls877_0(this, data, props, $completion), $completion);
  }
  j7j(data, out, filename, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_encode__nikamm(this, data, out, filename, props, $completion), $completion);
  }
  c7v(data, handle, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5(this, data, handle, $completion), $completion);
  }
  d7v(data, handler, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_riff__qieez3(this, data, handler, $completion), $completion);
  }
}
class Companion_8 extends WAV {
  constructor() {
    Companion_instance_9 = null;
    super();
    Companion_instance_9 = this;
  }
}
class Chunk {
  constructor(type, data) {
    this.r7u_1 = type;
    this.s7u_1 = data;
  }
  km() {
    return this.r7u_1;
  }
  lm() {
    return this.s7u_1;
  }
  toString() {
    return 'Chunk(type=' + this.r7u_1 + ', data=' + this.s7u_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.r7u_1);
    result = imul(result, 31) + hashCode(this.s7u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Chunk))
      return false;
    var tmp0_other_with_cast = other instanceof Chunk ? other : THROW_CCE();
    if (!(this.r7u_1 === tmp0_other_with_cast.r7u_1))
      return false;
    if (!equals(this.s7u_1, tmp0_other_with_cast.s7u_1))
      return false;
    return true;
  }
}
class ProcessedChunk {
  constructor(type, data, extra) {
    this.e7v_1 = type;
    this.f7v_1 = data;
    this.g7v_1 = extra;
  }
  toString() {
    return 'ProcessedChunk(type=' + this.e7v_1 + ', data=' + this.f7v_1.toString() + ', extra=' + toString(this.g7v_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.e7v_1);
    result = imul(result, 31) + hashCode(this.f7v_1) | 0;
    result = imul(result, 31) + hashCode(this.g7v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessedChunk))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessedChunk ? other : THROW_CCE();
    if (!(this.e7v_1 === tmp0_other_with_cast.e7v_1))
      return false;
    if (!equals(this.f7v_1, tmp0_other_with_cast.f7v_1))
      return false;
    if (!equals(this.g7v_1, tmp0_other_with_cast.g7v_1))
      return false;
    return true;
  }
}
class WavAudioStream extends AudioStream {
  constructor(fmt, buffer, bufferLength, data, props) {
    super(fmt.y7u_1, fmt.x7u_1);
    this.g7u_1 = fmt;
    this.h7u_1 = buffer;
    this.i7u_1 = bufferLength;
    this.j7u_1 = data;
    this.k7u_1 = props;
    this.l7u_1 = this.g7u_1.h7v();
    this.m7u_1 = false;
  }
  k7q() {
    return this.m7u_1;
  }
  l7q(value) {
    this.m7u_1 = false;
    var tmp = this.h7u_1;
    // Inline function 'kotlin.Long.times' call
    var other = this.l7u_1;
    tmp.t1t_1 = value.d4(toLong(other));
  }
  m7q(out, offset, length, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0(this, out, offset, length, $completion), $completion);
  }
  n7q($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_clone__nh2r5j(this, $completion), $completion);
  }
}
class Fmt {
  constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample) {
    formatTag = formatTag === VOID ? -1 : formatTag;
    channels = channels === VOID ? 2 : channels;
    samplesPerSec = samplesPerSec === VOID ? 44100 : samplesPerSec;
    avgBytesPerSec = avgBytesPerSec === VOID ? new Long(0, 0) : avgBytesPerSec;
    blockAlign = blockAlign === VOID ? 0 : blockAlign;
    bitsPerSample = bitsPerSample === VOID ? 0 : bitsPerSample;
    this.w7u_1 = formatTag;
    this.x7u_1 = channels;
    this.y7u_1 = samplesPerSec;
    this.z7u_1 = avgBytesPerSec;
    this.a7v_1 = blockAlign;
    this.b7v_1 = bitsPerSample;
  }
  h7v() {
    return this.b7v_1 / 8 | 0;
  }
  toString() {
    return 'Fmt(formatTag=' + this.w7u_1 + ', channels=' + this.x7u_1 + ', samplesPerSec=' + this.y7u_1 + ', avgBytesPerSec=' + this.z7u_1.toString() + ', blockAlign=' + this.a7v_1 + ', bitsPerSample=' + this.b7v_1 + ')';
  }
  hashCode() {
    var result = this.w7u_1;
    result = imul(result, 31) + this.x7u_1 | 0;
    result = imul(result, 31) + this.y7u_1 | 0;
    result = imul(result, 31) + this.z7u_1.hashCode() | 0;
    result = imul(result, 31) + this.a7v_1 | 0;
    result = imul(result, 31) + this.b7v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fmt))
      return false;
    var tmp0_other_with_cast = other instanceof Fmt ? other : THROW_CCE();
    if (!(this.w7u_1 === tmp0_other_with_cast.w7u_1))
      return false;
    if (!(this.x7u_1 === tmp0_other_with_cast.x7u_1))
      return false;
    if (!(this.y7u_1 === tmp0_other_with_cast.y7u_1))
      return false;
    if (!this.z7u_1.equals(tmp0_other_with_cast.z7u_1))
      return false;
    if (!(this.a7v_1 === tmp0_other_with_cast.a7v_1))
      return false;
    if (!(this.b7v_1 === tmp0_other_with_cast.b7v_1))
      return false;
    return true;
  }
}
class WAV$parse$slambda {
  constructor($fmt, $dataSize, $handle) {
    this.t7u_1 = $fmt;
    this.u7u_1 = $dataSize;
    this.v7u_1 = $handle;
  }
  p7v($this$riff, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $this$riff, $completion), $completion);
  }
  qe(p1, $completion) {
    return this.p7v(p1 instanceof Chunk ? p1 : THROW_CCE(), $completion);
  }
}
class SampleConvert {
  q7v(v) {
    return v / 32767;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    tmp.r7v_1 = lazy(AudioData$Companion$DUMMY$delegate$lambda);
  }
  s7v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r7v_1;
    DUMMY$factory();
    return this_0.b2();
  }
}
class AudioData {
  constructor(rate, samples) {
    Companion_getInstance_14();
    this.i7v_1 = rate;
    this.j7v_1 = samples;
    var tmp = this;
    tmp.k7v_1 = lazy(AudioData$samplesInterleaved$delegate$lambda(this));
  }
  l7v() {
    return this.j7v_1.n7u_1;
  }
  t7v() {
    return this.j7v_1.o7u_1;
  }
  i1(channel) {
    return this.j7v_1.p7u_1[channel];
  }
  toString() {
    return 'AudioData(rate=' + this.i7v_1 + ', channels=' + this.l7v() + ', samples=' + this.t7v() + ')';
  }
}
class AudioSamples {
  constructor(channels, totalSamples, data) {
    var tmp;
    if (data === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(channels), null);
      while (tmp_0 < channels) {
        tmp_1[tmp_0] = new Int16Array(totalSamples);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = data;
    }
    data = tmp;
    this.n7u_1 = channels;
    this.o7u_1 = totalSamples;
    this.p7u_1 = data;
  }
  l7v() {
    return this.n7u_1;
  }
  t7v() {
    return this.o7u_1;
  }
  i1(channel) {
    return this.p7u_1[channel];
  }
  z2k(channel, sample) {
    return this.p7u_1[channel][sample];
  }
  u7v(channel, sample, value) {
    this.p7u_1[channel][sample] = value;
  }
  hashCode() {
    return (this.n7u_1 + imul(this.o7u_1, 32) | 0) + imul(contentDeepHashCode(this.p7u_1), 64) | 0;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof AudioSamples) {
      tmp_1 = this.n7u_1 === other.n7u_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7u_1 === other.o7u_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentDeepEquals(this.p7u_1, other.p7u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'AudioSamples(channels=' + this.n7u_1 + ', totalSamples=' + this.o7u_1 + ')';
  }
}
class AudioSamplesInterleaved {
  constructor(channels, totalSamples, data) {
    data = data === VOID ? new Int16Array(imul(totalSamples, channels)) : data;
    this.m7v_1 = channels;
    this.n7v_1 = totalSamples;
    this.o7v_1 = data;
  }
  l7v() {
    return this.m7v_1;
  }
  t7v() {
    return this.n7v_1;
  }
  z2k(channel, sample) {
    return this.o7v_1[index(this, channel, sample)];
  }
  u7v(channel, sample, value) {
    this.o7v_1[index(this, channel, sample)] = value;
  }
  toString() {
    return 'AudioSamplesInterleaved(channels=' + this.m7v_1 + ', totalSamples=' + this.n7v_1 + ')';
  }
}
class AudioSamplesDeque {
  constructor(channels) {
    this.d7q_1 = channels;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.d7q_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = new ShortArrayDeque();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.e7q_1 = tmp_2;
  }
  i12() {
    var tmp28_safe_receiver = getOrNull_0(this.e7q_1, 0);
    var tmp0_elvis_lhs = tmp28_safe_receiver == null ? null : tmp28_safe_receiver.i12();
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  v7v() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var this_0 = this.e7q_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block;
      }
      // Inline function 'korlibs.audio.sound.AudioSamplesDeque.<get-availableReadMax>.<anonymous>' call
      var maxValue = this_0[0].i12();
      var inductionVariable = 1;
      var last = get_lastIndex(this_0);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.audio.sound.AudioSamplesDeque.<get-availableReadMax>.<anonymous>' call
          var v = this_0[i].i12();
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
         while (!(i === last));
      tmp$ret$1 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  k3p(channel) {
    return this.e7q_1[channel].p30();
  }
  w7v(channel, sample) {
    this.e7q_1[channel].q30(sample);
  }
  x7v(samples, offset, len) {
    var inductionVariable = 0;
    var last = this.d7q_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.y7v(channel, samples.i1(channel % samples.n7u_1 | 0), offset, len);
      }
       while (inductionVariable < last);
  }
  y7v(channel, data, offset, len) {
    this.e7q_1[channel].o30(data, offset, len);
  }
  z7v(data, offset, len, channels) {
    switch (channels) {
      case 1:
        var inductionVariable = 0;
        var last = this.d7q_1;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.e7q_1[n].o30(data, offset, len);
          }
           while (inductionVariable < last);
        break;
      case 2:
        var inductionVariable_0 = 0;
        var last_0 = len / 2 | 0;
        if (inductionVariable_0 < last_0)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.w7v(0, data[imul(n_0, 2) + 0 | 0]);
          }
           while (inductionVariable_0 < last_0);
        var inductionVariable_1 = 0;
        var last_1 = len / 2 | 0;
        if (inductionVariable_1 < last_1)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            this.w7v(1, data[imul(n_1, 2) + 1 | 0]);
          }
           while (inductionVariable_1 < last_1);
        break;
      default:
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < channels)
          do {
            var c = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var inductionVariable_3 = 0;
            var last_2 = len / channels | 0;
            if (inductionVariable_3 < last_2)
              do {
                var n_2 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                this.w7v(c, data[imul(n_2, channels) + c | 0]);
              }
               while (inductionVariable_3 < last_2);
          }
           while (inductionVariable_2 < channels);
        break;
    }
  }
  j7q(data, offset, len, channels, $super) {
    len = len === VOID ? data.length - offset | 0 : len;
    channels = channels === VOID ? this.d7q_1 : channels;
    var tmp;
    if ($super === VOID) {
      this.z7v(data, offset, len, channels);
      tmp = Unit_instance;
    } else {
      tmp = $super.z7v.call(this, data, offset, len, channels);
    }
    return tmp;
  }
  f7q(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.i12();
    var rlen = Math.min(len, b);
    var inductionVariable = 0;
    var last = out.n7u_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.e7q_1[channel % this.d7q_1 | 0].n30(out.i1(channel), offset, rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  a7w(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.o7u_1 - offset | 0 : len;
    return $super === VOID ? this.f7q(out, offset, len) : $super.f7q.call(this, out, offset, len);
  }
  o3() {
    var inductionVariable = 0;
    var last = this.e7q_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.e7q_1[c].o3();
      }
       while (inductionVariable <= last);
  }
  toString() {
    return 'AudioSamplesDeque(channels=' + this.d7q_1 + ', availableRead=' + this.i12() + ')';
  }
}
class Companion_10 {}
class NewPlatformAudioOutput {
  constructor(coroutineContext, channels, frequency, gen) {
    this.b7w_1 = coroutineContext;
    this.c7w_1 = channels;
    this.d7w_1 = frequency;
    this.e7w_1 = gen;
    this.f7w_1 = null;
    this.g7w_1 = false;
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.h7w_1 = get_atomicfu$reentrantLock();
    this.i7w_1 = 1.0;
    this.j7w_1 = 1.0;
    this.k7w_1 = 0.0;
    this.l7w_1 = Companion_getInstance_2().c2x_1;
  }
  n7w(buffer) {
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.h7w_1;
    try {
      this.e7w_1(buffer);
      applyPropsTo(this, buffer);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  o7w(_set____db54di) {
    this.i7w_1 = _set____db54di;
  }
  p7w() {
    return this.i7w_1;
  }
  q7w(_set____db54di) {
    this.j7w_1 = _set____db54di;
  }
  r7w() {
    return this.j7w_1;
  }
  s7w(_set____db54di) {
    this.k7w_1 = _set____db54di;
  }
  t7w() {
    return this.k7w_1;
  }
  u7w() {
    return Unit_instance;
  }
  v7w() {
    return Unit_instance;
  }
  w7w() {
    this.m7w();
    var tmp = this;
    tmp.f7w_1 = onCancel(this.b7w_1, NewPlatformAudioOutput$start$lambda(this));
    this.u7w();
  }
  m7w() {
    var tmp32_safe_receiver = this.f7w_1;
    if (tmp32_safe_receiver == null)
      null;
    else {
      tmp32_safe_receiver.u6();
    }
    this.f7w_1 = null;
    this.v7w();
  }
  u6() {
    return this.m7w();
  }
}
class PlatformAudioOutput {
  constructor(coroutineContext, frequency) {
    this.x7w_1 = coroutineContext;
    this.y7w_1 = frequency;
    this.z7w_1 = 0;
    this.a7x_1 = 1.0;
    this.b7x_1 = 1.0;
    this.c7x_1 = 0.0;
    this.d7x_1 = Companion_getInstance_2().c2x_1;
  }
  e7x() {
    return this.z7w_1;
  }
  o7w(_set____db54di) {
    this.a7x_1 = _set____db54di;
  }
  p7w() {
    return this.a7x_1;
  }
  q7w(_set____db54di) {
    this.b7x_1 = _set____db54di;
  }
  r7w() {
    return this.b7x_1;
  }
  s7w(_set____db54di) {
    this.c7x_1 = _set____db54di;
  }
  t7w() {
    return this.c7x_1;
  }
  f7x(samples, offset, size, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_add__cbj1ot(this, samples, offset, size, $completion), $completion);
  }
  w7w() {
    return Unit_instance;
  }
  m7w() {
    return Unit_instance;
  }
  g7x($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_wait__qfshcd(this, $completion), $completion);
  }
  u6() {
    return this.m7w();
  }
}
class DequeBasedPlatformAudioOutput extends PlatformAudioOutput {
  constructor(coroutineContext, frequency) {
    super(coroutineContext, frequency);
    this.o7x_1 = new NonRecursiveLock();
    this.p7x_1 = new AudioSamplesDeque(2);
    this.q7x_1 = 1.0;
    this.r7x_1 = 1.0;
    this.s7x_1 = 0.0;
    this.t7x_1 = Companion_getInstance_2().c2x_1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Float32Array(2);
    while (tmp_0 < 2) {
      tmp_1[tmp_0] = 1.0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.u7x_1 = tmp_1;
  }
  o7w(value) {
    this.q7x_1 = value;
    updateProps(this);
  }
  p7w() {
    return this.q7x_1;
  }
  q7w(value) {
    this.r7x_1 = value;
    updateProps(this);
  }
  r7w() {
    return this.r7x_1;
  }
  s7w(value) {
    this.s7x_1 = value;
    updateProps(this);
  }
  t7w() {
    return this.s7x_1;
  }
  i12() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.o7x_1;
      this_0.w1w();
      try {
        // Inline function 'korlibs.audio.sound.DequeBasedPlatformAudioOutput.<get-availableRead>.<anonymous>' call
        tmp$ret$1 = this.p7x_1.i12();
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
    return tmp$ret$1;
  }
  u7y(out, offset, count, nchannels, fully) {
    // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
    var this_0 = this.o7x_1;
    this_0.w1w();
    try {
      var tmp;
      if (fully) {
        tmp = count;
      } else {
        // Inline function 'kotlin.comparisons.minOf' call
        var a = this.i12();
        tmp = Math.min(a, count);
      }
      var totalRead = tmp;
      var inductionVariable = 0;
      if (inductionVariable < totalRead)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < nchannels)
            do {
              var ch = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              out.u7v(ch, offset + n | 0, _readShort(this, ch));
            }
             while (inductionVariable_0 < nchannels);
        }
         while (inductionVariable < totalRead);
      return totalRead;
    }finally {
      this_0.z1w();
    }
  }
  v7x(out, offset, count, nchannels, fully, $super) {
    offset = offset === VOID ? 0 : offset;
    count = count === VOID ? out.t7v() - offset | 0 : count;
    nchannels = nchannels === VOID ? out.l7v() : nchannels;
    return $super === VOID ? this.u7y(out, offset, count, nchannels, fully) : $super.u7y.call(this, out, offset, count, nchannels, fully);
  }
  e7x() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.o7x_1;
      this_0.w1w();
      try {
        // Inline function 'korlibs.audio.sound.DequeBasedPlatformAudioOutput.<get-availableSamples>.<anonymous>' call
        tmp$ret$1 = this.p7x_1.i12();
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
    return tmp$ret$1;
  }
  f7x(samples, offset, size, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_add__cbj1ot_0(this, samples, offset, size, $completion), $completion);
  }
}
class PlatformAudioOutputBasedOnNew extends DequeBasedPlatformAudioOutput {
  constructor(soundProvider, coroutineContext, frequency) {
    super(coroutineContext, frequency);
    this.k7y_1 = soundProvider;
    println('PlatformAudioOutputBasedOnNew[' + frequency + '] = ' + toString(this.k7y_1));
    var tmp = this;
    tmp.l7y_1 = this.k7y_1.t7y(coroutineContext, 2, frequency, PlatformAudioOutputBasedOnNew$new$lambda(this));
  }
  w7w() {
    this.l7y_1.w7w();
  }
  m7w() {
    this.l7y_1.m7w();
  }
}
class Companion_11 {
  constructor() {
    this.v7y_1 = 2;
  }
}
class NativeSoundProvider {
  constructor() {
    this.m7y_1 = 'unknown';
    this.n7y_1 = false;
    this.o7y_1 = Companion_getInstance_2().c2x_1;
    this.p7y_1 = Companion_getInstance_2().e2x_1;
    this.q7y_1 = Companion_getInstance_2().i2x_1;
    this.r7y_1 = Companion_getInstance_2().c2x_1;
    var tmp = this;
    tmp.s7y_1 = lazy(NativeSoundProvider$audioFormats$delegate$lambda);
  }
  z3d(_set____db54di) {
    this.n7y_1 = _set____db54di;
  }
  a7z(coroutineContext, freq) {
    return new PlatformAudioOutput(coroutineContext, freq);
  }
  t7y(coroutineContext, channels, frequency, gen) {
    return new NewPlatformAudioOutput(coroutineContext, channels, frequency, gen);
  }
  b7z(data, streaming, props, name, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd(this, data, streaming, props, name, $completion), $completion);
  }
  z7y(data, streaming, props, name, $completion, $super) {
    streaming = streaming === VOID ? false : streaming;
    props = props === VOID ? Companion_getInstance_5().e7j_1 : props;
    name = name === VOID ? 'Unknown' : name;
    return $super === VOID ? this.b7z(data, streaming, props, name, $completion) : $super.b7z.call(this, data, streaming, props, name, $completion);
  }
  w7y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s7y_1;
    audioFormats$factory();
    return this_0.b2();
  }
  x7y(data, name, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.gd();
    return new SoundAudioData(tmp$ret$0, data, this, true, name);
  }
  c7z(data, formats, streaming, name, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd_0(this, data, formats, streaming, name, $completion), $completion);
  }
  d7z(data, formats, streaming, name, $completion, $super) {
    formats = formats === VOID ? get_defaultAudioFormats() : formats;
    streaming = streaming === VOID ? false : streaming;
    name = name === VOID ? 'Unknown' : name;
    return $super === VOID ? this.c7z(data, formats, streaming, name, $completion) : $super.c7z.call(this, data, formats, streaming, name, $completion);
  }
  e7z(stream, closeStream, name, onComplete, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.gd();
    return new SoundAudioStream(tmp$ret$0, stream, this, closeStream, name, onComplete);
  }
  y7y(stream, closeStream, name, onComplete, $completion, $super) {
    closeStream = closeStream === VOID ? false : closeStream;
    name = name === VOID ? 'Unknown' : name;
    onComplete = onComplete === VOID ? null : onComplete;
    return $super === VOID ? this.e7z(stream, closeStream, name, onComplete, $completion) : $super.e7z.call(this, stream, closeStream, name, onComplete, $completion);
  }
  u6() {
  }
}
class NativeSoundProviderNew extends NativeSoundProvider {
  a7z(coroutineContext, freq) {
    return new PlatformAudioOutputBasedOnNew(this, coroutineContext, freq);
  }
}
class DummyNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    Companion_getInstance_17();
    super();
  }
}
class Companion_12 extends DummyNativeSoundProvider {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class SoundPlay {}
function play(params, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.gd();
  return this.u7z(tmp$ret$0, params);
}
function play$default(params, $completion, $super) {
  params = params === VOID ? Companion_getInstance_18().e80_1 : params;
  return $super === VOID ? this.v7z(params, $completion) : play(params, $completion);
}
class Sound {
  constructor(creationCoroutineContext) {
    this.m7z_1 = creationCoroutineContext;
    this.n7z_1 = this.m7z_1;
    this.o7z_1 = 'UnknownNativeSound';
    this.p7z_1 = 1.0;
    this.q7z_1 = 0.0;
    this.r7z_1 = 1.0;
    this.s7z_1 = Companion_getInstance_2().c2x_1;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    tmp.t7z_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
  }
  w3() {
    return this.o7z_1;
  }
  q7w(_set____db54di) {
    this.p7z_1 = _set____db54di;
  }
  r7w() {
    return this.p7z_1;
  }
  s7w(_set____db54di) {
    this.q7z_1 = _set____db54di;
  }
  t7w() {
    return this.q7z_1;
  }
  o7w(_set____db54di) {
    this.r7z_1 = _set____db54di;
  }
  p7w() {
    return this.r7z_1;
  }
  u7z(coroutineContext, params) {
    throw NotImplementedError.oe();
  }
  toString() {
    return "NativeSound('" + this.w3() + "')";
  }
}
class SoundChannel {
  constructor(sound, $box) {
    boxApply(this, $box);
    this.x7z_1 = new Mixin();
    this.y7z_1 = sound;
    this.z7z_1 = Companion_getInstance_0().h1w();
    this.a80_1 = 1.0;
    this.b80_1 = 1.0;
    this.c80_1 = 0.0;
    this.d80_1 = Companion_getInstance_2().c2x_1;
  }
  n13(_set____db54di) {
    this.x7z_1.n13(_set____db54di);
  }
  o13() {
    return this.x7z_1.o13();
  }
  q7w(_set____db54di) {
    this.a80_1 = _set____db54di;
  }
  r7w() {
    return this.a80_1;
  }
  o7w(_set____db54di) {
    this.b80_1 = _set____db54di;
  }
  p7w() {
    return this.b80_1;
  }
  s7w(_set____db54di) {
    this.c80_1 = _set____db54di;
  }
  t7w() {
    return this.c80_1;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_14 = this;
    var tmp = this;
    // Inline function 'korlibs.audio.sound.playbackTimes' call
    var tmp_0 = _PlaybackTimes___init__impl__rt6rw2(1);
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration(0, DurationUnit_SECONDS_getInstance());
    tmp.e80_1 = new PlaybackParameters(tmp_0, tmp$ret$2);
  }
}
class PlaybackParameters {
  constructor(times, startTime, bufferTime, volume, pitch, panning, position, onCancel, onFinish) {
    Companion_getInstance_18();
    var tmp;
    if (times === VOID) {
      // Inline function 'korlibs.audio.sound.playbackTimes' call
      tmp = _PlaybackTimes___init__impl__rt6rw2(1);
    } else {
      tmp = times;
    }
    times = tmp;
    var tmp_0;
    if (startTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp_0 = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_0 = startTime;
    }
    startTime = tmp_0;
    var tmp_1;
    if (bufferTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      tmp_1 = toDuration(0.16, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_1 = bufferTime;
    }
    bufferTime = tmp_1;
    volume = volume === VOID ? 1.0 : volume;
    pitch = pitch === VOID ? 1.0 : pitch;
    panning = panning === VOID ? 0.0 : panning;
    position = position === VOID ? Companion_getInstance_2().c2x_1 : position;
    onCancel = onCancel === VOID ? null : onCancel;
    onFinish = onFinish === VOID ? null : onFinish;
    this.f80_1 = times;
    this.g80_1 = startTime;
    this.h80_1 = bufferTime;
    this.i80_1 = volume;
    this.j80_1 = pitch;
    this.k80_1 = panning;
    this.l80_1 = position;
    this.m80_1 = onCancel;
    this.n80_1 = onFinish;
  }
  r7w() {
    return this.i80_1;
  }
  p7w() {
    return this.j80_1;
  }
  t7w() {
    return this.k80_1;
  }
  toString() {
    return 'PlaybackParameters(times=' + PlaybackTimes__toString_impl_l4chjq(this.f80_1) + ', startTime=' + Duration__toString_impl_8d916b(this.g80_1) + ', bufferTime=' + Duration__toString_impl_8d916b(this.h80_1) + ', volume=' + this.i80_1 + ', pitch=' + this.j80_1 + ', panning=' + this.k80_1 + ', position=' + this.l80_1.toString() + ', onCancel=' + toString_0(this.m80_1) + ', onFinish=' + toString_0(this.n80_1) + ')';
  }
  hashCode() {
    var result = PlaybackTimes__hashCode_impl_mtf95(this.f80_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.g80_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.h80_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i80_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j80_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k80_1) | 0;
    result = imul(result, 31) + this.l80_1.hashCode() | 0;
    result = imul(result, 31) + (this.m80_1 == null ? 0 : hashCode(this.m80_1)) | 0;
    result = imul(result, 31) + (this.n80_1 == null ? 0 : hashCode(this.n80_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaybackParameters))
      return false;
    var tmp0_other_with_cast = other instanceof PlaybackParameters ? other : THROW_CCE();
    if (!(this.f80_1 === tmp0_other_with_cast.f80_1))
      return false;
    if (!equals(this.g80_1, tmp0_other_with_cast.g80_1))
      return false;
    if (!equals(this.h80_1, tmp0_other_with_cast.h80_1))
      return false;
    if (!equals(this.i80_1, tmp0_other_with_cast.i80_1))
      return false;
    if (!equals(this.j80_1, tmp0_other_with_cast.j80_1))
      return false;
    if (!equals(this.k80_1, tmp0_other_with_cast.k80_1))
      return false;
    if (!this.l80_1.equals(tmp0_other_with_cast.l80_1))
      return false;
    if (!equals(this.m80_1, tmp0_other_with_cast.m80_1))
      return false;
    if (!equals(this.n80_1, tmp0_other_with_cast.n80_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_15 = this;
    this.o80_1 = _PlaybackTimes___init__impl__rt6rw2(0);
    this.p80_1 = _PlaybackTimes___init__impl__rt6rw2(1);
    this.q80_1 = _PlaybackTimes___init__impl__rt6rw2(-1);
  }
}
class PlaybackTimes {
  constructor(count) {
    Companion_getInstance_19();
    this.r80_1 = count;
  }
  toString() {
    return PlaybackTimes__toString_impl_l4chjq(this.r80_1);
  }
  hashCode() {
    return PlaybackTimes__hashCode_impl_mtf95(this.r80_1);
  }
  equals(other) {
    return PlaybackTimes__equals_impl_suah7n(this.r80_1, other);
  }
}
class SoundAudioData$play$2 extends SoundChannel {
  constructor($nas, this$0, $pos, $paused, $box) {
    if ($box === VOID)
      $box = {};
    $box.p81_1 = $nas;
    $box.q81_1 = this$0;
    $box.r81_1 = $pos;
    $box.s81_1 = $paused;
    super(this$0, $box);
    this.m81_1 = volume$factory($nas._v);
    this.n81_1 = pitch$factory($nas._v);
    this.o81_1 = panning$factory($nas._v);
  }
  q7w(_set____db54di) {
    var this_0 = this.m81_1;
    volume$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  r7w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m81_1;
    volume$factory_1();
    return this_0.get();
  }
  o7w(_set____db54di) {
    var this_0 = this.n81_1;
    pitch$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  p7w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n81_1;
    pitch$factory_1();
    return this_0.get();
  }
  s7w(_set____db54di) {
    var this_0 = this.o81_1;
    panning$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  t7w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o81_1;
    panning$factory_1();
    return this_0.get();
  }
}
class SoundAudioData extends Sound {
  constructor(coroutineContext, audioData, soundProvider, closeStream, name, onComplete) {
    closeStream = closeStream === VOID ? false : closeStream;
    name = name === VOID ? 'Unknown' : name;
    onComplete = onComplete === VOID ? null : onComplete;
    super(coroutineContext);
    this.a81_1 = audioData;
    this.b81_1 = soundProvider;
    this.c81_1 = closeStream;
    this.d81_1 = name;
    this.e81_1 = onComplete;
  }
  w3() {
    return this.d81_1;
  }
  u7z(coroutineContext, params) {
    var pos = {_v: 0};
    var paused = {_v: false};
    var times = {_v: new PlaybackTimes(params.f80_1)};
    var nas = {_v: null};
    var tmp = this.b81_1;
    var tmp_0 = this.a81_1.l7v();
    nas._v = tmp.t7y(coroutineContext, tmp_0, this.a81_1.i7v_1, SoundAudioData$play$lambda(paused, this, pos, times, nas));
    copySoundPropsFromCombined(nas._v, params, this);
    nas._v.w7w();
    return new SoundAudioData$play$2(nas, this, pos, paused);
  }
}
class SoundAudioStream$play$slambda$slambda {
  constructor(this$0, $newStream, $params, $playing, $nas, $paused) {
    this.h82_1 = this$0;
    this.i82_1 = $newStream;
    this.j82_1 = $params;
    this.k82_1 = $playing;
    this.l82_1 = $nas;
    this.m82_1 = $paused;
  }
  o1s($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0(this, $this$withContext, $completion), $completion);
  }
  qe(p1, $completion) {
    return this.o1s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    tmp.v82_1 = ConcurrentPool.s39(VOID, VOID, SoundAudioStream$Companion$ID_POOL$lambda);
  }
}
class SoundAudioStream$play$slambda {
  constructor($dispatcherName, $channelId, this$0, $newStream, $params, $playing, $nas, $paused) {
    this.n82_1 = $dispatcherName;
    this.o82_1 = $channelId;
    this.p82_1 = this$0;
    this.q82_1 = $newStream;
    this.r82_1 = $params;
    this.s82_1 = $playing;
    this.t82_1 = $nas;
    this.u82_1 = $paused;
  }
  o1s($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1(this, $this$launch, $completion), $completion);
  }
  qe(p1, $completion) {
    return this.o1s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundAudioStream$play$1 extends SoundChannel {
  constructor($nas, this$0, $newStream, $paused, $playing, $job, $box) {
    if ($box === VOID)
      $box = {};
    $box.g83_1 = this$0;
    $box.h83_1 = $newStream;
    $box.i83_1 = $paused;
    $box.j83_1 = $playing;
    $box.k83_1 = $job;
    super(this$0.g82_1, $box);
    this.d83_1 = volume$factory_2($nas);
    this.e83_1 = pitch$factory_2($nas);
    this.f83_1 = panning$factory_2($nas);
  }
  q7w(_set____db54di) {
    var this_0 = this.d83_1;
    volume$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  r7w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d83_1;
    volume$factory_4();
    return this_0.get();
  }
  o7w(_set____db54di) {
    var this_0 = this.e83_1;
    pitch$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  p7w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e83_1;
    pitch$factory_4();
    return this_0.get();
  }
  s7w(_set____db54di) {
    var this_0 = this.f83_1;
    panning$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  t7w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f83_1;
    panning$factory_4();
    return this_0.get();
  }
}
class SoundAudioStream extends Sound {
  constructor(coroutineContext, stream, soundProvider, closeStream, name, onComplete) {
    Companion_getInstance_20();
    closeStream = closeStream === VOID ? false : closeStream;
    name = name === VOID ? 'Unknown' : name;
    onComplete = onComplete === VOID ? null : onComplete;
    super(coroutineContext);
    this.b82_1 = stream;
    this.c82_1 = soundProvider;
    this.d82_1 = closeStream;
    this.e82_1 = name;
    this.f82_1 = onComplete;
    this.g82_1 = this;
  }
  w3() {
    return this.e82_1;
  }
  u7z(coroutineContext, params) {
    var nas = this.c82_1.a7z(coroutineContext, this.b82_1.o7q_1);
    copySoundPropsFromCombined(nas, params, this);
    var playing = {_v: true};
    var paused = {_v: false};
    var newStream = {_v: null};
    var channelId = Companion_getInstance_20().v82_1.g39();
    var dispatcherName = 'SoundChannel-SoundAudioStream-' + channelId;
    var tmp = CoroutineScope_0(coroutineContext);
    var job = launch(tmp, VOID, VOID, SoundAudioStream$play$slambda_0(dispatcherName, channelId, this, newStream, params, playing, nas, paused));
    return new SoundAudioStream$play$1(nas, this, newStream, paused, playing, job);
  }
}
class HtmlNativeSoundProvider extends NativeSoundProviderNew {
  constructor() {
    super();
    HtmlSimpleSound_getInstance().u83();
  }
  t7y(coroutineContext, channels, frequency, gen) {
    return new JsNewPlatformAudioOutput(coroutineContext, channels, frequency, gen);
  }
  b7z(data, streaming, props, name, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd_1(this, data, streaming, props, name, $completion), $completion);
  }
}
class JsNewPlatformAudioOutput extends NewPlatformAudioOutput {
  constructor(coroutineContext, nchannels, frequency, gen) {
    super(coroutineContext, nchannels, frequency, gen);
    get_nativeSoundProvider();
    this.n84_1 = 0;
    this.o84_1 = false;
    this.p84_1 = null;
    this.q84_1 = null;
  }
  u7w() {
    if (this.o84_1)
      return Unit_instance;
    var tmp = this;
    var tmp_0 = HtmlSimpleSound_getInstance();
    tmp.q84_1 = tmp_0.r84(JsNewPlatformAudioOutput$internalStart$lambda(this));
    this.o84_1 = true;
    this.n84_1 = 0;
  }
  v7w() {
    if (!this.o84_1)
      return Unit_instance;
    var tmp4_safe_receiver = this.q84_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      cancel(tmp4_safe_receiver);
    }
    var tmp5_safe_receiver = this.p84_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.disconnect();
    }
    this.o84_1 = false;
  }
}
class AudioBufferSound$play$2 extends SoundChannel {
  constructor(this$0, $channel, $box) {
    if ($box === VOID)
      $box = {};
    $box.r85_1 = $channel;
    super(this$0, $box);
    var tmp = this;
    var tmp15_safe_receiver = this$0.a86_1;
    var tmp16_safe_receiver = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.e86();
    var tmp_0;
    if (tmp16_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'korlibs.time.seconds' call
      tmp_0 = toDuration(tmp16_safe_receiver, DurationUnit_SECONDS_getInstance());
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_1;
    var tmp_2 = tmp0_elvis_lhs;
    if ((tmp_2 == null ? null : new Duration(tmp_2)) == null) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    tmp.q85_1 = tmp_1;
  }
  q7w(value) {
    var tmp8_safe_receiver = this.r85_1;
    if (tmp8_safe_receiver == null)
      null;
    else {
      tmp8_safe_receiver.q7w(value);
    }
  }
  r7w() {
    var tmp7_safe_receiver = this.r85_1;
    var tmp0_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.c85_1;
    return tmp0_elvis_lhs == null ? 1.0 : tmp0_elvis_lhs;
  }
  o7w(value) {
    var tmp10_safe_receiver = this.r85_1;
    if (tmp10_safe_receiver == null)
      null;
    else {
      tmp10_safe_receiver.o7w(value);
    }
  }
  p7w() {
    var tmp9_safe_receiver = this.r85_1;
    var tmp0_elvis_lhs = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.d85_1;
    return tmp0_elvis_lhs == null ? 1.0 : tmp0_elvis_lhs;
  }
  s7w(value) {
    var tmp12_safe_receiver = this.r85_1;
    if (tmp12_safe_receiver == null)
      null;
    else {
      tmp12_safe_receiver.s7w(value);
    }
  }
  t7w() {
    var tmp11_safe_receiver = this.r85_1;
    var tmp0_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.e85_1;
    return tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  }
}
class AudioBufferSound extends Sound {
  constructor(buffer, url, coroutineContext, name) {
    name = name === VOID ? 'unknown' : name;
    super(coroutineContext);
    this.a86_1 = buffer;
    this.b86_1 = url;
    this.c86_1 = name;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    var tmp0_elvis_lhs = this.a86_1.e86();
    var this_0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    tmp.d86_1 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
  }
  w3() {
    return this.c86_1;
  }
  u7z(coroutineContext, params) {
    var channel = this.a86_1.g86() ? HtmlSimpleSound_getInstance().f86(this.a86_1, params, coroutineContext) : null;
    var tmp = HtmlSimpleSound_getInstance();
    tmp.r84(AudioBufferSound$play$lambda(channel));
    // Inline function 'kotlin.also' call
    var this_0 = new AudioBufferSound$play$2(this, channel);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.sound.AudioBufferSound.play.<anonymous>' call
    copySoundPropsFrom(this_0, params);
    return this_0;
  }
}
class HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda {
  constructor(this$0, $startTime) {
    this.h86_1 = this$0;
    this.i86_1 = $startTime;
  }
  o1s($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2(this, $this$launch, $completion), $completion);
  }
  qe(p1, $completion) {
    return this.o1s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SimpleSoundChannel {
  constructor(buffer, ctx, params, coroutineContext) {
    this.s84_1 = buffer;
    this.t84_1 = ctx;
    this.u84_1 = params;
    this.v84_1 = coroutineContext;
    this.w84_1 = null;
    this.x84_1 = null;
    this.y84_1 = null;
    this.z84_1 = null;
    this.a85_1 = Companion_getInstance_0().h1w();
    this.b85_1 = this.u84_1.f80_1;
    this.c85_1 = this.u84_1.i80_1;
    this.d85_1 = this.u84_1.j80_1;
    this.e85_1 = this.u84_1.k80_1;
    this.f85_1 = true;
    this.g85_1 = null;
    this.h85_1 = null;
  }
  j86(startTime) {
    var tmp23_safe_receiver = this.z84_1;
    if (tmp23_safe_receiver == null)
      null;
    else {
      tmp23_safe_receiver.pause();
    }
    var tmp24_safe_receiver = this.y84_1;
    if (tmp24_safe_receiver == null)
      null;
    else {
      tmp24_safe_receiver.disconnect();
    }
    var htmlAudioElement = this.s84_1.s83_1;
    var audioBuffer = this.s84_1.r83_1;
    var tmp25_safe_receiver = this.t84_1;
    var tmp26_safe_receiver = tmp25_safe_receiver == null ? null : tmp25_safe_receiver.destination;
    if (tmp26_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.audio.sound.SimpleSoundChannel.createNode.<anonymous>' call
      var tmp = this;
      var tmp_0 = HtmlSimpleSound_getInstance();
      tmp.x84_1 = tmp_0.n86(tmp26_safe_receiver, HtmlSimpleSound$SimpleSoundChannel$createNode$lambda(this, htmlAudioElement, audioBuffer));
      this.o86();
    }
    var realHtmlAudioElement = this.z84_1;
    if (!(realHtmlAudioElement == null)) {
      realHtmlAudioElement.currentTime = get_seconds(startTime);
      realHtmlAudioElement.play();
    } else {
      var tmp27_safe_receiver = this.y84_1;
      if (tmp27_safe_receiver == null)
        null;
      else {
        tmp27_safe_receiver.start(0.0, get_seconds(startTime));
      }
    }
  }
  p86(startTime) {
    if (get_job(this.v84_1).y15()) {
      // Inline function 'korlibs.logger.Logger.warn' call
      var this_0 = HtmlSimpleSound_getInstance().l83_1;
      var level = Level_WARN_getInstance();
      var tmp;
      if (this_0.u3g(level)) {
        // Inline function 'korlibs.audio.sound.SimpleSoundChannel.createJobAt.<anonymous>' call
        var tmp$ret$0 = "Sound won't play because coroutineContext.job is completed";
        this_0.v3g(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    this.a85_1 = Companion_getInstance_0().h1w();
    var startTime_0 = {_v: new Duration(startTime)};
    var tmp28_safe_receiver = this.t84_1;
    if (tmp28_safe_receiver == null)
      null;
    else {
      tmp28_safe_receiver.resume();
    }
    var tmp_0 = CoroutineScope_0(this.v84_1);
    return launch(tmp_0, VOID, VOID, HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda_0(this, startTime_0));
  }
  q7w(value) {
    this.c85_1 = value;
    this.q86();
  }
  o7w(value) {
    this.d85_1 = value;
    this.r86();
  }
  s7w(value) {
    this.e85_1 = value;
    this.s86();
  }
  o86() {
    this.q86();
    this.r86();
    this.s86();
  }
  q86() {
    var tmp35_safe_receiver = this.w84_1;
    var tmp36_safe_receiver = tmp35_safe_receiver == null ? null : tmp35_safe_receiver.gain;
    if (tmp36_safe_receiver == null)
      null;
    else {
      tmp36_safe_receiver.value = this.c85_1;
    }
  }
  r86() {
  }
  s86() {
    var tmp37_safe_receiver = this.x84_1;
    if (tmp37_safe_receiver == null)
      null;
    else {
      tmp37_safe_receiver.setPosition(this.e85_1, 0.0, 0.0);
    }
    var tmp38_safe_receiver = this.x84_1;
    if (tmp38_safe_receiver == null)
      null;
    else {
      tmp38_safe_receiver.setOrientation(0.0, 1.0, 0.0);
    }
  }
  m7w() {
    var tmp42_safe_receiver = this.h85_1;
    if (tmp42_safe_receiver == null)
      null;
    else {
      tmp42_safe_receiver.l16();
    }
  }
  i85() {
    if (!(this.h85_1 == null) && !(this.z84_1 == null)) {
      var tmp43_safe_receiver = this.z84_1;
      if (tmp43_safe_receiver == null)
        null;
      else
        tmp43_safe_receiver.play();
    } else {
      this.m7w();
      this.h85_1 = this.p86(this.u84_1.g80_1);
    }
  }
}
class sam$korlibs_io_lang_Cancellable$0 {
  constructor(function_0) {
    this.t86_1 = function_0;
  }
  iu(e) {
    return this.t86_1(e);
  }
}
class HtmlSimpleSound {
  constructor() {
    HtmlSimpleSound_instance = this;
    this.l83_1 = Companion_getInstance_3().ez('HtmlSimpleSound');
    var tmp = this;
    var tmp_0;
    try {
      // Inline function 'kotlin.also' call
      var tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      if (!(typeof window.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        if (!(typeof window.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          tmp_1 = null;
        }
      }
      var this_0 = tmp_1;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
      // Inline function 'kotlin.js.asDynamic' call
      window.globalAudioContext = this_0;
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = this.l83_1;
        var level = Level_ERROR_getInstance();
        var tmp_3;
        if (this_1.u3g(level)) {
          // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
          this_1.v3g(level, e);
          tmp_3 = Unit_instance;
        }
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp.m83_1 = tmp_0;
    this.n83_1 = false;
    this.o83_1 = CompletableDeferred(Job());
    var tmp_4 = this;
    var tmp_5 = this.o83_1;
    tmp_4.p83_1 = isInterface(tmp_5, Deferred) ? tmp_5 : THROW_CCE();
    var tmp47_safe_receiver = this.m83_1;
    var _scratchBuffer = tmp47_safe_receiver == null ? null : tmp47_safe_receiver.createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    unlock._v = HtmlSimpleSound$lambda(unlock, this, _scratchBuffer);
    var tmp_6 = document;
    var tmp_7;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_7 = unlock._v;
    }
    tmp_6.addEventListener('keydown', tmp_7, true);
    var tmp_8 = document;
    var tmp_9;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_9 = unlock._v;
    }
    tmp_8.addEventListener('touchstart', tmp_9, true);
    var tmp_10 = document;
    var tmp_11;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_11 = unlock._v;
    }
    tmp_10.addEventListener('touchend', tmp_11, true);
    var tmp_12 = document;
    var tmp_13;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_13 = unlock._v;
    }
    tmp_12.addEventListener('mousedown', tmp_13, true);
  }
  n86(_this__u8e3s4, callback) {
    var tmp0_elvis_lhs = this.m83_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    // Inline function 'kotlin.Result.getOrNull' call
    // Inline function 'kotlin.runCatching' call
    var tmp_0;
    try {
      // Inline function 'kotlin.Companion.success' call
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.panner.<anonymous>' call
      var value = ctx.createPanner();
      tmp_0 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var this_0 = tmp_0;
    var tmp_2;
    if (_Result___get_isFailure__impl__jpiriv(this_0)) {
      tmp_2 = null;
    } else {
      var tmp_3 = _Result___get_value__impl__bjfvqg(this_0);
      tmp_2 = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
    }
    var tmp1_elvis_lhs = tmp_2;
    var tmp_4;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_4 = tmp1_elvis_lhs;
    }
    var node = tmp_4;
    callback(node);
    node.connect(_this__u8e3s4);
    return node;
  }
  m86(_this__u8e3s4, callback) {
    var tmp0_elvis_lhs = this.m83_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createGain();
    callback(node);
    node.connect(_this__u8e3s4);
    return node;
  }
  u86(_this__u8e3s4, buffer, callback) {
    var tmp0_elvis_lhs = this.m83_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createBufferSource();
    node.buffer = buffer;
    callback(node);
    node.connect(_this__u8e3s4);
    return node;
  }
  k86(_this__u8e3s4, buffer, callback, $super) {
    var tmp;
    if (callback === VOID) {
      tmp = HtmlSimpleSound$source$lambda;
    } else {
      tmp = callback;
    }
    callback = tmp;
    return $super === VOID ? this.u86(_this__u8e3s4, buffer, callback) : $super.u86.call(this, _this__u8e3s4, buffer, callback);
  }
  v86(_this__u8e3s4, buffer, callback) {
    var tmp0_elvis_lhs = this.m83_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createMediaElementSource(buffer);
    callback(node);
    node.connect(_this__u8e3s4);
    return node;
  }
  l86(_this__u8e3s4, buffer, callback, $super) {
    var tmp;
    if (callback === VOID) {
      tmp = HtmlSimpleSound$source$lambda_0;
    } else {
      tmp = callback;
    }
    callback = tmp;
    return $super === VOID ? this.v86(_this__u8e3s4, buffer, callback) : $super.v86.call(this, _this__u8e3s4, buffer, callback);
  }
  f86(buffer, params, coroutineContext) {
    var tmp44_safe_receiver = this.m83_1;
    var tmp;
    if (tmp44_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.playSound.<anonymous>' call
      tmp = new SimpleSoundChannel(buffer, tmp44_safe_receiver, params, coroutineContext);
    }
    return tmp;
  }
  u83() {
  }
  r84(callback) {
    var cancelled = {_v: false};
    this.p83_1.e16(HtmlSimpleSound$callOnUnlocked$lambda(cancelled, callback));
    var tmp = HtmlSimpleSound$callOnUnlocked$lambda_0(cancelled);
    return new sam$korlibs_io_lang_Cancellable$0(tmp);
  }
  w86(data, url, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadSound__rbkbnv(this, data, url, $completion), $completion);
  }
  q83(data, $completion) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.w86(data.buffer, 'ByteArray', $completion);
  }
}
class AudioBufferOrHTMLMediaElement {
  static x86(audioBuffer, htmlAudioElement) {
    var $this = createThis(this);
    $this.r83_1 = audioBuffer;
    $this.s83_1 = htmlAudioElement;
    return $this;
  }
  static t83(audioBuffer) {
    return this.x86(audioBuffer, null);
  }
  y86() {
    return this.r83_1 == null && this.s83_1 == null;
  }
  g86() {
    return !this.y86();
  }
  e86() {
    return !(this.r83_1 == null) ? get_durationOrNull_0(this.r83_1) : !(this.s83_1 == null) ? get_durationOrNull(this.s83_1) : null;
  }
}
//endregion
function get_defaultAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  // Inline function 'kotlin.getValue' call
  var this_0 = defaultAudioFormats$delegate;
  defaultAudioFormats$factory();
  return this_0.b2();
}
var defaultAudioFormats$delegate;
var Companion_instance_0;
function Companion_getInstance_4() {
  return Companion_instance_0;
}
function invalidate($this) {
  $this.a7j_1 = null;
  return $this;
}
function *_generator_tryReadInfo__rowfdh($this, data, props, $completion) {
  var _iterator__ex2g4s = $this.z7i_1.f1();
  $l$loop: while (_iterator__ex2g4s.g1()) {
    var format = _iterator__ex2g4s.h1();
    try {
      var tmp = format.d7j(data.r1u(), props, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var tmp0_elvis_lhs = tmp;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      return tmp_0;
    } catch ($p) {
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          printStackTrace(e_0);
        } else {
          throw $p;
        }
      }
    }
  }
  return null;
}
function *_generator_decodeStreamInternal__hls877($this, data, props, $completion) {
  var _iterator__ex2g4s = $this.z7i_1.f1();
  $l$loop_0: while (_iterator__ex2g4s.g1()) {
    var format = _iterator__ex2g4s.h1();
    try {
      var tmp = format.d7j(data.r1u(), Companion_getInstance_5().f7j_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      if (tmp == null)
        continue $l$loop_0;
      var tmp_0 = format.g7j(data.r1u(), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var tmp0_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      return tmp_1;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  return null;
}
function standardAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  return Companion_instance_0.x7i([Companion_getInstance_13(), Companion_getInstance_10()]);
}
function *_generator_decodeStream__ydjika($this, data, props, $completion) {
  var tmp;
  if (!(props.y7j_1 == null)) {
    var tmp_0 = withContext(props.y7j_1, AudioFormat$decodeStream$slambda_0($this, data, props), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = $this.i7j(data, props, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_decodeStreamOrError__s0emn1($this, data, props, $completion) {
  var tmp = $this.g7j(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var tmp_1 = $this.toString();
    var tmp_2 = readBytesUpTo(data.r1u(), 8, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var message = "Can't decode audio stream [" + tmp_1 + '] ' + toHexString(tmp_2);
    throw IllegalStateException.m5(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function *_generator_encodeToByteArray__x1kcl0($this, data, filename, format, props, $completion) {
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.mv(4096);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.audio.format.AudioFormat.encodeToByteArray.<anonymous>' call
  var tmp = format.j7j(data, toAsync(s), filename, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return buffer.rv();
}
function AudioFormat$decodeStream$slambda_0(this$0, $data, $props) {
  var i = new AudioFormat$decodeStream$slambda(this$0, $data, $props);
  var l = function ($this$withContext, $completion) {
    return i.o1s($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_1;
function Companion_getInstance_5() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_6() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
function invalidAudioFormat(message) {
  message = message === VOID ? 'invalid audio format' : message;
  _init_properties_AudioFormat_kt__9os7np();
  throw InvalidAudioFormatException.j7k(message);
}
function defaultAudioFormats$delegate$lambda() {
  _init_properties_AudioFormat_kt__9os7np();
  return standardAudioFormats();
}
function defaultAudioFormats$factory() {
  return getPropertyCallableRef('defaultAudioFormats', 0, KProperty0, function () {
    return get_defaultAudioFormats();
  }, null);
}
var properties_initialized_AudioFormat_kt_2wpbb7;
function _init_properties_AudioFormat_kt__9os7np() {
  if (!properties_initialized_AudioFormat_kt_2wpbb7) {
    properties_initialized_AudioFormat_kt_2wpbb7 = true;
    defaultAudioFormats$delegate = lazy(defaultAudioFormats$delegate$lambda);
  }
}
var Companion_instance_3;
function Companion_getInstance_7() {
  if (Companion_instance_3 === VOID)
    new Companion_2();
  return Companion_instance_3;
}
var ChannelMode_STEREO_instance;
var ChannelMode_JOINT_STEREO_instance;
var ChannelMode_DUAL_CHANNEL_instance;
var ChannelMode_SINGLE_CHANNEL_instance;
var Companion_instance_4;
function Companion_getInstance_8() {
  ChannelMode_initEntries();
  if (Companion_instance_4 === VOID)
    new Companion_3();
  return Companion_instance_4;
}
function values() {
  return [ChannelMode_STEREO_getInstance(), ChannelMode_JOINT_STEREO_getInstance(), ChannelMode_DUAL_CHANNEL_getInstance(), ChannelMode_SINGLE_CHANNEL_getInstance()];
}
var ChannelMode_entriesInitialized;
function ChannelMode_initEntries() {
  if (ChannelMode_entriesInitialized)
    return Unit_instance;
  ChannelMode_entriesInitialized = true;
  ChannelMode_STEREO_instance = new ChannelMode('STEREO', 0, 0, 2);
  ChannelMode_JOINT_STEREO_instance = new ChannelMode('JOINT_STEREO', 1, 1, 1);
  ChannelMode_DUAL_CHANNEL_instance = new ChannelMode('DUAL_CHANNEL', 2, 2, 2);
  ChannelMode_SINGLE_CHANNEL_instance = new ChannelMode('SINGLE_CHANNEL', 3, 3, 1);
  Companion_getInstance_8();
}
function framesize($this, layer, bitrate, sample_rate, padding_bit) {
  if (sample_rate === 0) {
    // Inline function 'kotlin.error' call
    var message = 'division by 0';
    throw IllegalStateException.m5(toString(message));
  }
  var tmp;
  if (layer === 1) {
    tmp = imul((imul(imul(12, bitrate), 1000) / sample_rate | 0) + padding_bit | 0, 4);
  } else {
    tmp = (imul(imul(144, bitrate), 1000) / sample_rate | 0) + padding_bit | 0;
  }
  return tmp;
}
function ChannelMode_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_STEREO_instance;
}
function ChannelMode_JOINT_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_JOINT_STEREO_instance;
}
function ChannelMode_DUAL_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_DUAL_CHANNEL_instance;
}
function ChannelMode_SINGLE_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_SINGLE_CHANNEL_instance;
}
function *_generator_getSeekingTable__ywx4sa($this, rate, $completion) {
  var times = DoubleArrayList.c32();
  var filePositions = DoubleArrayList.c32();
  var tmp = _getDuration($this, false, MP3Base$Parser$getSeekingTable$lambda(times, filePositions), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  tmp.hk_1;
  return new SeekingTable(times, filePositions, rate);
}
function *_generator__getDuration__467r4t($this, use_cbr_estimate, emit, $completion) {
  $this.x7k_1.t1t_1 = new Long(0, 0);
  var fd = $this.x7k_1.r1u();
  var tmp = fd.y1s($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var len = tmp;
  var durationMicroseconds = 0.0;
  var tmp_0 = readStream(fd, 100, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = skipID3v2Tag($this, tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var offset = tmp_1;
  var pos = offset;
  var info = null;
  var nframes = 0;
  var block2 = _UByteArrayInt___init__impl__xif7bu(new Int8Array(10));
  var fdbase = fd.s1t_1;
  var fdsync = toSyncOrNull(fdbase);
  var nreads = 0;
  var nskips = 0;
  var nasync = 0;
  try {
    $l$loop: while (pos.g2(len) < 0) {
      var tmp_2;
      if (!(fdsync == null)) {
        tmp_2 = fdsync.h1s(pos, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10);
      } else {
        nasync = nasync + 1 | 0;
        fd.t1t_1 = pos;
        var tmp_3 = readBytesUpTo_0(fd, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        tmp_2 = tmp_3;
      }
      var block2Size = tmp_2;
      nreads = nreads + 1 | 0;
      if (block2Size < 10)
        break $l$loop;
      // Inline function 'kotlin.Long.plus' call
      pos = pos.c4(toLong(block2Size));
      if (UByteArrayInt__get_impl_px6q8a(block2, 0) === 255 && !((UByteArrayInt__get_impl_px6q8a(block2, 1) & 224) === 0)) {
        var framePos = fd.t1t_1;
        info = Companion_getInstance_9().f7l(block2);
        if (emit == null)
          null;
        else
          emit(framePos, durationMicroseconds, info);
        nframes = nframes + 1 | 0;
        $this.z7k_1 = info;
        if (info.v7k_1 === 0) {
          // Inline function 'korlibs.time.microseconds' call
          var this_0 = durationMicroseconds;
          var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
          return new Duration(tmp$ret$1);
        }
        // Inline function 'kotlin.Long.plus' call
        var this_1 = pos;
        var other = info.v7k_1 - 10 | 0;
        pos = this_1.c4(toLong(other));
        var tmp_4 = durationMicroseconds;
        // Inline function 'kotlin.Long.div' call
        var this_2 = numberToLong(info.w7k_1).d4(new Long(1000000, 0));
        var other_0 = info.t7k_1;
        durationMicroseconds = tmp_4 + this_2.e4(toLong(other_0)).t4();
      } else if (readString(openSync(_UByteArrayInt___get_bytes__impl__pj0ilc(block2)), 3) === 'TAG') {
        // Inline function 'kotlin.Long.plus' call
        pos = pos.c4(toLong(118));
      } else {
        // Inline function 'kotlin.Long.minus' call
        pos = pos.h2(toLong(9));
        nskips = nskips + 1 | 0;
      }
      if (!(info == null) && use_cbr_estimate) {
        // Inline function 'korlibs.time.microseconds' call
        var tmp_5 = estimateDuration($this, info.s7k_1, info.u7k_1.o7k_1, offset.q2(), $completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        var this_3 = tmp_5;
        var tmp$ret$6 = toDuration_0(this_3, DurationUnit_MICROSECONDS_getInstance());
        return new Duration(tmp$ret$6);
      }
    }
  }finally {
  }
  // Inline function 'korlibs.time.microseconds' call
  var this_4 = durationMicroseconds;
  var tmp$ret$7 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
  return new Duration(tmp$ret$7);
}
function _getDuration($this, use_cbr_estimate, emit, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__getDuration__467r4t($this, use_cbr_estimate, emit, $completion), $completion);
}
function _getDuration$default($this, use_cbr_estimate, emit, $completion, $super) {
  emit = emit === VOID ? null : emit;
  return _getDuration($this, use_cbr_estimate, emit, $completion);
}
function estimateDuration($this, bitrate, channels, offset, $completion) {
  var kbps = imul(bitrate, 1000) / 8 | 0;
  // Inline function 'kotlin.Long.minus' call
  var dataSize = $this.y7k_1.h2(toLong(offset));
  // Inline function 'kotlin.Long.div' call
  // Inline function 'kotlin.Long.times' call
  var other = 2 / channels | 0;
  return dataSize.d4(toLong(other)).d4(new Long(1000000, 0)).e4(toLong(kbps));
}
function *_generator_skipID3v2Tag__vewobn($this, block, $completion) {
  var b = block.r1u();
  var tmp = readString_0(b, 3, Charsets_instance.ly(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp === 'ID3') {
    var tmp_0 = readBytesExact(b, 7, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var bb = tmp_0;
    var id3v2_major_version = getU8(bb, 0);
    var id3v2_minor_version = getU8(bb, 1);
    var id3v2_flags = getU8(bb, 2);
    var z0 = getU8(bb, 3);
    var z1 = getU8(bb, 4);
    var z2 = getU8(bb, 5);
    var z3 = getU8(bb, 6);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_unsynchronisation = !(((id3v2_flags >>> 7 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_extended_header = !(((id3v2_flags >>> 6 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_experimental_ind = !(((id3v2_flags >>> 5 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_footer_present = !(((id3v2_flags >>> 4 | 0) & 1) === 0);
    if ((z0 & 128) === 0 && (z1 & 128) === 0 && (z2 & 128) === 0 && (z3 & 128) === 0) {
      var header_size = 10;
      var tag_size = ((imul(z0 & 127, 2097152) + imul(z1 & 127, 16384) | 0) + imul(z2 & 127, 128) | 0) + (z3 & 127) | 0;
      var footer_size = flag_footer_present ? 10 : 0;
      return toLong((header_size + tag_size | 0) + footer_size | 0);
    }
  }
  return new Long(0, 0);
}
function skipID3v2Tag($this, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_skipID3v2Tag__vewobn($this, block, $completion), $completion);
}
var Companion_instance_5;
function Companion_getInstance_9() {
  if (Companion_instance_5 === VOID)
    new Companion_4();
  return Companion_instance_5;
}
function MP3Base$Parser$getSeekingTable$lambda($times, $filePositions) {
  return function (filePos, totalMicro, info) {
    $times.t2d(totalMicro);
    $filePositions.t2d(filePos.t4());
    return Unit_instance;
  };
}
function *_generator_tryReadInfo__rowfdh_0($this, data, props, $completion) {
  try {
    var tmp = readBytesExact(data, 4, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var header = tmp;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = header.slice();
    var tmp$ret$2 = _UByteArray___init__impl__ip4y9n(tmp$ret$1);
    var this_0 = UByteArray__get_impl_t5f3hv(tmp$ret$2, 0);
    var h0 = _UByte___get_data__impl__jof9qr(this_0) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = header.slice();
    var tmp$ret$6 = _UByteArray___init__impl__ip4y9n(tmp$ret$5);
    var this_1 = UByteArray__get_impl_t5f3hv(tmp$ret$6, 1);
    var h1 = _UByte___get_data__impl__jof9qr(this_1) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = header.slice();
    var tmp$ret$10 = _UByteArray___init__impl__ip4y9n(tmp$ret$9);
    var this_2 = UByteArray__get_impl_t5f3hv(tmp$ret$10, 2);
    var h2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
    var isId3 = readStringz(header, 0, 3) === 'ID3';
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226)) {
      // Inline function 'korlibs.memory.extract2' call
      tmp_2 = !(((h1 >>> 1 | 0) & 3) === 0);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      // Inline function 'korlibs.memory.extract4' call
      tmp_1 = !(((h2 >>> 4 | 0) & 15) === 15);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'korlibs.memory.extract2' call
      tmp_0 = !(((h2 >>> 2 | 0) & 3) === 3);
    } else {
      tmp_0 = false;
    }
    var isSync = tmp_0;
    if (!isId3 && !isSync)
      return null;
    var tmp_3 = data.y1s($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var parser = new Parser(data, tmp_3);
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.bk();
    // Inline function 'korlibs.audio.format.MP3Base.tryReadInfo.<anonymous>' call
    var tmp_4;
    switch (props.u7j_1) {
      case null:
        var tmp_5 = parser.h7l($completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        tmp_4 = tmp_5.hk_1;
        break;
      case true:
        var tmp_6 = parser.h7l($completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        tmp_4 = tmp_6.hk_1;
        break;
      default:
        var tmp_7 = parser.i7l($completion);
        if (tmp_7 === get_COROUTINE_SUSPENDED())
          tmp_7 = yield tmp_7;
        tmp_4 = tmp_7.hk_1;
        break;
    }
    var result = new Duration(tmp_4);
    var _destruct__k2r9zo = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    var duration = _destruct__k2r9zo.km().hk_1;
    var decodingTime = _destruct__k2r9zo.ur();
    var tmp3_safe_receiver = parser.z7k_1;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.u7k_1;
    var tmp0_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.o7k_1;
    return new Info(duration, tmp0_elvis_lhs == null ? 2 : tmp0_elvis_lhs, decodingTime);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      return null;
    } else {
      throw $p;
    }
  }
}
var Companion_instance_6;
function Companion_getInstance_10() {
  if (Companion_instance_6 === VOID)
    new Companion_5();
  return Companion_instance_6;
}
var Minimp3AudioFormat_instance;
function Minimp3AudioFormat_getInstance() {
  if (Minimp3AudioFormat_instance === VOID)
    new Minimp3AudioFormat();
  return Minimp3AudioFormat_instance;
}
function *_generator_read__qih2oe($this, out, offset, length, $completion) {
  var noMoreSamples = false;
  $l$loop: while (ensureNotNull($this.w7p_1.u7m().y7m_1).i12() < length) {
    var tmp = createDecoderStream$readMoreSamples($this.w7p_1, $this.y7p_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!tmp) {
      noMoreSamples = true;
      break $l$loop;
    }
  }
  // Inline function 'kotlin.also' call
  var tmp_0;
  if (noMoreSamples && ensureNotNull($this.w7p_1.u7m().y7m_1).i12() === 0) {
    $this.t7p_1 = true;
    tmp_0 = 0;
  } else {
    tmp_0 = ensureNotNull($this.w7p_1.u7m().y7m_1).f7q(out, offset, length);
  }
  var this_0 = tmp_0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.audio.format.<no name provided>.read.<anonymous>' call
  var tmp_1 = $this;
  // Inline function 'kotlin.Long.plus' call
  tmp_1.v7p_1 = $this.v7p_1.c4(toLong(this_0));
  return this_0;
}
function *_generator_createDecoderStream__oszsb8($this, data, props, table, $completion) {
  var dataStartPosition = data.t1t_1;
  var decoder = $this.n7p();
  decoder.u7m().z33();
  var tmp;
  if (props.u7j_1 === true) {
    var tmp_0;
    if (table == null) {
      var tmp_1;
      var tmp_2 = data.z1s($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      if (tmp_2) {
        var tmp_3 = data.y1s($completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var tmp_4 = (new Parser(data, tmp_3)).q7l(44100, $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        tmp_1 = tmp_4;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = table;
    }
    tmp = tmp_0;
  } else {
    tmp = null;
  }
  var mp3SeekingTable = tmp;
  var tmp_5 = createDecoderStream$readMoreSamples(decoder, data, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return new BaseMinimp3AudioFormat$createDecoderStream$2(decoder, mp3SeekingTable, data, $this, dataStartPosition, props, table);
}
function createDecoderStream($this, data, props, table, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createDecoderStream__oszsb8($this, data, props, table, $completion), $completion);
}
var Companion_instance_7;
function Companion_getInstance_11() {
  if (Companion_instance_7 === VOID)
    new Companion_6();
  return Companion_instance_7;
}
function *_generator_createDecoderStream$readMoreSamples__md5fam(decoder, $data, $completion) {
  $l$loop: while (true) {
    var tmp;
    if (decoder.u7m().x7m_1.i12() < decoder.u7m().w7m_1.length) {
      var tmp_0 = $data.p1u($completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_1 = decoder.u7m().x7m_1;
      var tmp_2 = readBytesUpTo($data, 4096, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1.y2z(tmp_2);
    }
    var result = decoder.u7m().g7q(decoder);
    if (decoder.u7m().z7m_1 === 0 || decoder.u7m().b7n_1 === 0)
      continue $l$loop;
    return result;
  }
}
function createDecoderStream$readMoreSamples(decoder, $data, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createDecoderStream$readMoreSamples__md5fam(decoder, $data, $completion), $completion);
}
function arrayOfUByte($this, values, size) {
  return _UByteArrayInt___init__impl__xif7bu_0(size, MiniMp3Program$Companion$arrayOfUByte$lambda(values));
}
function arrayOfUByte$default($this, values, size, $super) {
  size = size === VOID ? values.length : size;
  return arrayOfUByte($this, values, size);
}
function arrayOfShort($this, values, size) {
  var tmp = 0;
  var tmp_0 = new Int16Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    // Inline function 'kotlin.code' call
    // Inline function 'kotlin.text.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2;
    if (0 <= tmp_1 ? tmp_1 <= (charSequenceLength(values) - 1 | 0) : false) {
      tmp_2 = charSequenceGet(values, tmp_1);
    } else {
      // Inline function 'korlibs.audio.format.Companion.arrayOfShort.<anonymous>' call
      tmp_2 = _Char___init__impl__6a9atx(0);
    }
    var this_0 = tmp_2;
    var tmp$ret$2 = Char__toInt_impl_vasixd(this_0);
    tmp_0[tmp_1] = toShort(tmp$ret$2);
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function arrayOfShort$default($this, values, size, $super) {
  size = size === VOID ? values.length : size;
  return arrayOfShort($this, values, size);
}
function MiniMp3Program$Companion$arrayOfUByte$lambda($values) {
  return function (it) {
    // Inline function 'kotlin.code' call
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = $values;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= it ? it <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, it);
    } else {
      // Inline function 'korlibs.audio.format.Companion.arrayOfUByte.<anonymous>.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    var this_1 = tmp;
    return Char__toInt_impl_vasixd(this_1);
  };
}
var Companion_instance_8;
function Companion_getInstance_12() {
  if (Companion_instance_8 === VOID)
    new Companion_7();
  return Companion_instance_8;
}
function toInt_0(_this__u8e3s4, $this) {
  return _this__u8e3s4 ? 1 : 0;
}
function *_generator_read__qih2oe_0($this, out, offset, length, $completion) {
  var tmp = readBytesUpTo($this.h7u_1, imul(imul(length, $this.l7u_1), $this.p7q_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var bytes = tmp;
  var tmp_0 = $this;
  var tmp_1 = $this.h7u_1.s1u($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  tmp_0.m7u_1 = tmp_1;
  var availableSamples = (bytes.length / $this.l7u_1 | 0) / $this.p7q_1 | 0;
  var inductionVariable = 0;
  var last = $this.p7q_1;
  if (inductionVariable < last)
    do {
      var channel = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      switch ($this.l7u_1) {
        case 1:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_13();
          var channels = $this.p7q_1;
          var bytesPerSample = $this.l7u_1;
          var increment = imul(channels, bytesPerSample);
          var index = imul(channel, bytesPerSample);
          var outc = out.i1(channel);
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < availableSamples)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp_2 = offset + n | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it = index;
              outc[tmp_2] = coerceToShort(imul(getU8(bytes, it) - 128 | 0, 255));
              index = index + increment | 0;
            }
             while (inductionVariable_0 < availableSamples);
          break;
        case 2:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_13();
          var channels_0 = $this.p7q_1;
          var bytesPerSample_0 = $this.l7u_1;
          var increment_0 = imul(channels_0, bytesPerSample_0);
          var index_0 = imul(channel, bytesPerSample_0);
          var outc_0 = out.i1(channel);
          var inductionVariable_1 = 0;
          if (inductionVariable_1 < availableSamples)
            do {
              var n_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var tmp_3 = offset + n_0 | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it_0 = index_0;
              outc_0[tmp_3] = toShort(getS16LE(bytes, it_0));
              index_0 = index_0 + increment_0 | 0;
            }
             while (inductionVariable_1 < availableSamples);
          break;
        case 3:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_13();
          var channels_1 = $this.p7q_1;
          var bytesPerSample_1 = $this.l7u_1;
          var increment_1 = imul(channels_1, bytesPerSample_1);
          var index_1 = imul(channel, bytesPerSample_1);
          var outc_1 = out.i1(channel);
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < availableSamples)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var tmp_4 = offset + n_1 | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it_1 = index_1;
              outc_1[tmp_4] = toShort(getS24LE(bytes, it_1) >>> 8 | 0);
              index_1 = index_1 + increment_1 | 0;
            }
             while (inductionVariable_2 < availableSamples);
          break;
        default:
          invalidOp('Unsupported bytesPerSample=' + $this.l7u_1);
          break;
      }
    }
     while (inductionVariable < last);
  return availableSamples;
}
function *_generator_clone__nh2r5j($this, $completion) {
  var tmp = (new WAV()).i7j($this.j7u_1.r1u(), $this.k7u_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return ensureNotNull(tmp);
}
function *_generator_invoke__zhh2q8($this, $this$riff, $completion) {
  var type = $this$riff.km();
  var d2 = $this$riff.lm();
  var d = d2.r1u();
  var cdata = Unit_instance;
  switch (type) {
    case 'fmt ':
      var tmp = $this.t7u_1;
      var tmp_0 = readS16LE(d, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp.w7u_1 = tmp_0;
      var tmp_1 = $this.t7u_1;
      var tmp_2 = readS16LE(d, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1.x7u_1 = tmp_2;
      var tmp_3 = $this.t7u_1;
      var tmp_4 = readS32LE(d, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp_3.y7u_1 = tmp_4;
      var tmp_5 = $this.t7u_1;
      var tmp_6 = readU32LE(d, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      tmp_5.z7u_1 = tmp_6;
      var tmp_7 = $this.t7u_1;
      var tmp_8 = readS16LE(d, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      tmp_7.a7v_1 = tmp_8;
      var tmp_9 = $this.t7u_1;
      var tmp_10 = readS16LE(d, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
      tmp_9.b7v_1 = tmp_10;
      cdata = $this.t7u_1;
      break;
    case 'data':
      var tmp_11 = $this.u7u_1._v;
      var tmp_12 = d.y1s($completion);
      if (tmp_12 === get_COROUTINE_SUSPENDED())
        tmp_12 = yield tmp_12;
      $this.u7u_1._v = tmp_11.c4(tmp_12);
      cdata = d;
      break;
    default:
      break;
  }
  $this.v7u_1(new ProcessedChunk($this$riff.r7u_1, $this$riff.s7u_1, cdata));
  return Unit_instance;
}
var Companion_instance_9;
function Companion_getInstance_13() {
  if (Companion_instance_9 === VOID)
    new Companion_8();
  return Companion_instance_9;
}
function *_generator_tryReadInfo__rowfdh_1($this, data, props, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.c7v(data, WAV$tryReadInfo$lambda, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
    }
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_decodeStreamInternal__hls877_0($this, data, props, $completion) {
  var fmt = {_v: new Fmt()};
  var buffer = {_v: toAsync(MemorySyncStream_0())};
  var tmp = $this.c7v(data, WAV$decodeStreamInternal$lambda(fmt, buffer), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = fmt._v;
  var tmp_1 = buffer._v;
  var tmp_2 = buffer._v.y1s($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return new WavAudioStream(tmp_0, tmp_1, tmp_2, data, props);
}
function *_generator_encode__nikamm($this, data, out, filename, props, $completion) {
  var bytesPerSample = 2;
  var tmp = writeString(out, 'RIFF', VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = write32LE(out, 36 + imul(imul(data.j7v_1.o7u_1, bytesPerSample), data.l7v()) | 0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = writeString(out, 'WAVE', VOID, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = writeString(out, 'fmt ', VOID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = write32LE(out, 16, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = write16LE(out, 1, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = write16LE(out, data.l7v(), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = write32LE(out, data.i7v_1, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp_7 = write32LE(out, imul(imul(data.i7v_1, data.l7v()), bytesPerSample), $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp_8 = write16LE(out, bytesPerSample, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  var tmp_9 = write16LE(out, imul(bytesPerSample, 8), $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  var tmp_10 = writeString(out, 'data', VOID, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  var tmp_11 = write32LE(out, imul(imul(data.j7v_1.o7u_1, bytesPerSample), data.l7v()), $completion);
  if (tmp_11 === get_COROUTINE_SUSPENDED())
    tmp_11 = yield tmp_11;
  var array = interleaved(data.j7v_1).o7v_1;
  var tmp_12 = writeShortArrayLE(out, array, $completion);
  if (tmp_12 === get_COROUTINE_SUSPENDED())
    tmp_12 = yield tmp_12;
  return Unit_instance;
}
function *_generator_parse__tgo4f5($this, data, handle, $completion) {
  var fmt = new Fmt();
  var dataSize = {_v: new Long(0, 0)};
  var tmp = $this.d7v(data, WAV$parse$slambda_0(fmt, dataSize, handle), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (fmt.w7u_1 < 0) {
    invalidOp("Couldn't find RIFF 'fmt ' chunk");
  }
  // Inline function 'korlibs.time.microseconds' call
  // Inline function 'kotlin.Long.times' call
  // Inline function 'kotlin.Long.times' call
  var this_0 = dataSize._v.d4(toLong(1000)).d4(toLong(1000)).e4(fmt.z7u_1);
  var tmp$ret$2 = toDuration_0(this_0, DurationUnit_MICROSECONDS_getInstance());
  return new Info(tmp$ret$2, fmt.x7u_1);
}
function *_generator_riff__qieez3($this, data, handler, $completion) {
  var s2 = data.r1u();
  var tmp = s2.q1u($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp.g2(new Long(12, 0)) < 0) {
    // Inline function 'kotlin.error' call
    var message = 'Not enough data for a RIFF file';
    throw IllegalStateException.m5(toString(message));
  }
  var tmp_0 = readString_0(s2, 4, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var magic = tmp_0;
  var tmp_1 = readS32LE(s2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var length = tmp_1;
  var tmp_2 = readString_0(s2, 4, VOID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var magic2 = tmp_2;
  if (!(magic === 'RIFF')) {
    invalidAudioFormat("Not a RIFF file but '" + magic + "'");
  }
  if (!(magic2 === 'WAVE')) {
    invalidAudioFormat('Not a RIFF + WAVE file');
  }
  var tmp_3 = readStream(s2, length - 4 | 0, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var s = tmp_3;
  $l$loop_1: while (true) {
    var tmp_4 = s.s1u($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    if (!!tmp_4) {
      break $l$loop_1;
    }
    var tmp_5 = s.q1u($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    if (tmp_5.g2(new Long(8, 0)) < 0)
      break $l$loop_1;
    var tmp_6 = readString_0(s, 4, VOID, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var type = tmp_6;
    var tmp_7 = readS32LE(s, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    var size = tmp_7;
    var tmp_8 = s.q1u($completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    if (tmp_8.g2(toLong(size)) < 0)
      break $l$loop_1;
    var tmp_9 = readStream(s, size, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    var d = tmp_9;
    var tmp_10 = handler(new Chunk(type, d), $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
  }
  return Unit_instance;
}
function WAV$tryReadInfo$lambda(it) {
  return Unit_instance;
}
function WAV$decodeStreamInternal$lambda($fmt, $buffer) {
  return function (it) {
    var extra = it.g7v_1;
    var tmp;
    if (extra instanceof Fmt) {
      $fmt._v = extra;
      tmp = Unit_instance;
    }
    var tmp_0;
    if (it.e7v_1 === 'data') {
      $buffer._v = it.f7v_1;
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function WAV$parse$slambda_0($fmt, $dataSize, $handle) {
  var i = new WAV$parse$slambda($fmt, $dataSize, $handle);
  var l = function ($this$riff, $completion) {
    return i.p7v($this$riff, $completion);
  };
  l.$arity = 1;
  return l;
}
function coerceToShort(_this__u8e3s4) {
  return toShort(coerceIn(_this__u8e3s4, -32768, 32767));
}
var SampleConvert_instance;
function SampleConvert_getInstance() {
  return SampleConvert_instance;
}
function AudioData$Companion$DUMMY$delegate$lambda() {
  return new AudioData(44100, new AudioSamples(2, 0));
}
var Companion_instance_10;
function Companion_getInstance_14() {
  if (Companion_instance_10 === VOID)
    new Companion_9();
  return Companion_instance_10;
}
function AudioData$samplesInterleaved$delegate$lambda(this$0) {
  return function () {
    return interleaved(this$0.j7v_1);
  };
}
function DUMMY$factory() {
  return getPropertyCallableRef('DUMMY', 1, KProperty1, function (receiver) {
    return receiver.s7v();
  }, null);
}
function index($this, channel, sample) {
  return imul(sample, $this.m7v_1) + channel | 0;
}
function interleaved(_this__u8e3s4, out) {
  out = out === VOID ? new AudioSamplesInterleaved(_this__u8e3s4.n7u_1, _this__u8e3s4.o7u_1) : out;
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(out.o7v_1.length >= imul(_this__u8e3s4.o7u_1, _this__u8e3s4.n7u_1))) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message = 'Check failed.';
    throw IllegalStateException.m5(toString(message));
  }
  switch (_this__u8e3s4.n7u_1) {
    case 1:
      arraycopy_1(_this__u8e3s4.p7u_1[0], 0, out.o7v_1, 0, _this__u8e3s4.o7u_1);
      break;
    case 2:
      arrayinterleave(out.o7v_1, 0, _this__u8e3s4.p7u_1[0], 0, _this__u8e3s4.p7u_1[1], 0, _this__u8e3s4.o7u_1);
      break;
    default:
      var outData = out.o7v_1;
      var channels = _this__u8e3s4.n7u_1;
      var inductionVariable = 0;
      if (inductionVariable < channels)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var m = c;
          var inductionVariable_0 = 0;
          var last = _this__u8e3s4.o7u_1;
          if (inductionVariable_0 < last)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              outData[m] = _this__u8e3s4.z2k(c, n);
              m = m + channels | 0;
            }
             while (inductionVariable_0 < last);
        }
         while (inductionVariable < channels);
      break;
  }
  return out;
}
function arraycopy_1(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arrayinterleave(out, outPos, array1, array1Pos, array2, array2Pos, size) {
  var m = outPos;
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = m;
      m = _unary__edvuaz + 1 | 0;
      out[_unary__edvuaz] = array1[array1Pos + n | 0];
      var _unary__edvuaz_0 = m;
      m = _unary__edvuaz_0 + 1 | 0;
      out[_unary__edvuaz_0] = array2[array2Pos + n | 0];
    }
     while (inductionVariable < size);
}
function separated(_this__u8e3s4, out) {
  out = out === VOID ? new AudioSamples(_this__u8e3s4.l7v(), _this__u8e3s4.t7v()) : out;
  var inductionVariable = 0;
  var last = _this__u8e3s4.t7v();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = _this__u8e3s4.l7v();
      if (inductionVariable_0 < last_0)
        do {
          var c = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out.u7v(c, n, _this__u8e3s4.z2k(c, n));
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return out;
}
var DEFAULT_MAX_SAMPLES;
var Companion_instance_11;
function Companion_getInstance_15() {
  return Companion_instance_11;
}
function *_generator_toData__gg6t99(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  var out = new AudioSamplesDeque(_this__u8e3s4.p7q_1);
  // Inline function 'kotlin.math.min' call
  var tmp$ret$0 = Math.min(maxSamples, 65536);
  var buffer = new AudioSamples(_this__u8e3s4.p7q_1, tmp$ret$0);
  try {
    $l$loop_0: while (!_this__u8e3s4.k7q()) {
      // Inline function 'kotlin.math.min' call
      var a = maxSamples - out.i12() | 0;
      var b = buffer.o7u_1;
      var tmp$ret$1 = Math.min(a, b);
      var tmp = _this__u8e3s4.m7q(buffer, 0, tmp$ret$1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var read = tmp;
      if (read <= 0)
        break $l$loop_0;
      // Inline function 'kotlin.math.min' call
      var b_0 = maxSamples - out.i12() | 0;
      var mread = Math.min(read, b_0);
      out.x7v(buffer, 0, mread);
      if (out.i12() >= maxSamples)
        break $l$loop_0;
    }
  }finally {
    _this__u8e3s4.u6();
  }
  var maxOutSamples = out.v7v();
  // Inline function 'kotlin.apply' call
  var this_0 = new AudioSamples(_this__u8e3s4.p7q_1, maxOutSamples);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.audio.sound.toData.<anonymous>' call
  out.a7w(this_0);
  return new AudioData(_this__u8e3s4.o7q_1, this_0);
}
function toData(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_toData__gg6t99(_this__u8e3s4, maxSamples, $completion), $completion);
}
function NewPlatformAudioOutput$start$lambda(this$0) {
  return function () {
    this$0.m7w();
    return Unit_instance;
  };
}
function *_generator_add__cbj1ot($this, samples, offset, size, $completion) {
  // Inline function 'korlibs.time.milliseconds' call
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
  var tmp = delay(tmp$ret$1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_wait__qfshcd($this, $completion) {
  while ($this.e7x() > 0) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(10, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function PlatformAudioOutputBasedOnNew$new$lambda(this$0) {
  return function (buffer) {
    this$0.v7x(buffer, VOID, VOID, VOID, true);
    return Unit_instance;
  };
}
var Companion_instance_12;
function Companion_getInstance_16() {
  return Companion_instance_12;
}
function updateProps($this) {
  var rratio = clamp01(($this.t7w() + 1.0) / 2.0);
  var lratio = 1.0 - rratio;
  $this.u7x_1[0] = $this.r7w() * lratio;
  $this.u7x_1[1] = $this.r7w() * rratio;
}
function _readShort($this, channel) {
  return $this.p7x_1.i12() >= 1 ? toShortClamped(numberToInt($this.p7x_1.k3p(channel) * $this.u7x_1[channel])) : 0;
}
function *_generator_add__cbj1ot_0($this, samples, offset, size, $completion) {
  while ($this.p7x_1.i12() >= 16384) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
    var this_0 = $this.o7x_1;
    this_0.w1w();
    try {
      $this.p7x_1.x7v(samples, offset, size);
      break $l$block;
    }finally {
      this_0.z1w();
    }
  }
  return Unit_instance;
}
function *_generator_createSound__kkt3xd($this, data, streaming, props, name, $completion) {
  var tmp0_elvis_lhs = props.w7j_1;
  var format = tmp0_elvis_lhs == null ? $this.w7y() : tmp0_elvis_lhs;
  var tmp = format.l7j(openAsync(data), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var stream = tmp;
  var tmp_0;
  if (streaming) {
    var tmp_1 = $this.y7y(stream, true, name, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    var tmp_2 = toData(stream, VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = $this.x7y(tmp_2, name, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  }
  return tmp_0;
}
function *_generator_createSound__kkt3xd_0($this, data, formats, streaming, name, $completion) {
  var tmp = Companion_getInstance_13().n7j(data, VOID, VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.z7y(tmp, streaming, VOID, name, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function NativeSoundProvider$audioFormats$delegate$lambda() {
  return get_defaultAudioFormats();
}
var Companion_instance_13;
function Companion_getInstance_17() {
  if (Companion_instance_13 === VOID)
    new Companion_12();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_18() {
  if (Companion_instance_14 === VOID)
    new Companion_13();
  return Companion_instance_14;
}
function copySoundPropsFrom(_this__u8e3s4, other) {
  _this__u8e3s4.q7w(other.r7w());
  _this__u8e3s4.o7w(other.p7w());
  _this__u8e3s4.s7w(other.t7w());
}
function _PlaybackTimes___init__impl__rt6rw2(count) {
  return count;
}
function _PlaybackTimes___get_count__impl__ll6dcs($this) {
  return $this;
}
var Companion_instance_15;
function Companion_getInstance_19() {
  if (Companion_instance_15 === VOID)
    new Companion_14();
  return Companion_instance_15;
}
function _PlaybackTimes___get_hasMore__impl__ei8boc($this) {
  return !($this === Companion_getInstance_19().o80_1);
}
function _PlaybackTimes___get_oneLess__impl__ea0jl8($this) {
  return $this === Companion_getInstance_19().q80_1 ? Companion_getInstance_19().q80_1 : _PlaybackTimes___init__impl__rt6rw2(_PlaybackTimes___get_count__impl__ll6dcs($this) - 1 | 0);
}
function PlaybackTimes__toString_impl_l4chjq($this) {
  return _PlaybackTimes___get_count__impl__ll6dcs($this) >= 0 ? '' + _PlaybackTimes___get_count__impl__ll6dcs($this) + ' times' : 'Infinite times';
}
function PlaybackTimes__hashCode_impl_mtf95($this) {
  return $this;
}
function PlaybackTimes__equals_impl_suah7n($this, other) {
  if (!(other instanceof PlaybackTimes))
    return false;
  if (!($this === (other instanceof PlaybackTimes ? other.r80_1 : THROW_CCE())))
    return false;
  return true;
}
function applyPropsTo(_this__u8e3s4, samples) {
  var inductionVariable = 0;
  var last = samples.m7v_1;
  if (inductionVariable < last)
    do {
      var ch = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var volume01 = volumeForChannel(_this__u8e3s4, ch);
      var inductionVariable_0 = 0;
      var last_0 = samples.n7v_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var sample = samples.z2k(ch, n);
          sample = toShort(numberToInt(sample * volume01));
          samples.u7v(ch, n, sample);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function copySoundPropsFromCombined(_this__u8e3s4, l, r) {
  _this__u8e3s4.q7w(l.r7w() * r.r7w());
  _this__u8e3s4.o7w(l.p7w() * r.p7w());
  _this__u8e3s4.s7w(r.t7w());
}
function volumeForChannel(_this__u8e3s4, channel) {
  return channel === 0 ? convertRangeClamped(_this__u8e3s4.t7w(), -1.0, 0.0, 0.0, 1.0) : 1.0 - convertRangeClamped(_this__u8e3s4.t7w(), 0.0, 1.0, 0.0, 1.0);
}
function audioFormats$factory() {
  return getPropertyCallableRef('audioFormats', 1, KProperty1, function (receiver) {
    return receiver.w7y();
  }, null);
}
function SoundAudioData$play$lambda($paused, this$0, $pos, $times, $nas) {
  return function (it) {
    var tmp;
    if ($paused._v) {
      var inductionVariable = 0;
      var last = it.m7v_1;
      if (inductionVariable < last)
        do {
          var ch = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          fill_1(this$0.a81_1.i1(ch), 0);
        }
         while (inductionVariable < last);
      return Unit_instance;
    }
    var inductionVariable_0 = 0;
    var last_0 = it.m7v_1;
    var tmp_0;
    if (inductionVariable_0 < last_0) {
      loop: do {
        var ch_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var audioDataCh = this$0.a81_1.i1(ch_0);
        var inductionVariable_1 = 0;
        var last_1 = it.n7v_1;
        if (inductionVariable_1 < last_1)
          do {
            var n = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var audioDataPos = $pos._v + n | 0;
            var sample = audioDataPos < audioDataCh.length ? audioDataCh[audioDataPos] : 0;
            it.u7v(ch_0, n, sample);
          }
           while (inductionVariable_1 < last_1);
      }
       while (inductionVariable_0 < last_0);
      tmp_0 = Unit_instance;
    }
    $pos._v = $pos._v + it.n7v_1 | 0;
    var tmp_1;
    if ($pos._v >= this$0.a81_1.t7v()) {
      $pos._v = 0;
      $times._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($times._v.r80_1));
      var tmp_2;
      if ($times._v.equals(new PlaybackTimes(Companion_getInstance_19().o80_1))) {
        var tmp37_safe_receiver = $nas._v;
        if (tmp37_safe_receiver == null)
          null;
        else {
          tmp37_safe_receiver.m7w();
        }
        tmp_2 = Unit_instance;
      }
      tmp_1 = tmp_2;
    }
    return Unit_instance;
  };
}
function SoundAudioStream$Companion$ID_POOL$lambda(it) {
  return it;
}
function *_generator_invoke__zhh2q8_0($this, $this$withContext, $completion) {
  var tmp = $this.h82_1.b82_1.n7q($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var stream = tmp;
  $this.i82_1._v = stream;
  stream.t7q($this.j82_1.g80_1);
  $this.k82_1._v = true;
  var times = $this.j82_1.f80_1;
  var tmp_0;
  try {
    var temp = new AudioSamples(stream.p7q_1, 1024);
    var nchannels = 2;
    var minBuf = numberToInt(imul(stream.o7q_1, nchannels) * get_seconds($this.j82_1.h80_1));
    $this.l82_1.w7w();
    while (_PlaybackTimes___get_hasMore__impl__ei8boc(times)) {
      stream.l7q(new Long(0, 0));
      while (!stream.k7q()) {
        while ($this.m82_1._v) {
          // Inline function 'korlibs.time.milliseconds' call
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$1 = toDuration(2, DurationUnit_MILLISECONDS_getInstance());
          var tmp_1 = delay(tmp$ret$1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
        }
        var tmp_2 = stream.m7q(temp, 0, temp.o7u_1, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        var read = tmp_2;
        var tmp_3 = $this.l82_1.f7x(temp, 0, read, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        $l$loop: while (true) {
          var containsUpper = imul(minBuf, 2);
          var containsArg = $this.l82_1.e7x();
          if (!(minBuf <= containsArg ? containsArg <= containsUpper : false)) {
            break $l$loop;
          }
          // Inline function 'korlibs.time.milliseconds' call
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$3 = toDuration(2, DurationUnit_MILLISECONDS_getInstance());
          var tmp_4 = delay(tmp$ret$3, $completion);
          if (tmp_4 === get_COROUTINE_SUSPENDED())
            tmp_4 = yield tmp_4;
        }
        var tmp_5;
        var containsUpper_0 = imul(minBuf, 2);
        var containsArg_0 = $this.l82_1.e7x();
        if (!(minBuf <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false)) {
          tmp_5 = !stream.k7q();
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          // Inline function 'korlibs.time.milliseconds' call
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$5 = toDuration(2, DurationUnit_MILLISECONDS_getInstance());
          var tmp_6 = delay(tmp$ret$5, $completion);
          if (tmp_6 === get_COROUTINE_SUSPENDED())
            tmp_6 = yield tmp_6;
        }
      }
      times = _PlaybackTimes___get_oneLess__impl__ea0jl8(times);
    }
    tmp_0 = Unit_instance;
  } catch ($p) {
    var tmp_7;
    if ($p instanceof CancellationException) {
      var e = $p;
      $this.l82_1.m7w();
      var tmp38_safe_receiver = $this.j82_1.m80_1;
      tmp_7 = tmp38_safe_receiver == null ? null : tmp38_safe_receiver();
    } else {
      throw $p;
    }
    tmp_0 = tmp_7;
  }
  finally {
    var tmp_8 = $this.l82_1.g7x($completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    $this.l82_1.m7w();
    if ($this.h82_1.d82_1) {
      stream.u6();
    }
    $this.k82_1._v = false;
    var tmp39_safe_receiver = $this.j82_1.n80_1;
    if (tmp39_safe_receiver == null)
      null;
    else
      tmp39_safe_receiver();
    var tmp40_safe_receiver = $this.h82_1.f82_1;
    if (tmp40_safe_receiver == null)
      null;
    else {
      var tmp_9 = tmp40_safe_receiver($completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
    }
  }
  return tmp_0;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var dispatcher = Companion_getInstance_1().vw().yw() ? null : createSingleThreadedDispatcher(Dispatchers_getInstance(), $this.n82_1);
  try {
    var tmp = dispatcher == null ? EmptyCoroutineContext_getInstance() : dispatcher;
    var tmp_0 = withContext(tmp, SoundAudioStream$play$slambda$slambda_0($this.p82_1, $this.q82_1, $this.r82_1, $this.s82_1, $this.t82_1, $this.u82_1), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }finally {
    Companion_getInstance_20().v82_1.h39($this.o82_1);
    if (dispatcher instanceof CloseableCoroutineDispatcher) {
      dispatcher.u6();
    } else {
      if (!(dispatcher == null) ? isInterface(dispatcher, AutoCloseable) : false) {
        dispatcher.u6();
      }
    }
  }
  return Unit_instance;
}
function SoundAudioStream$play$slambda$slambda_0(this$0, $newStream, $params, $playing, $nas, $paused) {
  var i = new SoundAudioStream$play$slambda$slambda(this$0, $newStream, $params, $playing, $nas, $paused);
  var l = function ($this$withContext, $completion) {
    return i.o1s($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_16;
function Companion_getInstance_20() {
  if (Companion_instance_16 === VOID)
    new Companion_15();
  return Companion_instance_16;
}
function SoundAudioStream$play$slambda_0($dispatcherName, $channelId, this$0, $newStream, $params, $playing, $nas, $paused) {
  var i = new SoundAudioStream$play$slambda($dispatcherName, $channelId, this$0, $newStream, $params, $playing, $nas, $paused);
  var l = function ($this$launch, $completion) {
    return i.o1s($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function volume$factory($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.r7w();
  }, function (value) {
    return $b0.q7w(value);
  });
}
function pitch$factory($b0) {
  return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
    return $b0.p7w();
  }, function (value) {
    return $b0.o7w(value);
  });
}
function panning$factory($b0) {
  return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
    return $b0.t7w();
  }, function (value) {
    return $b0.s7w(value);
  });
}
function volume$factory_0() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.r7w();
  }, function (receiver, value) {
    return receiver.q7w(value);
  });
}
function volume$factory_1() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.r7w();
  }, function (receiver, value) {
    return receiver.q7w(value);
  });
}
function pitch$factory_0() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.p7w();
  }, function (receiver, value) {
    return receiver.o7w(value);
  });
}
function pitch$factory_1() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.p7w();
  }, function (receiver, value) {
    return receiver.o7w(value);
  });
}
function panning$factory_0() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.t7w();
  }, function (receiver, value) {
    return receiver.s7w(value);
  });
}
function panning$factory_1() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.t7w();
  }, function (receiver, value) {
    return receiver.s7w(value);
  });
}
function volume$factory_2($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.r7w();
  }, function (value) {
    return $b0.q7w(value);
  });
}
function pitch$factory_2($b0) {
  return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
    return $b0.p7w();
  }, function (value) {
    return $b0.o7w(value);
  });
}
function panning$factory_2($b0) {
  return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
    return $b0.t7w();
  }, function (value) {
    return $b0.s7w(value);
  });
}
function volume$factory_3() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.r7w();
  }, function (receiver, value) {
    return receiver.q7w(value);
  });
}
function volume$factory_4() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.r7w();
  }, function (receiver, value) {
    return receiver.q7w(value);
  });
}
function pitch$factory_3() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.p7w();
  }, function (receiver, value) {
    return receiver.o7w(value);
  });
}
function pitch$factory_4() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.p7w();
  }, function (receiver, value) {
    return receiver.o7w(value);
  });
}
function panning$factory_3() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.t7w();
  }, function (receiver, value) {
    return receiver.s7w(value);
  });
}
function panning$factory_4() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.t7w();
  }, function (receiver, value) {
    return receiver.s7w(value);
  });
}
function get_nativeSoundProvider() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  // Inline function 'kotlin.getValue' call
  var this_0 = nativeSoundProvider$delegate;
  nativeSoundProvider$factory();
  return this_0.b2();
}
var nativeSoundProvider$delegate;
function *_generator_createSound__kkt3xd_1($this, data, streaming, props, name, $completion) {
  var tmp = HtmlSimpleSound_getInstance().q83(data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = AudioBufferOrHTMLMediaElement.t83(tmp);
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.gd();
  return new AudioBufferSound(tmp_0, '#bytes', tmp$ret$0, name);
}
function JsNewPlatformAudioOutput$internalStart$lambda$lambda(this$0, $samples, $bufferSize, $scale) {
  return function (e) {
    this$0.n7w($samples);
    var separated_0 = separated($samples);
    var inductionVariable = 0;
    var last = this$0.c7w_1;
    var tmp;
    if (inductionVariable < last) {
      do {
        var ch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var outCh = e.outputBuffer.getChannelData(ch);
        var data = separated_0.i1(ch);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < $bufferSize)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            outCh[n] = SampleConvert_instance.q7v(getSampled(data, n * $scale));
          }
           while (inductionVariable_0 < $bufferSize);
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function JsNewPlatformAudioOutput$internalStart$lambda(this$0) {
  return function (it) {
    var ctx = HtmlSimpleSound_getInstance().m83_1;
    var tmp;
    if (!(ctx == null)) {
      var bufferSize = 1024;
      var scale = this$0.d7w_1 / ctx.sampleRate;
      var samples = new AudioSamplesInterleaved(this$0.c7w_1, numberToInt(bufferSize * scale));
      this$0.p84_1 = ctx.createScriptProcessor(bufferSize, this$0.c7w_1, this$0.c7w_1);
      var tmp2_safe_receiver = this$0.p84_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.onaudioprocess = JsNewPlatformAudioOutput$internalStart$lambda$lambda(this$0, samples, bufferSize, scale);
      }
      var tmp3_safe_receiver = this$0.p84_1;
      if (tmp3_safe_receiver == null)
        null;
      else
        tmp3_safe_receiver.connect(ctx.destination);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function AudioBufferSound$play$lambda($channel) {
  return function (it) {
    var tmp6_safe_receiver = $channel;
    if (tmp6_safe_receiver == null)
      null;
    else {
      tmp6_safe_receiver.i85();
    }
    return Unit_instance;
  };
}
function nativeSoundProvider$delegate$lambda() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  var tmp;
  if (Companion_getInstance_1().ax()) {
    tmp = new HtmlNativeSoundProvider();
  } else {
    tmp = Companion_getInstance_17();
  }
  return tmp;
}
function nativeSoundProvider$factory() {
  return getPropertyCallableRef('nativeSoundProvider', 0, KProperty0, function () {
    return get_nativeSoundProvider();
  }, null);
}
var properties_initialized_HtmlNativeSoundProvider_kt_uyp32m;
function _init_properties_HtmlNativeSoundProvider_kt__ocy1lg() {
  if (!properties_initialized_HtmlNativeSoundProvider_kt_uyp32m) {
    properties_initialized_HtmlNativeSoundProvider_kt_uyp32m = true;
    nativeSoundProvider$delegate = lazy(nativeSoundProvider$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  try {
    $l$loop: while (_PlaybackTimes___get_hasMore__impl__ei8boc($this.h86_1.b85_1)) {
      $this.h86_1.a85_1 = Companion_getInstance_0().h1w();
      $this.h86_1.j86($this.i86_1._v.hk_1);
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
      $this.i86_1._v = new Duration(tmp$ret$1);
      var deferred = CompletableDeferred();
      var tmp;
      if ($this.h86_1.y84_1 == null) {
        tmp = true;
      } else {
        var tmp29_safe_receiver = $this.h86_1.t84_1;
        tmp = !((tmp29_safe_receiver == null ? null : tmp29_safe_receiver.state) === 'running');
      }
      if (tmp) {
        var tmp_0 = window;
        var tmp_1 = HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda$lambda(deferred);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = $this.h86_1.s84_1;
        var tmp0_elvis_lhs = get_durationOrNull(tmp$ret$3);
        tmp_0.setTimeout(tmp_1, numberToInt((tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) * 1000));
      } else {
        var tmp30_safe_receiver = $this.h86_1.y84_1;
        if (tmp30_safe_receiver == null)
          null;
        else {
          tmp30_safe_receiver.onended = HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda$lambda_0(deferred);
        }
      }
      var tmp_2 = deferred.v17($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      $this.h86_1.b85_1 = _PlaybackTimes___get_oneLess__impl__ea0jl8($this.h86_1.b85_1);
      if (!_PlaybackTimes___get_hasMore__impl__ei8boc($this.h86_1.b85_1))
        break $l$loop;
    }
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      var tmp31_safe_receiver = $this.h86_1.u84_1.m80_1;
      if (tmp31_safe_receiver == null)
        null;
      else
        tmp31_safe_receiver();
    } else {
      throw $p;
    }
  }
  finally {
    $this.h86_1.f85_1 = false;
    var realHtmlAudioElement = $this.h86_1.z84_1;
    if (!(realHtmlAudioElement == null)) {
      realHtmlAudioElement.pause();
      realHtmlAudioElement.currentTime = 0.0;
    } else {
      var tmp32_safe_receiver = $this.h86_1.y84_1;
      if (tmp32_safe_receiver == null)
        null;
      else {
        tmp32_safe_receiver.stop();
      }
    }
    $this.h86_1.w84_1 = null;
    $this.h86_1.x84_1 = null;
    $this.h86_1.y84_1 = null;
    var tmp33_safe_receiver = $this.h86_1.u84_1.n80_1;
    if (tmp33_safe_receiver == null)
      null;
    else
      tmp33_safe_receiver();
  }
  return Unit_instance;
}
function HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda$lambda($deferred) {
  return function () {
    return $deferred.m1b(Unit_instance);
  };
}
function HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda$lambda_0($deferred) {
  return function () {
    $deferred.m1b(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$SimpleSoundChannel$createNode$lambda$lambda($htmlAudioElement, this$0, $audioBuffer) {
  return function ($this$gain) {
    var tmp;
    if (!($htmlAudioElement == null)) {
      this$0.z84_1 = clone($htmlAudioElement);
      this$0.y84_1 = HtmlSimpleSound_getInstance().l86($this$gain, ensureNotNull(this$0.z84_1));
      tmp = Unit_instance;
    } else if (!($audioBuffer == null)) {
      this$0.y84_1 = HtmlSimpleSound_getInstance().k86($this$gain, $audioBuffer);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function HtmlSimpleSound$SimpleSoundChannel$createNode$lambda(this$0, $htmlAudioElement, $audioBuffer) {
  return function ($this$panner) {
    var tmp = this$0;
    var tmp_0 = HtmlSimpleSound_getInstance();
    tmp.w84_1 = tmp_0.m86($this$panner, HtmlSimpleSound$SimpleSoundChannel$createNode$lambda$lambda($htmlAudioElement, this$0, $audioBuffer));
    return Unit_instance;
  };
}
function HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda_0(this$0, $startTime) {
  var i = new HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda(this$0, $startTime);
  var l = function ($this$launch, $completion) {
    return i.o1s($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_loadSound__rbkbnv($this, data, url, $completion) {
  if ($this.m83_1 == null)
    return null;
  // Inline function 'kotlin.coroutines.suspendCoroutine' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlin.coroutines.suspendCoroutine.<anonymous>' call
  var safe = SafeContinuation.zd(intercepted($completion));
  // Inline function 'korlibs.audio.sound.HtmlSimpleSound.loadSound.<anonymous>' call
  var tmp = HtmlSimpleSound_getInstance().m83_1;
  var tmp_0 = HtmlSimpleSound$loadSound$lambda(safe);
  tmp.decodeAudioData(data, tmp_0, HtmlSimpleSound$loadSound$lambda_0(safe, url));
  var tmp$ret$0 = safe.ae();
  var tmp_1 = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function HtmlSimpleSound$source$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HtmlSimpleSound$source$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
function HtmlSimpleSound$callOnUnlocked$lambda($cancelled, $callback) {
  return function (it) {
    if (!$cancelled._v)
      $callback(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$callOnUnlocked$lambda_0($cancelled) {
  return function (it) {
    $cancelled._v = true;
    return Unit_instance;
  };
}
function HtmlSimpleSound$loadSound$lambda($c) {
  return function (data) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(data);
    this_0.id(tmp$ret$0);
    return Unit_instance;
  };
}
function HtmlSimpleSound$loadSound$lambda_0($c, $url) {
  return function () {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = Exception.f6('error decoding ' + $url);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.id(tmp$ret$0);
    return Unit_instance;
  };
}
function HtmlSimpleSound$lambda$lambda($source) {
  return function () {
    $source.disconnect(0);
    HtmlSimpleSound_getInstance().n83_1 = true;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = HtmlSimpleSound_getInstance().l83_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'Web Audio was successfully unlocked';
      this_0.v3g(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    HtmlSimpleSound_getInstance().o83_1.m1b(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$lambda($unlock, this$0, $_scratchBuffer) {
  return function (it) {
    var tmp = document;
    var tmp_0;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_0 = $unlock._v;
    }
    tmp.removeEventListener('keydown', tmp_0, true);
    var tmp_1 = document;
    var tmp_2;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_2 = $unlock._v;
    }
    tmp_1.removeEventListener('touchstart', tmp_2, true);
    var tmp_3 = document;
    var tmp_4;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_4 = $unlock._v;
    }
    tmp_3.removeEventListener('touchend', tmp_4, true);
    var tmp_5 = document;
    var tmp_6;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_6 = $unlock._v;
    }
    tmp_5.removeEventListener('mousedown', tmp_6, true);
    var tmp_7;
    if (!(this$0.m83_1 == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp48_safe_receiver = window.globalAudioContext;
      if (tmp48_safe_receiver == null)
        null;
      else {
        tmp48_safe_receiver.resume();
      }
      var source = this$0.m83_1.createBufferSource();
      source.buffer = $_scratchBuffer;
      source.connect(this$0.m83_1.destination);
      source.start(0.0);
      // Inline function 'kotlin.js.asDynamic' call
      if (typeof this$0.m83_1.resume === 'function') {
        // Inline function 'kotlin.js.asDynamic' call
        this$0.m83_1.resume();
      }
      source.onended = HtmlSimpleSound$lambda$lambda(source);
      tmp_7 = Unit_instance;
    }
    return Unit_instance;
  };
}
var HtmlSimpleSound_instance;
function HtmlSimpleSound_getInstance() {
  if (HtmlSimpleSound_instance === VOID)
    new HtmlSimpleSound();
  return HtmlSimpleSound_instance;
}
function clone(_this__u8e3s4) {
  return createAudioElement(_this__u8e3s4.src, _this__u8e3s4.currentTime, _this__u8e3s4.autoplay, _this__u8e3s4.crossOrigin);
}
function get_durationOrNull(_this__u8e3s4) {
  // Inline function 'kotlin.takeIf' call
  var this_0 = _this__u8e3s4.duration;
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'korlibs.audio.sound.<get-durationOrNull>.<anonymous>' call
  if (!isNaN_0(this_0)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
function createAudioElement(src, currentTime, autoplay, crossOrigin) {
  currentTime = currentTime === VOID ? 0.0 : currentTime;
  autoplay = autoplay === VOID ? false : autoplay;
  crossOrigin = crossOrigin === VOID ? 'anonymous' : crossOrigin;
  var out = new Audio(src);
  out.crossOrigin = crossOrigin;
  out.currentTime = currentTime;
  out.autoplay = autoplay;
  out.pause();
  return out;
}
function get_durationOrNull_0(_this__u8e3s4) {
  // Inline function 'kotlin.takeIf' call
  var this_0 = _this__u8e3s4.duration;
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'korlibs.audio.sound.<get-durationOrNull>.<anonymous>' call
  if (!isNaN_0(this_0)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioFormat, 'AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(AudioFormats, 'AudioFormats', AudioFormats, VOID, VOID, [2, 4]);
initMetadataForClass(Info, 'Info', Info);
initMetadataForLambda(AudioFormat$decodeStream$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(AudioDecodingProps, 'AudioDecodingProps', AudioDecodingProps);
initMetadataForCompanion(Companion_1);
initMetadataForClass(AudioEncodingProps, 'AudioEncodingProps', AudioEncodingProps);
initMetadataForClass(InvalidAudioFormatException, 'InvalidAudioFormatException');
initMetadataForClass(MP3Base, 'MP3Base', MP3Base, VOID, VOID, [2, 4]);
initMetadataForClass(MP3, 'MP3', MP3, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_2, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_3);
initMetadataForClass(ChannelMode, 'ChannelMode');
initMetadataForClass(Mp3Info, 'Mp3Info');
initMetadataForCompanion(Companion_4, VOID, VOID, [1]);
initMetadataForClass(SeekingTable, 'SeekingTable');
initMetadataForClass(Parser, 'Parser', VOID, VOID, VOID, [0, 1, 2, 3]);
initMetadataForClass(MP3Decoder, 'MP3Decoder', MP3Decoder, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_5, VOID, VOID, [2, 4]);
initMetadataForClass(MiniMp3Program, 'MiniMp3Program', MiniMp3Program);
initMetadataForClass(Minimp3Decoder, 'Minimp3Decoder', Minimp3Decoder, VOID, [MiniMp3Program, AutoCloseable]);
initMetadataForClass(BaseMinimp3AudioFormat, 'BaseMinimp3AudioFormat', VOID, VOID, VOID, [2, 3, 4]);
initMetadataForObject(Minimp3AudioFormat, 'Minimp3AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(BaseMp3DecoderInfo, 'BaseMp3DecoderInfo', BaseMp3DecoderInfo);
initMetadataForCompanion(Companion_6);
initMetadataForClass(AudioStream, 'AudioStream', VOID, VOID, [AutoCloseable], [3, 0]);
initMetadataForClass(BaseMinimp3AudioFormat$createDecoderStream$2, VOID, VOID, VOID, VOID, [3, 0]);
initMetadataForCompanion(Companion_7);
initMetadataForClass(L12_subband_alloc_tStruct, 'L12_subband_alloc_tStruct');
initMetadataForClass(Mp3Dec, 'Mp3Dec', Mp3Dec.l7m);
initMetadataForClass(Bs, 'Bs', Bs);
initMetadataForClass(Mp3Scratch, 'Mp3Scratch', Mp3Scratch.p7s);
initMetadataForClass(Mp3FrameInfo, 'Mp3FrameInfo', Mp3FrameInfo);
initMetadataForClass(ArrayPtr, 'ArrayPtr');
initMetadataForClass(UByteArrayIntPtr, 'UByteArrayIntPtr');
initMetadataForClass(FloatArrayPtr, 'FloatArrayPtr');
initMetadataForClass(ShortArrayPtr, 'ShortArrayPtr');
initMetadataForClass(GrInfo, 'GrInfo', GrInfo);
initMetadataForClass(ScaleInfo, 'ScaleInfo', ScaleInfo);
initMetadataForClass(WAV, 'WAV', WAV, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_8, VOID, VOID, [2, 4]);
initMetadataForClass(Chunk, 'Chunk');
initMetadataForClass(ProcessedChunk, 'ProcessedChunk');
initMetadataForClass(WavAudioStream, 'WavAudioStream', VOID, VOID, VOID, [3, 0]);
initMetadataForClass(Fmt, 'Fmt', Fmt);
initMetadataForLambda(WAV$parse$slambda, VOID, VOID, [1]);
initMetadataForObject(SampleConvert, 'SampleConvert');
initMetadataForCompanion(Companion_9);
initMetadataForClass(AudioData, 'AudioData');
initMetadataForClass(AudioSamples, 'AudioSamples');
initMetadataForClass(AudioSamplesInterleaved, 'AudioSamplesInterleaved');
initMetadataForClass(AudioSamplesDeque, 'AudioSamplesDeque');
initMetadataForCompanion(Companion_10);
initMetadataForClass(NewPlatformAudioOutput, 'NewPlatformAudioOutput', VOID, VOID, [AutoCloseable]);
initMetadataForClass(PlatformAudioOutput, 'PlatformAudioOutput', VOID, VOID, [AutoCloseable], [3, 1, 0]);
initMetadataForClass(DequeBasedPlatformAudioOutput, 'DequeBasedPlatformAudioOutput', VOID, VOID, VOID, [3, 1, 0]);
initMetadataForClass(PlatformAudioOutputBasedOnNew, 'PlatformAudioOutputBasedOnNew', VOID, VOID, VOID, [3, 1, 0]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(NativeSoundProvider, 'NativeSoundProvider', NativeSoundProvider, VOID, [AutoCloseable], [1, 3, 4, 2]);
initMetadataForClass(NativeSoundProviderNew, 'NativeSoundProviderNew', NativeSoundProviderNew, VOID, VOID, [1, 3, 4, 2]);
initMetadataForClass(DummyNativeSoundProvider, 'DummyNativeSoundProvider', DummyNativeSoundProvider, VOID, VOID, [1, 3, 4, 2]);
initMetadataForCompanion(Companion_12, VOID, VOID, [1, 3, 4, 2]);
initMetadataForInterface(SoundPlay, 'SoundPlay', VOID, VOID, VOID, [1, 2, 3]);
protoOf(Sound).v7z = play;
protoOf(Sound).w7z = play$default;
initMetadataForClass(Sound, 'Sound', VOID, VOID, [SoundPlay], [1, 0, 2, 3]);
initMetadataForClass(SoundChannel, 'SoundChannel');
initMetadataForCompanion(Companion_13);
initMetadataForClass(PlaybackParameters, 'PlaybackParameters', PlaybackParameters);
initMetadataForCompanion(Companion_14);
initMetadataForClass(PlaybackTimes, 'PlaybackTimes');
initMetadataForClass(SoundAudioData$play$2);
initMetadataForClass(SoundAudioData, 'SoundAudioData', VOID, VOID, VOID, [1, 2, 0, 3]);
initMetadataForLambda(SoundAudioStream$play$slambda$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_15);
initMetadataForLambda(SoundAudioStream$play$slambda, VOID, VOID, [1]);
initMetadataForClass(SoundAudioStream$play$1);
initMetadataForClass(SoundAudioStream, 'SoundAudioStream', VOID, VOID, VOID, [1, 0, 2, 3]);
initMetadataForClass(HtmlNativeSoundProvider, 'HtmlNativeSoundProvider', HtmlNativeSoundProvider, VOID, VOID, [4, 1, 3, 2]);
initMetadataForClass(JsNewPlatformAudioOutput, 'JsNewPlatformAudioOutput');
initMetadataForClass(AudioBufferSound$play$2);
initMetadataForClass(AudioBufferSound, 'AudioBufferSound', VOID, VOID, VOID, [1, 2, 0, 3]);
initMetadataForLambda(HtmlSimpleSound$SimpleSoundChannel$createJobAt$slambda, VOID, VOID, [1]);
initMetadataForClass(SimpleSoundChannel, 'SimpleSoundChannel');
initMetadataForClass(sam$korlibs_io_lang_Cancellable$0, 'sam$korlibs_io_lang_Cancellable$0');
initMetadataForObject(HtmlSimpleSound, 'HtmlSimpleSound', VOID, VOID, VOID, [0, 2, 1]);
initMetadataForClass(AudioBufferOrHTMLMediaElement, 'AudioBufferOrHTMLMediaElement');
//endregion
//region block: init
Companion_instance_0 = new Companion();
SampleConvert_instance = new SampleConvert();
DEFAULT_MAX_SAMPLES = 39690000;
Companion_instance_11 = new Companion_10();
Companion_instance_12 = new Companion_11();
//endregion
//region block: exports
export {
  Companion_getInstance_14 as Companion_getInstance3vx36q4sbftih,
  get_nativeSoundProvider as get_nativeSoundProvider1b6rsunmfcp5k,
};
//endregion
